(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 5602:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = _defineProperty;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/***/ }),

/***/ 5839:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(9185);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 9800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jc": function() { return /* reexport */ appWithTranslation; },
  "$G": function() { return /* reexport */ useTranslation; }
});

// UNUSED EXPORTS: I18nContext, Trans, Translation, i18n, withTranslation

;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/typeof.js
function typeof_typeof(o) {
  "@babel/helpers - typeof";

  return typeof_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, typeof_typeof(o);
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function _toPrimitive(input, hint) {
  if (typeof_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof_typeof(key) === "symbol" ? key : String(key);
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/createClass.js

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
;// CONCATENATED MODULE: ../node_modules/react-i18next/dist/es/unescape.js
var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};

var unescapeHtmlEntity = function unescapeHtmlEntity(m) {
  return htmlEntities[m];
};

var unescape_unescape = function unescape(text) {
  return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};
;// CONCATENATED MODULE: ../node_modules/react-i18next/dist/es/context.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape_unescape
};
var i18nInstance;
var I18nContext = (0,react.createContext)();
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
}
function getDefaults() {
  return defaultOptions;
}
var ReportNamespaces = function () {
  function ReportNamespaces() {
    _classCallCheck(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  _createClass(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
}();
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
function composeInitialProps(ForComponent) {
  return function (ctx) {
    return new Promise(function (resolve) {
      var i18nInitialProps = getInitialProps();

      if (ForComponent.getInitialProps) {
        ForComponent.getInitialProps(ctx).then(function (componentsInitialProps) {
          resolve(_objectSpread(_objectSpread({}, componentsInitialProps), i18nInitialProps));
        });
      } else {
        resolve(i18nInitialProps);
      }
    });
  };
}
function getInitialProps() {
  var i18n = getI18n();
  var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
  var ret = {};
  var initialI18nStore = {};
  i18n.languages.forEach(function (l) {
    initialI18nStore[l] = {};
    namespaces.forEach(function (ns) {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
}
;// CONCATENATED MODULE: ../node_modules/react-i18next/dist/es/utils.js
function warn() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  });
}

function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };

  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}

function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;

  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }

  return i18n.hasLoadedNamespace(ns, {
    precheck: function precheck(i18nInstance, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}
;// CONCATENATED MODULE: ../node_modules/react-i18next/dist/es/useTranslation.js



function useTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function useTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { useTranslation_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { useTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var usePrevious = function usePrevious(value, ignore) {
  var ref = (0,react.useRef)();
  (0,react.useEffect)(function () {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};

function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;

  var _ref = (0,react.useContext)(I18nContext) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();

  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k) {
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  if (i18n.options.react && i18n.options.react.wait !== undefined) warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');

  var i18nOptions = useTranslation_objectSpread(useTranslation_objectSpread(useTranslation_objectSpread({}, getDefaults()), i18n.options.react), props);

  var useSuspense = i18nOptions.useSuspense,
      keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return hasLoadedNamespace(n, i18n, i18nOptions);
  });

  function getT() {
    return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }

  var _useState = (0,react.useState)(getT),
      _useState2 = _slicedToArray(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];

  var joinedNS = namespaces.join();
  var previousJoinedNS = usePrevious(joinedNS);
  var isMounted = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;

    if (!ready && !useSuspense) {
      loadNamespaces(i18n, namespaces, function () {
        if (isMounted.current) setT(getT);
      });
    }

    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }

    function boundReset() {
      if (isMounted.current) setT(getT);
    }

    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, joinedNS]);
  var isInitial = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }

    isInitial.current = false;
  }, [i18n, keyPrefix]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    loadNamespaces(i18n, namespaces, function () {
      resolve();
    });
  });
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
// EXTERNAL MODULE: ../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(5839);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ../node_modules/react-i18next/dist/es/I18nextProvider.js


function I18nextProvider(_ref) {
  var i18n = _ref.i18n,
      defaultNS = _ref.defaultNS,
      children = _ref.children;
  var value = (0,react.useMemo)(function () {
    return {
      i18n: i18n,
      defaultNS: defaultNS
    };
  }, [i18n, defaultNS]);
  return (0,react.createElement)(I18nContext.Provider, {
    value: value
  }, children);
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function toConsumableArray_toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
;// CONCATENATED MODULE: ../node_modules/next-i18next/dist/esm/config/defaultConfig.js
var DEFAULT_LOCALE = 'en';
var LOCALES = ['en'];
var DEFAULT_NAMESPACE = 'common';
var LOCALE_PATH = './public/locales';
var LOCALE_STRUCTURE = '{{lng}}/{{ns}}';
var LOCALE_EXTENSION = 'json';
var defaultConfig = {
  defaultNS: DEFAULT_NAMESPACE,
  errorStackTraceLimit: 0,
  i18n: {
    defaultLocale: DEFAULT_LOCALE,
    locales: LOCALES
  },

  get initImmediate() {
    return  true && typeof window !== 'undefined';
  },

  interpolation: {
    escapeValue: false
  },
  load: 'currentOnly',
  localeExtension: LOCALE_EXTENSION,
  localePath: LOCALE_PATH,
  localeStructure: LOCALE_STRUCTURE,
  react: {
    useSuspense: false
  },
  reloadOnPrerender: false,
  serializeConfig: true,
  use: []
};
;// CONCATENATED MODULE: ../node_modules/next-i18next/dist/esm/utils.js


var getFallbackForLng = function getFallbackForLng(lng, fallbackLng) {
  if (typeof fallbackLng === 'string') {
    return [fallbackLng];
  }

  if (Array.isArray(fallbackLng)) {
    return fallbackLng;
  }

  if (_typeof(fallbackLng) === 'object') {
    var fallbackList = fallbackLng[lng];
    var fallbackDefault = fallbackLng["default"];
    return [].concat(_toConsumableArray(fallbackList !== null && fallbackList !== void 0 ? fallbackList : []), _toConsumableArray(fallbackDefault !== null && fallbackDefault !== void 0 ? fallbackDefault : []));
  }

  if (typeof fallbackLng === 'function') {
    return getFallbackForLng(lng, fallbackLng(lng));
  }

  return [];
};
var unique = function unique(list) {
  return Array.from(new Set(list));
};
;// CONCATENATED MODULE: ../node_modules/next-i18next/dist/esm/config/createConfig.js





var _excluded = ["i18n"],
    _excluded2 = ["i18n"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = createConfig_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function createConfig_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return createConfig_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return createConfig_arrayLikeToArray(o, minLen); }

function createConfig_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function createConfig_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function createConfig_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? createConfig_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : createConfig_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var deepMergeObjects = ['backend', 'detection'];
var createConfig = function createConfig(userConfig) {
  var _userConfig$use;

  if (typeof (userConfig === null || userConfig === void 0 ? void 0 : userConfig.lng) !== 'string') {
    throw new Error('config.lng was not passed into createConfig');
  } //
  // Initial merge of default and user-provided config
  //


  var userI18n = userConfig.i18n,
      userConfigStripped = _objectWithoutProperties(userConfig, _excluded);

  var defaultI18n = defaultConfig.i18n,
      defaultConfigStripped = _objectWithoutProperties(defaultConfig, _excluded2);

  var combinedConfig = createConfig_objectSpread(createConfig_objectSpread(createConfig_objectSpread(createConfig_objectSpread({}, defaultConfigStripped), userConfigStripped), defaultI18n), userI18n);

  var defaultNS = combinedConfig.defaultNS,
      lng = combinedConfig.lng,
      localeExtension = combinedConfig.localeExtension,
      localePath = combinedConfig.localePath,
      localeStructure = combinedConfig.localeStructure,
      nonExplicitSupportedLngs = combinedConfig.nonExplicitSupportedLngs;
  var locales = combinedConfig.locales.filter(function (l) {
    return l !== 'default';
  });
  /**
   * Skips translation file resolution while in cimode
   * https://github.com/i18next/next-i18next/pull/851#discussion_r503113620
  */

  if (lng === 'cimode') {
    return combinedConfig;
  }

  if (typeof combinedConfig.fallbackLng === 'undefined') {
    combinedConfig.fallbackLng = combinedConfig.defaultLocale;

    if (combinedConfig.fallbackLng === 'default') {
      var _locales = _slicedToArray(locales, 1);

      combinedConfig.fallbackLng = _locales[0];
    }
  }

  var fallbackLng = combinedConfig.fallbackLng;

  if (nonExplicitSupportedLngs) {
    var createFallbackObject = function createFallbackObject(acc, l) {
      var _l$split = l.split('-'),
          _l$split2 = _slicedToArray(_l$split, 1),
          locale = _l$split2[0];

      acc[l] = [locale];
      return acc;
    };

    if (typeof fallbackLng === 'string') {
      combinedConfig.fallbackLng = combinedConfig.locales.filter(function (l) {
        return l.includes('-');
      }).reduce(createFallbackObject, {
        "default": [fallbackLng]
      });
    } else if (Array.isArray(fallbackLng)) {
      combinedConfig.fallbackLng = combinedConfig.locales.filter(function (l) {
        return l.includes('-');
      }).reduce(createFallbackObject, {
        "default": fallbackLng
      });
    } else if (typeof_typeof(fallbackLng) === 'object') {
      combinedConfig.fallbackLng = Object.entries(combinedConfig.fallbackLng).reduce(function (acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            l = _ref2[0],
            f = _ref2[1];

        acc[l] = l.includes('-') ? unique([l.split('-')[0]].concat(toConsumableArray_toConsumableArray(f))) : f;
        return acc;
      }, fallbackLng);
    } else if (typeof fallbackLng === 'function') {
      throw new Error('If nonExplicitSupportedLngs is true, no functions are allowed for fallbackLng');
    }
  }

  var hasCustomBackend = userConfig === null || userConfig === void 0 ? void 0 : (_userConfig$use = userConfig.use) === null || _userConfig$use === void 0 ? void 0 : _userConfig$use.some(function (b) {
    return b.type === 'backend';
  });

  if (false) { var getNamespaces, _defaultFallbackNSExists, _fallback, _defaultNSExists, _defaultNSPath, defaultFallbackNSExists, fallback, defaultNSExists, defaultNSPath, defaultFile, defaultLocaleStructure, suffix, prefix, _userConfig$interpola, _userConfig$interpola2, _userConfig$interpola3, _userConfig$interpola4, path, fs; } else {
    //
    // Set client side backend, if there is no custom backend
    //
    if (!hasCustomBackend) {
      if (typeof localePath === 'string') {
        combinedConfig.backend = {
          addPath: "".concat(localePath, "/").concat(localeStructure, ".missing.").concat(localeExtension),
          loadPath: "".concat(localePath, "/").concat(localeStructure, ".").concat(localeExtension)
        };
      } else if (typeof localePath === 'function') {
        combinedConfig.backend = {
          addPath: function addPath(locale, namespace) {
            return localePath(locale, namespace, true);
          },
          loadPath: function loadPath(locale, namespace) {
            return localePath(locale, namespace, false);
          }
        };
      }
    }

    if (typeof combinedConfig.ns !== 'string' && !Array.isArray(combinedConfig.ns)) {
      combinedConfig.ns = [defaultNS];
    }
  } //
  // Deep merge with overwrite - goes last
  //


  deepMergeObjects.forEach(function (obj) {
    if (userConfig[obj]) {
      combinedConfig[obj] = createConfig_objectSpread(createConfig_objectSpread({}, combinedConfig[obj]), userConfig[obj]);
    }
  });
  return combinedConfig;
};
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && (typeof_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/toArray.js




function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}
;// CONCATENATED MODULE: ../node_modules/i18next/dist/esm/i18next.js










function i18next_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function i18next_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { i18next_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { i18next_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Logger);

    this.init(concreteLogger, options);
  }

  _createClass(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, i18next_objectSpread(i18next_objectSpread({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }), this.options));
    }
  }, {
    key: "clone",
    value: function clone(options) {
      options = options || this.options;
      options.prefix = options.prefix || this.prefix;
      return new Logger(this.logger, options);
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.observers = {};
  }

  _createClass(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();

    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);

  if (value !== undefined) {
    return value;
  }

  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }

  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function i18next_escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && typeof window.navigator.userAgentData === 'undefined' && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var chars = [' ', ',', '?', '!', ';'];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  var possibleChars = chars.filter(function (c) {
    return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
  });
  if (possibleChars.length === 0) return true;
  var r = new RegExp("(".concat(possibleChars.map(function (c) {
    return c === '?' ? '\\?' : c;
  }).join('|'), ")"));
  var matched = !r.test(key);

  if (!matched) {
    var ki = key.indexOf(keySeparator);

    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }

  return matched;
}

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function deepFind(obj, path) {
  var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  var paths = path.split(keySeparator);
  var current = obj;

  for (var i = 0; i < paths.length; ++i) {
    if (!current) return undefined;

    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }

    if (current[paths[i]] === undefined) {
      var j = 2;
      var p = paths.slice(i, i + j).join(keySeparator);
      var mix = current[p];

      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }

      if (mix === undefined) return undefined;
      if (mix === null) return null;

      if (path.endsWith(p)) {
        if (typeof mix === 'string') return mix;
        if (p && typeof mix[p] === 'string') return mix[p];
      }

      var joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }

    current = current[paths[i]];
  }

  return current;
}

var ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);

  var _super = _createSuper(ResourceStore);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    _classCallCheck(this, ResourceStore);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    if (_this.options.ignoreJSONStructure === undefined) {
      _this.options.ignoreJSONStructure = true;
    }

    return _this;
  }

  _createClass(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      var result = getPath(this.data, path);
      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread$1(_objectSpread$1({}, pack), resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread$1(_objectSpread$1({}, {}), this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function hasLanguageSomeTranslations(lng) {
      var data = this.getDataByLanguage(lng);
      var n = data && Object.keys(data) || [];
      return !!n.find(function (v) {
        return data[v] && Object.keys(data[v]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var checkedLoadedFor = {};

var Translator = function (_EventEmitter) {
  _inherits(Translator, _EventEmitter);

  var _super = _createSuper$1(Translator);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Translator);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, _assertThisInitialized(_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  _createClass(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };

      if (key === undefined || key === null) {
        return false;
      }

      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS || [];
      var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
      var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);

      if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
        var m = key.match(this.interpolator.nestingRegexp);

        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }

        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;

      if (typeof_typeof(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;

          if (returnDetails) {
            resolved.res = "".concat(namespace).concat(nsSeparator).concat(key);
            return resolved;
          }

          return "".concat(namespace).concat(nsSeparator).concat(key);
        }

        if (returnDetails) {
          resolved.res = key;
          return resolved;
        }

        return key;
      }

      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          }

          var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$2(_objectSpread$2({}, options), {}, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");

          if (returnDetails) {
            resolved.res = r;
            return resolved;
          }

          return r;
        }

        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread$2(_objectSpread$2({}, options), {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }

          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;

        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }

        var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
        var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);

          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$2(_objectSpread$2({}, options), {}, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }

          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k, specificDefaultValue) {
            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;

            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language, options).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }

        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);

        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
          if (this.options.compatibilityAPI !== 'v1') {
            res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
          } else {
            res = this.options.parseMissingKeyHandler(res);
          }
        }
      }

      if (returnDetails) {
        resolved.res = res;
        return resolved;
      }

      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread$2(_objectSpread$2({}, options), {
          interpolation: _objectSpread$2(_objectSpread$2({}, this.options.interpolation), options.interpolation)
        }));
        var skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
        var nestBef;

        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));

            return null;
          }

          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }

      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$2({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';

        var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();

        var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKeys = [key];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
              var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");

              if (needsPluralHandling) {
                finalKeys.push(key + pluralSuffix);

                if (needsZeroSuffixLookup) {
                  finalKeys.push(key + zeroSuffix);
                }
              }

              if (needsContextHandling) {
                var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                finalKeys.push(contextKey);

                if (needsPluralHandling) {
                  finalKeys.push(contextKey + pluralSuffix);

                  if (needsZeroSuffixLookup) {
                    finalKeys.push(contextKey + zeroSuffix);
                  }
                }
              }
            }

            var possibleKey;

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';

      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }

      return false;
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck(this, LanguageUtil);

    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }

  _createClass(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;

      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;

        var cleanedLng = _this.formatLanguageCode(code);

        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });

      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;

          var lngOnly = _this.getLanguagePartFromCode(code);

          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }

      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
var deprecatedJsonVersions = ['v1', 'v2', 'v3'];
var suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');

    if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === 'v4') && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
      this.options.compatibilityJSON = 'v3';
      this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
    }

    this.rules = createRules();
  }

  _createClass(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.shouldUseIntlApi()) {
        try {
          return new Intl.PluralRules(code, {
            type: options.ordinal ? 'ordinal' : 'cardinal'
          });
        } catch (_unused) {
          return;
        }
      }

      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);

      if (this.shouldUseIntlApi()) {
        return rule && rule.resolvedOptions().pluralCategories.length > 1;
      }

      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.getSuffixes(code, options).map(function (suffix) {
        return "".concat(key).concat(suffix);
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);

      if (!rule) {
        return [];
      }

      if (this.shouldUseIntlApi()) {
        return rule.resolvedOptions().pluralCategories.sort(function (pluralCategory1, pluralCategory2) {
          return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
        }).map(function (pluralCategory) {
          return "".concat(_this.options.prepend).concat(pluralCategory);
        });
      }

      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number, options);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var rule = this.getRule(code, options);

      if (rule) {
        if (this.shouldUseIntlApi()) {
          return "".concat(this.options.prepend).concat(rule.select(count));
        }

        return this.getSuffixRetroCompatible(rule, count);
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function getSuffixRetroCompatible(rule, count) {
      var _this2 = this;

      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];

      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }

      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };

      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
        return returnSuffix();
      } else if (this.options.compatibilityJSON === 'v2') {
        return returnSuffix();
      } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }

      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function shouldUseIntlApi() {
      return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
    }
  }]);

  return PluralResolver;
}();

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }

  _createClass(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : i18next_escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
            interpolationkey: key
          })) : path;
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
          interpolationkey: k
        }));
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;

        while (match = todo.regex.exec(str)) {
          var matchedVar = match[1].trim();
          value = handleFormat(matchedVar);

          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (options && options.hasOwnProperty(matchedVar)) {
              value = '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));

              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }

          var safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);

          if (skipOnVariables) {
            todo.regex.lastIndex += value.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }

          replaces++;

          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = _objectSpread$3({}, options);

      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;

      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        var matchedSingleQuotes = optionsString.match(/'/g);
        var matchedDoubleQuotes = optionsString.match(/"/g);

        if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
          optionsString = optionsString.replace(/'/g, '"');
        }

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }

        delete clonedOptions.defaultValue;
        return key;
      }

      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;

        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }

        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }

        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
              interpolationkey: match[1].trim()
            }));
          }, value.trim());
        }

        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function parseFormatStr(formatStr) {
  var formatName = formatStr.toLowerCase().trim();
  var formatOptions = {};

  if (formatStr.indexOf('(') > -1) {
    var p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    var optStr = p[1].substring(0, p[1].length - 1);

    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      var opts = optStr.split(';');
      opts.forEach(function (opt) {
        if (!opt) return;

        var _opt$split = opt.split(':'),
            _opt$split2 = _toArray(_opt$split),
            key = _opt$split2[0],
            rest = _opt$split2.slice(1);

        var val = rest.join(':').trim().replace(/^'+|'+$/g, '');
        if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
        if (val === 'false') formatOptions[key.trim()] = false;
        if (val === 'true') formatOptions[key.trim()] = true;
        if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
      });
    }
  }

  return {
    formatName: formatName,
    formatOptions: formatOptions
  };
}

function createCachedFormatter(fn) {
  var cache = {};
  return function invokeFormatter(val, lng, options) {
    var key = lng + JSON.stringify(options);
    var formatter = cache[key];

    if (!formatter) {
      formatter = fn(lng, options);
      cache[key] = formatter;
    }

    return formatter(val);
  };
}

var Formatter = function () {
  function Formatter() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Formatter);

    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.formats = {
      number: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.NumberFormat(lng, options);
        return function (val) {
          return formatter.format(val);
        };
      }),
      currency: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.NumberFormat(lng, _objectSpread$4(_objectSpread$4({}, options), {}, {
          style: 'currency'
        }));
        return function (val) {
          return formatter.format(val);
        };
      }),
      datetime: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.DateTimeFormat(lng, _objectSpread$4({}, options));
        return function (val) {
          return formatter.format(val);
        };
      }),
      relativetime: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.RelativeTimeFormat(lng, _objectSpread$4({}, options));
        return function (val) {
          return formatter.format(val, options.range || 'day');
        };
      }),
      list: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.ListFormat(lng, _objectSpread$4({}, options));
        return function (val) {
          return formatter.format(val);
        };
      })
    };
    this.init(options);
  }

  _createClass(Formatter, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var iOpts = options.interpolation;
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    }
  }, {
    key: "add",
    value: function add(name, fc) {
      this.formats[name.toLowerCase().trim()] = fc;
    }
  }, {
    key: "addCached",
    value: function addCached(name, fc) {
      this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
    }
  }, {
    key: "format",
    value: function format(value, _format, lng, options) {
      var _this = this;

      var formats = _format.split(this.formatSeparator);

      var result = formats.reduce(function (mem, f) {
        var _parseFormatStr = parseFormatStr(f),
            formatName = _parseFormatStr.formatName,
            formatOptions = _parseFormatStr.formatOptions;

        if (_this.formats[formatName]) {
          var formatted = mem;

          try {
            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
            formatted = _this.formats[formatName](mem, l, _objectSpread$4(_objectSpread$4(_objectSpread$4({}, formatOptions), options), valOptions));
          } catch (error) {
            _this.logger.warn(error);
          }

          return formatted;
        } else {
          _this.logger.warn("there was no format function for ".concat(formatName));
        }

        return mem;
      }, value);
      return result;
    }
  }]);

  return Formatter;
}();

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function removePending(q, name) {
  if (q.pending[name] !== undefined) {
    delete q.pending[name];
    q.pendingCount--;
  }
}

var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  var _super = _createSuper$2(Connector);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Connector);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.waitingReads = [];
    _this.maxParallelReads = options.maxParallelReads || 10;
    _this.readingCalls = 0;
    _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
    _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  _createClass(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      var toLoad = {};
      var pending = {};
      var toLoadLanguages = {};
      var toLoadNamespaces = {};
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending[name] === undefined) pending[name] = true;
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending[name] === undefined) pending[name] = true;
            if (toLoad[name] === undefined) toLoad[name] = true;
            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
          }
        });
        if (!hasAllNamespaces) toLoadLanguages[lng] = true;
      });

      if (Object.keys(toLoad).length || Object.keys(pending).length) {
        this.queue.push({
          pending: pending,
          pendingCount: Object.keys(pending).length,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: Object.keys(toLoad),
        pending: Object.keys(pending),
        toLoadLanguages: Object.keys(toLoadLanguages),
        toLoadNamespaces: Object.keys(toLoadNamespaces)
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }

      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        removePending(q, name);
        if (err) q.errors.push(err);

        if (q.pendingCount === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = {};
            var loadedKeys = q.loaded[l];

            if (loadedKeys.length) {
              loadedKeys.forEach(function (ns) {
                if (loaded[l][ns] === undefined) loaded[l][ns] = true;
              });
            }
          });
          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});

      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng: lng,
          ns: ns,
          fcName: fcName,
          tried: tried,
          wait: wait,
          callback: callback
        });
        return;
      }

      this.readingCalls++;
      return this.backend[fcName](lng, ns, function (err, data) {
        _this3.readingCalls--;

        if (_this3.waitingReads.length > 0) {
          var next = _this3.waitingReads.shift();

          _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
        }

        if (err && data && tried < _this3.maxRetries) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }

      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread$5(_objectSpread$5({}, options), {}, {
          isUpdate: isUpdate
        }));
      }

      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (typeof_typeof(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if (typeof_typeof(args[2]) === 'object' || typeof_typeof(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: true
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }

  return options;
}

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function noop() {}

function bindMemberFunctions(inst) {
  var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(function (mem) {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
}

var I18n = function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);

  var _super = _createSuper$3(I18n);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, I18n);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };
    bindMemberFunctions(_assertThisInitialized(_this));

    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  _createClass(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      if (!options.defaultNS && options.defaultNS !== false && options.ns) {
        if (typeof options.ns === 'string') {
          options.defaultNS = options.ns;
        } else if (options.ns.indexOf('translation') < 0) {
          options.defaultNS = options.ns[0];
        }
      }

      var defOpts = get();
      this.options = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, defOpts), this.options), transformOptions(options));

      if (this.options.compatibilityAPI !== 'v1') {
        this.options.interpolation = _objectSpread$6(_objectSpread$6({}, defOpts.interpolation), this.options.interpolation);
      }

      if (options.keySeparator !== undefined) {
        this.options.userDefinedKeySeparator = options.keySeparator;
      }

      if (options.nsSeparator !== undefined) {
        this.options.userDefinedNsSeparator = options.nsSeparator;
      }

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }

      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var formatter;

        if (this.modules.formatter) {
          formatter = this.modules.formatter;
        } else if (typeof Intl !== 'undefined') {
          formatter = Formatter;
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });

        if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
          s.formatter = createClassOnDemand(formatter);
          s.formatter.init(s, this.options);
          this.options.interpolation.format = s.formatter.format.bind(s.formatter);
        }

        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }

      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;

      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }

      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }

      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;

          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);

          return _this2;
        };
      });
      var deferred = defer();

      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t);
          callback(err, t);
        };

        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));

        _this2.changeLanguage(_this2.options.lng, finish);
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, function (e) {
          if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
          usedCallback(e);
        });
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');

      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === 'formatter') {
        this.modules.formatter = module;
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function setResolvedLanguage(l) {
      if (!l || !this.languages) return;
      if (['cimode', 'dev'].indexOf(l) > -1) return;

      for (var li = 0; li < this.languages.length; li++) {
        var lngInLngs = this.languages[li];
        if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;

        if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
          this.resolvedLanguage = lngInLngs;
          break;
        }
      }
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var setLngProps = function setLngProps(l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        _this4.resolvedLanguage = undefined;

        _this4.setResolvedLanguage(l);
      };

      var done = function done(err, l) {
        if (l) {
          setLngProps(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);

        if (l) {
          if (!_this4.language) {
            setLngProps(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns, keyPrefix) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if (typeof_typeof(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread$6({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
        var keySeparator = _this5.options.keySeparator || '.';
        var resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
        return _this5.t(resultKey, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      fixedT.keyPrefix = keyPrefix;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.resolvedLanguage || this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      };

      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }

      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      var mergedOptions = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, this.options), options), {
        isClone: true
      });

      var clone = new I18n(mergedOptions);

      if (options.debug !== undefined || options.prefix !== undefined) {
        clone.logger = clone.logger.clone(options);
      }

      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = _objectSpread$6({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]);

  return I18n;
}(EventEmitter);

_defineProperty(I18n, "createInstance", function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  return new I18n(options, callback);
});

var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;

var createInstance = instance.createInstance;
var init = instance.init;
var loadResources = instance.loadResources;
var reloadResources = instance.reloadResources;
var use = instance.use;
var changeLanguage = instance.changeLanguage;
var getFixedT = instance.getFixedT;
var t = instance.t;
var exists = instance.exists;
var setDefaultNamespace = instance.setDefaultNamespace;
var i18next_hasLoadedNamespace = instance.hasLoadedNamespace;
var i18next_loadNamespaces = instance.loadNamespaces;
var loadLanguages = instance.loadLanguages;

/* harmony default export */ var i18next = (instance);


;// CONCATENATED MODULE: ../node_modules/next-i18next/dist/esm/createClient/browser.js

/* harmony default export */ var browser = (function (config) {
  if (config.ns === undefined) config.ns = [];
  var instance = i18next.createInstance(config);
  var initPromise;

  if (!instance.isInitialized) {
    var _config$use;

    config === null || config === void 0 ? void 0 : (_config$use = config.use) === null || _config$use === void 0 ? void 0 : _config$use.forEach(function (x) {
      return instance.use(x);
    });

    if (typeof config.onPreInitI18next === 'function') {
      config.onPreInitI18next(instance);
    }

    initPromise = instance.init(config);
  } else {
    initPromise = Promise.resolve(i18next.t);
  }

  return {
    i18n: instance,
    initPromise: initPromise
  };
});
;// CONCATENATED MODULE: ../node_modules/next-i18next/dist/esm/appWithTranslation.js


var __jsx = react.createElement;

function appWithTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function appWithTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? appWithTranslation_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : appWithTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var globalI18n = null;
var appWithTranslation = function appWithTranslation(WrappedComponent) {
  var configOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var AppWithTranslation = function AppWithTranslation(props) {
    var _nextI18Next$initialL, _props$router;

    var _ref = props.pageProps,
        _nextI18Next = _ref._nextI18Next;
    var locale = (_nextI18Next$initialL = _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.initialLocale) !== null && _nextI18Next$initialL !== void 0 ? _nextI18Next$initialL : props === null || props === void 0 ? void 0 : (_props$router = props.router) === null || _props$router === void 0 ? void 0 : _props$router.locale;
    var ns = _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.ns; // Memoize the instance and only re-initialize when either:
    // 1. The route changes (non-shallowly)
    // 2. Router locale changes
    // 3. UserConfig override changes

    var i18n = (0,react.useMemo)(function () {
      var _userConfig, _userConfig2, _userConfig2$i18n;

      if (!_nextI18Next && !configOverride) return null;
      var userConfig = configOverride !== null && configOverride !== void 0 ? configOverride : _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.userConfig;

      if (!userConfig && configOverride === null) {
        throw new Error('appWithTranslation was called without a next-i18next config');
      }

      if (configOverride !== null) {
        userConfig = configOverride;
      }

      if (!((_userConfig = userConfig) !== null && _userConfig !== void 0 && _userConfig.i18n)) {
        throw new Error('appWithTranslation was called without config.i18n');
      }

      if (!((_userConfig2 = userConfig) !== null && _userConfig2 !== void 0 && (_userConfig2$i18n = _userConfig2.i18n) !== null && _userConfig2$i18n !== void 0 && _userConfig2$i18n.defaultLocale)) {
        throw new Error('config.i18n does not include a defaultLocale property');
      }

      var _ref2 = _nextI18Next || {},
          initialI18nStore = _ref2.initialI18nStore;

      var resources = configOverride !== null && configOverride !== void 0 && configOverride.resources ? configOverride.resources : initialI18nStore;
      if (!locale) locale = userConfig.i18n.defaultLocale;
      var instance = browser(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, createConfig(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, userConfig), {}, {
        lng: locale
      }))), {}, {
        lng: locale,
        ns: ns,
        resources: resources
      })).i18n;
      globalI18n = instance;
      return instance;
    }, [_nextI18Next, locale, configOverride, ns]);
    return i18n !== null ? __jsx(I18nextProvider, {
      i18n: i18n
    }, __jsx(WrappedComponent, props)) : __jsx(WrappedComponent, _extends({
      key: locale
    }, props));
  };

  return hoist_non_react_statics_cjs_default()(AppWithTranslation, WrappedComponent);
};
;// CONCATENATED MODULE: ../node_modules/next-i18next/dist/esm/index.js



/***/ }),

/***/ 6321:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(1999);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8603:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(5602)/* ["default"] */ .Z);
var _slicedToArray = (__webpack_require__(9854)/* ["default"] */ .Z);
var _toConsumableArray = (__webpack_require__(3957)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _extends = (__webpack_require__(6516)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2619)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(6808)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(518)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(7378));
var _head = _interop_require_default(__webpack_require__(555));
var _imageBlurSvg = __webpack_require__(1721);
var _imageConfig = __webpack_require__(7893);
var _imageConfigContext = __webpack_require__(300);
var _utils = __webpack_require__(4915);
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, fill = _param.fill, style = _param.style, onLoadingComplete = _param.onLoadingComplete, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = _param.blurDataURL, all = _object_without_properties_loose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "className",
        "quality",
        "width",
        "height",
        "fill",
        "style",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL"
    ]);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _extends({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var loader = defaultLoader;
    if ("loader" in rest) {
        if (rest.loader) {
            var customImageLoader = rest.loader;
            var _tmp;
            _tmp = function(obj) {
                var _ = obj.config, opts = _object_without_properties_loose(obj, [
                    "config"
                ]);
                // The config object is internal only so we must
                // not pass it to the user-defined loader()
                return customImageLoader(opts);
            }, loader = _tmp, _tmp;
        }
        // Remove property so it's not spread on <img>
        delete rest.loader;
    }
    var staticSrc = "";
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var blurWidth;
    var blurHeight;
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        if (!staticImageData.height || !staticImageData.width) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurWidth = staticImageData.blurWidth;
        blurHeight = staticImageData.blurHeight;
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!fill) {
            if (!widthInt && !heightInt) {
                widthInt = staticImageData.width;
                heightInt = staticImageData.height;
            } else if (widthInt && !heightInt) {
                var ratio = widthInt / staticImageData.width;
                heightInt = Math.round(staticImageData.height * ratio);
            } else if (!widthInt && heightInt) {
                var ratio1 = heightInt / staticImageData.height;
                widthInt = Math.round(staticImageData.width * ratio1);
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if (config.unoptimized) {
        unoptimized = true;
    }
    var ref = _slicedToArray((0, _react).useState(false), 2), blurComplete = ref[0], setBlurComplete = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(false), 2), showAltText = ref1[0], setShowAltText = ref1[1];
    var qualityInt = getInt(quality);
    if (false) { var url, urlStr, VALID_BLUR_EXT; }
    var imgStyle = Object.assign(fill ? {
        position: "absolute",
        height: "100%",
        width: "100%",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
    } : {}, showAltText ? {} : {
        color: "transparent"
    }, style);
    var blurStyle = placeholder === "blur" && blurDataURL && !blurComplete ? {
        backgroundSize: imgStyle.objectFit || "cover",
        backgroundPosition: imgStyle.objectPosition || "50% 50%",
        backgroundRepeat: "no-repeat",
        backgroundImage: 'url("data:image/svg+xml;charset=utf-8,'.concat((0, _imageBlurSvg).getImageBlurSvg({
            widthInt: widthInt,
            heightInt: heightInt,
            blurWidth: blurWidth,
            blurHeight: blurHeight,
            blurDataURL: blurDataURL
        }), '")')
    } : {};
    if (false) {}
    var imgAttributes = generateImgAttrs({
        config: config,
        src: src,
        unoptimized: unoptimized,
        width: widthInt,
        quality: qualityInt,
        sizes: sizes,
        loader: loader
    });
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = "imagesrcset";
    var imageSizesPropName = "imagesizes";
    if (true) {
        imageSrcSetPropName = "imageSrcSet";
        imageSizesPropName = "imageSizes";
    }
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _defineProperty(_obj, "crossOrigin", rest.crossOrigin), _obj);
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    var imgElementArgs = _extends({
        isLazy: isLazy,
        imgAttributes: imgAttributes,
        heightInt: heightInt,
        widthInt: widthInt,
        qualityInt: qualityInt,
        className: className,
        imgStyle: imgStyle,
        blurStyle: blurStyle,
        loading: loading,
        config: config,
        fill: fill,
        unoptimized: unoptimized,
        placeholder: placeholder,
        loader: loader,
        srcString: srcString,
        onLoadingCompleteRef: onLoadingCompleteRef,
        setBlurComplete: setBlurComplete,
        setShowAltText: setShowAltText
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs)), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
"client";
var configEnv = {"deviceSizes":[600,900,1024,1440],"imageSizes":[600,900,1024,1440],"path":"/_next/image/","loader":"default","dangerouslyAllowSVG":false,"unoptimized":false};
var allImgs = new Map();
var perfObserver;
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    var widths = _toConsumableArray(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref = getWidths(config, width, sizes), widths = ref.widths, kind = ref.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number" || typeof x === "undefined") {
        return x;
    }
    if (typeof x === "string" && /^[0-9]+$/.test(x)) {
        return parseInt(x, 10);
    }
    return NaN;
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, placeholder, onLoadingCompleteRef, setBlurComplete) {
    if (!img || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    var p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(function() {}).then(function() {
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            onLoadingCompleteRef.current(img);
        }
        if (false) { var widthModified, heightModified, valid, position, widthViewportRatio; }
    });
}
var ImageElement = function(_param) {
    var imgAttributes = _param.imgAttributes, heightInt = _param.heightInt, widthInt = _param.widthInt, qualityInt = _param.qualityInt, className = _param.className, imgStyle = _param.imgStyle, blurStyle = _param.blurStyle, isLazy = _param.isLazy, fill = _param.fill, placeholder = _param.placeholder, loading = _param.loading, srcString = _param.srcString, config = _param.config, unoptimized = _param.unoptimized, loader = _param.loader, onLoadingCompleteRef = _param.onLoadingCompleteRef, setBlurComplete = _param.setBlurComplete, setShowAltText = _param.setShowAltText, onLoad = _param.onLoad, onError = _param.onError, rest = _object_without_properties_loose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "fill",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setShowAltText",
        "onLoad",
        "onError"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        width: widthInt,
        height: heightInt,
        decoding: "async",
        "data-nimg": "future".concat(fill ? "-fill" : ""),
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback(function(img) {
            if (!img) {
                return;
            }
            if (onError) {
                // If the image has an error before react hydrates, then the error is lost.
                // The workaround is to wait until the image is mounted which is after hydration,
                // then we set the src again to trigger the error handler (if there was an error).
                // eslint-disable-next-line no-self-assign
                img.src = img.src;
            }
            if (false) {}
            if (img.complete) {
                handleLoading(img, srcString, placeholder, onLoadingCompleteRef, setBlurComplete);
            }
        }, [
            srcString,
            placeholder,
            onLoadingCompleteRef,
            setBlurComplete,
            onError, 
        ]),
        onLoad: function(event) {
            var img = event.currentTarget;
            handleLoading(img, srcString, placeholder, onLoadingCompleteRef, setBlurComplete);
            if (onLoad) {
                onLoad(event);
            }
        },
        onError: function(event) {
            // if the real image fails to load, this will ensure "alt" is visible
            setShowAltText(true);
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })));
};
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var hasMatch, parsedSrc, missingValues; }
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat(config.path, "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 1528:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath =  false || "";
function getDomainLocale(path, locale, locales, domainLocales) {
    if (true) {
        var normalizeLocalePath = (__webpack_require__(7964).normalizeLocalePath);
        var detectDomainLocale = (__webpack_require__(2019).detectDomainLocale);
        var target = locale || normalizeLocalePath(path, locales).detectedLocale;
        var domain = detectDomainLocale(domainLocales, undefined, target);
        if (domain) {
            var proto = "http".concat(domain.http ? "" : "s", "://");
            var finalLocale = target === domain.defaultLocale ? "" : "/".concat(target);
            return "".concat(proto).concat(domain.domain).concat(basePath).concat(finalLocale).concat(path);
        }
        return false;
    } else {}
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 1453:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(9854)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(2271)["default"]);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(2619)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(518)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7378));
var _router = __webpack_require__(194);
var _addLocale = __webpack_require__(4087);
var _routerContext = __webpack_require__(9756);
var _appRouterContext = __webpack_require__(7868);
var _useIntersection = __webpack_require__(1842);
var _getDomainLocale = __webpack_require__(1528);
var _addBasePath = __webpack_require__(1470);
"client";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow: shallow,
                locale: locale,
                scroll: scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            var method = replace ? "replace" : "push";
            router[method](href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onTouchStart = props.onTouchStart, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(true) !== true : _legacyBehavior, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref.href, as = ref.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref1[0], isVisible = ref1[1], resetVisible = ref1[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: function(e) {
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 7964:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.normalizeLocalePath = void 0;
var normalizeLocalePath = function(pathname, locales) {
    if (true) {
        return (__webpack_require__(4331).normalizeLocalePath)(pathname, locales);
    }
    return {
        pathname: pathname,
        detectedLocale: undefined
    };
};
exports.normalizeLocalePath = normalizeLocalePath;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=normalize-locale-path.js.map


/***/ }),

/***/ 1842:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(9854)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(7378);
var _requestIdleCallback = __webpack_require__(2878);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                var unobserve = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 7868:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(2619)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7378));
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
var GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
var TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 9906:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(3210)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6516)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2619)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7378));
var _loadable = _interop_require_default(__webpack_require__(2456));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 1721:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getImageBlurSvg = getImageBlurSvg;
function getImageBlurSvg(param) {
    var widthInt = param.widthInt, heightInt = param.heightInt, blurWidth = param.blurWidth, blurHeight = param.blurHeight, blurDataURL = param.blurDataURL;
    var std = blurWidth && blurHeight ? "1" : "20";
    var svgWidth = blurWidth || widthInt;
    var svgHeight = blurHeight || heightInt;
    var feComponentTransfer = blurDataURL.startsWith("data:image/jpeg") ? "%3CfeComponentTransfer%3E%3CfeFuncA type='discrete' tableValues='1 1'/%3E%3C/feComponentTransfer%3E%" : "";
    return "%3Csvg xmlns='http%3A//www.w3.org/2000/svg' viewBox='0 0 ".concat(svgWidth, " ").concat(svgHeight, "'%3E%3Cfilter id='b' color-interpolation-filters='sRGB'%3E%3CfeGaussianBlur stdDeviation='").concat(std, "'/%3E").concat(feComponentTransfer, "%3C/filter%3E%3Cimage filter='url(%23b)' x='0' y='0' height='100%25' width='100%25' href='").concat(blurDataURL, "'/%3E%3C/svg%3E");
} //# sourceMappingURL=image-blur-svg.js.map


/***/ }),

/***/ 7815:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(2619)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7378));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 2456:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(93)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(7758)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6516)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2619)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7378));
var _loadableContext = __webpack_require__(7815);
var useSyncExternalStore = ( true ? __webpack_require__(7378) : 0).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 5884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A_": function() { return /* binding */ META_TITLE_SUFFIX; },
/* harmony export */   "PX": function() { return /* binding */ __IS_PROD_ENV__; },
/* harmony export */   "aG": function() { return /* binding */ DeviceSizes; },
/* harmony export */   "ch": function() { return /* binding */ __IS_DEV_ENV__; },
/* harmony export */   "ip": function() { return /* binding */ headerHeightXs; },
/* harmony export */   "jT": function() { return /* binding */ __APP_HOST_PUBLIC__; },
/* harmony export */   "l_": function() { return /* binding */ Viewport; },
/* harmony export */   "z_": function() { return /* binding */ headerHeightSmAndAbove; }
/* harmony export */ });
/* unused harmony exports __IS_TEST_ENV__, __IS_BUILD_TEST__, __APP_HOST_AUTHOR__ */
/* provided dependency */ var process = __webpack_require__(7061);
// ---- Node environments
var __IS_DEV_ENV__ = "production" === "development";
var __IS_PROD_ENV__ = "production" === "production";
var __IS_TEST_ENV__ = (/* unused pure expression or super */ null && ("production" === "test"));
var __IS_BUILD_TEST__ = process.env.NEXT_PUBLIC_IS_BUILD_TEST === "true";
var __APP_HOST_PUBLIC__ = String("https://frontend-author.uat-wif.busfinland.magnolia-platform.com" || 0);
var __APP_HOST_AUTHOR__ = String(process.env.NEXT_PUBLIC_APP_HOST_AUTHOR || __APP_HOST_PUBLIC__);
var Viewport;
(function(Viewport) {
    Viewport["xs"] = "xs";
    Viewport["sm"] = "sm";
    Viewport["md"] = "md";
    Viewport["lg"] = "lg";
    Viewport["xl"] = "xl";
})(Viewport || (Viewport = {}));
var DeviceSizes;
(function(DeviceSizes) {
    DeviceSizes[DeviceSizes["xs"] = 0] = "xs";
    DeviceSizes[DeviceSizes["sm"] = 600] = "sm";
    DeviceSizes[DeviceSizes["md"] = 900] = "md";
    DeviceSizes[DeviceSizes["lg"] = 1024] = "lg";
    DeviceSizes[DeviceSizes["xl"] = 1440] = "xl";
})(DeviceSizes || (DeviceSizes = {}));
var headerHeightXs = 75;
var headerHeightSmAndAbove = 104;
var META_TITLE_SUFFIX = " - Work in Finland";


/***/ }),

/***/ 48:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MG": function() { return /* binding */ LOCAL_STORAGE_JOBS_SEARCH_HISTORY; },
/* harmony export */   "Mu": function() { return /* binding */ LOCAL_STORAGE_SAVED_ITEMS_KEY; },
/* harmony export */   "NT": function() { return /* binding */ LOCAL_STORAGE_AINO_PREVENT_POPUP_KEY; }
/* harmony export */ });
var LOCAL_STORAGE_SAVED_ITEMS_KEY = "wif_local_storage_saved_items";
var LOCAL_STORAGE_AINO_PREVENT_POPUP_KEY = "wif_aino_prevent_chatPanel_Popup";
var LOCAL_STORAGE_JOBS_SEARCH_HISTORY = "wif-jobs-search-history";


/***/ }),

/***/ 3726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EW": function() { return /* binding */ ogLocaleMap; },
/* harmony export */   "HG": function() { return /* binding */ localesEmployers; },
/* harmony export */   "Vb": function() { return /* binding */ localesTalent; },
/* harmony export */   "al": function() { return /* binding */ defaultLocale; },
/* harmony export */   "go": function() { return /* binding */ Locale; }
/* harmony export */ });
/* unused harmony export locales */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7599);

var Locale;
(function(Locale) {
    Locale["Default"] = "default";
    Locale["English"] = "en";
    Locale["Finnish"] = "fi";
    Locale["Swedish"] = "sv";
})(Locale || (Locale = {}));
var defaultLocale = Locale.English;
var locales = [
    Locale.Finnish,
    Locale.English,
    Locale.Swedish, 
];
var localesTalent = [
    Locale.English
];
var localesEmployers = locales;
var _obj;
var ogLocaleMap = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, Locale.Finnish, "fi_FI"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, Locale.Swedish, "sv_SE"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, Locale.English, "en_GB"), _obj);


/***/ }),

/***/ 5056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ MGNL; },
  "w": function() { return /* binding */ MGNL_API; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(4364);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_create_class.mjs
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

;// CONCATENATED MODULE: ./src/constants/magnolia.ts
/* provided dependency */ var process = __webpack_require__(7061);
/* eslint-disable max-len */ 

var MGNL = /*#__PURE__*/ function() {
    "use strict";
    function MGNL() {
        (0,_class_call_check/* default */.Z)(this, MGNL);
    }
    /**
   * URL for the current author or public deployment of Magnolia instance.
   * If `isPreview` is set to `true`, path for the author instance will be used,
   * else path for the public instance will be used.
   * @example "http://localhost:8080"
   */ MGNL.HOST = function HOST() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return isPreview ? this.HOST_AUTHOR : this.HOST_PUBLIC;
    };
    /**
   * Used as base for all API endpoints
   * @example "http://localhost:8080/magnoliaAuthor"
   */ MGNL.BASE_URL = function BASE_URL() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return this.HOST(isPreview) + this.AUTHOR_PATH;
    };
    /**
   * Used as base for all API endpoints
   * @example "http://localhost:8080/magnoliaAuthor"
   */ MGNL.DELIVERY_API = function DELIVERY_API() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return this.BASE_URL(isPreview) + "/.rest/wif";
    };
    MGNL.BF_CUSTOM_API = function BF_CUSTOM_API() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return this.BASE_URL(isPreview) + "/.rest/bf";
    };
    _createClass(MGNL, null, [
        {
            key: "HOST_PUBLIC",
            get: /**
   * URL for the current public deployment of Magnolia instance.
   * @example "http://localhost:8080"
   * @required
   */ function get() {
                var host = String("https://mgnl-author.uat.busfinland.magnolia-platform.com" || 0);
                if (!host) {
                    throw new Error("Env var NEXT_PUBLIC_MGNL_HOST is required.");
                }
                return host;
            }
        },
        {
            key: "HOST_AUTHOR",
            get: /**
   * URL for the current author deployment of Magnolia instance.
   * @example "http://localhost:8080"
   */ function get() {
                return String(process.env.NEXT_PUBLIC_MGNL_HOST_AUTHOR || this.HOST_PUBLIC);
            }
        },
        {
            key: "AUTHOR_PATH",
            get: /**
   * Subpath of Magnolia's author instance. Could be empty string.
   * @example "/magnoliaAuthor"
   * @default ""
   */ function get() {
                return String(process.env.NEXT_PUBLIC_MGNL_AUTHOR || "");
            }
        },
        {
            key: "ROOT_NODE",
            get: /**
   * Magnolia root node (parent page-node for all pages/content).
   * @default "/wif"
   */ function get() {
                return String("/wif" || 0);
            }
        },
        {
            key: "EMPLOYERS_NODE",
            get: /**
   * Magnolia root node for employers site .
   * @default "/wif/tyonantajat"
   */ function get() {
                return String(this.ROOT_NODE + "/tyonantajat");
            }
        },
        {
            key: "AUTH_TOKEN",
            get: function get() {
                return process.env.MGNL_AUTH_TOKEN;
            }
        }
    ]);
    return MGNL;
}();
var MGNL_API = /*#__PURE__*/ function() {
    "use strict";
    function MGNL_API() {
        (0,_class_call_check/* default */.Z)(this, MGNL_API);
    }
    /**
   * Get all companies.
   */ MGNL_API.COMPANIES = function COMPANIES() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return MGNL.DELIVERY_API(isPreview) + "/companies";
    };
    /**
   * Get all content for the current page node to render page.
   */ MGNL_API.PAGE_CONTENT = function PAGE_CONTENT() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return MGNL.DELIVERY_API(isPreview) + "/page-content";
    };
    /**
   * Get minimum data for all page-nodes that are required to build navigation.
   */ MGNL_API.NAVIGATION = function NAVIGATION() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return MGNL.DELIVERY_API(isPreview) + "/navigation";
    };
    /**
   * Get minimum data for a list of page-nodes. Limit=100.
   */ MGNL_API.PAGES_100 = function PAGES_100() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return MGNL.DELIVERY_API(isPreview) + "/pages/100";
    };
    /**
   * Get minimum data for a list of page-nodes. Limit=10.
   */ MGNL_API.PAGES_10 = function PAGES_10() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return MGNL.DELIVERY_API(isPreview) + "/pages/10";
    };
    /**
   * Get minimum data for all page-nodes under ROOT_NODE
   * to statically generate pages during build-time (all languages).
   */ MGNL_API.PATHS = function PATHS() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return MGNL.DELIVERY_API(isPreview) + "/paths";
    };
    /**
   * Get minimum data for all page-nodes under ROOT_NODE
   * to statically generate pages during build-time (all languages).
   */ MGNL_API.PATHS_VIDEOS = function PATHS_VIDEOS() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return MGNL.DELIVERY_API(isPreview) + "/paths/videos";
    };
    /**
   * Get minimum data for all page-nodes under ROOT_NODE
   * to statically generate pages during build-time (all languages).
   */ MGNL_API.PATHS_IMAGES = function PATHS_IMAGES() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return MGNL.DELIVERY_API(isPreview) + "/paths/images";
    };
    /**
   * Get all services.
   */ MGNL_API.SERVICES = function SERVICES() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return MGNL.DELIVERY_API(isPreview) + "/services";
    };
    /**
   * Form module custom endpoint.
   */ MGNL_API.FORM_SUBMIT = function FORM_SUBMIT() {
        var isPreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return MGNL.BF_CUSTOM_API(isPreview) + "/form/submit";
    };
    /**
   * Get template annotations for current page during preview,
   * so the Magnolia editor can render toolbars.
   */ MGNL_API.TEMPLATE = function TEMPLATE() {
        return MGNL.BASE_URL(true) + "/.rest/template-annotations/v1";
    };
    /**
   * Magnolia Nodes API endpoint.
   * @see https://docs.magnolia-cms.com/product-docs/6.2/Developing/API/Nodes-and-properties-APIs/Nodes-API.html
   */ MGNL_API.NODES = function NODES(workspace) {
        var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "/", options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var _isPreview = options.isPreview, isPreview = _isPreview === void 0 ? false : _isPreview, _depth = options.depth, depth = _depth === void 0 ? 0 : _depth, excludeNodeTypes = options.excludeNodeTypes, includeMetadata = options.includeMetadata;
        var url = MGNL.BASE_URL(isPreview) + "/.rest/nodes/v1/".concat(workspace).concat(path);
        if (!depth && !excludeNodeTypes && !includeMetadata) {
            return url;
        }
        var searchParams = new URLSearchParams();
        searchParams.set("depth", depth.toString());
        searchParams.set("excludeNodeTypes", (excludeNodeTypes === null || excludeNodeTypes === void 0 ? void 0 : excludeNodeTypes.join(",")) || "");
        searchParams.set("includeMetadata", String(Boolean(includeMetadata)));
        return "".concat(url, "?").concat(searchParams.toString());
    };
    return MGNL_API;
}();


/***/ }),

/***/ 981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ EmployerSiteContextProvider; },
/* harmony export */   "Z": function() { return /* binding */ useEmployerSite; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);

var EmployerSiteContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    isEmployerSite: false
});
var EmployerSiteContextProvider = EmployerSiteContext.Provider;
function useEmployerSite() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(EmployerSiteContext);
}


/***/ }),

/***/ 6548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ PageContentContextProvider; },
/* harmony export */   "Z": function() { return /* binding */ usePageContent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);

var PageContentContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var PageContentContextProvider = PageContentContext.Provider;
function usePageContent() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(PageContentContext);
    if (!context) {
        throw new Error("The page content is not available on this route.");
    }
    return context;
}


/***/ }),

/***/ 2433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSavedItems; },
/* harmony export */   "e": function() { return /* binding */ WifSavedItemsToStorageProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3444);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _util_localStorage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9166);
/* harmony import */ var _constants_localStorageKeys__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48);





var SavedItemsToStorageContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
function WifSavedItemsToStorageProvider(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useTransition)(), startTransition = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), storedItems = ref1[0], setStoredItems = ref1[1];
    var getFromLocalStorage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var lsStoredItems = (0,_util_localStorage__WEBPACK_IMPORTED_MODULE_2__/* .getLocalStorage */ .$o)(_constants_localStorageKeys__WEBPACK_IMPORTED_MODULE_3__/* .LOCAL_STORAGE_SAVED_ITEMS_KEY */ .Mu);
        return lsStoredItems || [];
    }, []);
    var toggleItemInLocalStorage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(item) {
        var lsStoredItems = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(getFromLocalStorage());
        if (lsStoredItems && !lsStoredItems.some(function(a) {
            return (a === null || a === void 0 ? void 0 : a.id) === item.id;
        })) {
            var increasedArray = [
                item
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(lsStoredItems));
            startTransition(function() {
                setStoredItems(increasedArray);
            });
            (0,_util_localStorage__WEBPACK_IMPORTED_MODULE_2__/* .setLocalStorage */ .qQ)(_constants_localStorageKeys__WEBPACK_IMPORTED_MODULE_3__/* .LOCAL_STORAGE_SAVED_ITEMS_KEY */ .Mu, increasedArray);
        } else {
            var decreasedArray = lsStoredItems.filter(function(a) {
                return a.id !== item.id;
            });
            startTransition(function() {
                setStoredItems(decreasedArray);
            });
            (0,_util_localStorage__WEBPACK_IMPORTED_MODULE_2__/* .setLocalStorage */ .qQ)(_constants_localStorageKeys__WEBPACK_IMPORTED_MODULE_3__/* .LOCAL_STORAGE_SAVED_ITEMS_KEY */ .Mu, decreasedArray);
        }
    }, [
        getFromLocalStorage
    ]);
    var isSaved = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(id) {
        if (!id || id === undefined) {
            return false;
        }
        return storedItems.some(function(item) {
            return (item === null || item === void 0 ? void 0 : item.id) === id;
        });
    }, [
        storedItems
    ]);
    var clearLocalStorage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        (0,_util_localStorage__WEBPACK_IMPORTED_MODULE_2__/* .removeLocalStorage */ .dZ)(_constants_localStorageKeys__WEBPACK_IMPORTED_MODULE_3__/* .LOCAL_STORAGE_SAVED_ITEMS_KEY */ .Mu);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var lsStoredItems = getFromLocalStorage();
        startTransition(function() {
            setStoredItems(lsStoredItems);
        });
    }, [
        getFromLocalStorage
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SavedItemsToStorageContext.Provider, {
        value: {
            storedItems: storedItems,
            toggleItemInLocalStorage: toggleItemInLocalStorage,
            isSaved: isSaved,
            getFromLocalStorage: getFromLocalStorage,
            clearLocalStorage: clearLocalStorage
        },
        children: children
    });
}
function useSavedItems() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(SavedItemsToStorageContext);
    if (!context) throw new Error("Cannot use this hook without Provider.");
    return context;
}


/***/ }),

/***/ 9366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ ViewportContextProvider; },
/* harmony export */   "Z": function() { return /* binding */ useViewport; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(169);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var _business_finland_wif_ui_lib__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(128);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _util_viewport__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5625);






var initialViewport = {
    viewport: "xl",
    isMobile: false
};
var ViewportContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(initialViewport);
function ViewportContextProvider(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useTransition)(), startTransition = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialViewport), viewport = ref1[0], setViewport = ref1[1];
    var checkIsMobile = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(viewport) {
        return viewport === "xs" || viewport === "sm" || viewport === undefined;
    }, []);
    var updateViewport = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var viewport = (0,_util_viewport__WEBPACK_IMPORTED_MODULE_2__/* .getViewportByWindowWidth */ .J)();
        setViewport(function(prev) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, prev), {
                viewport: viewport,
                isMobile: checkIsMobile(viewport)
            });
        });
    }, [
        checkIsMobile
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return startTransition(updateViewport);
    }, [
        updateViewport
    ]);
    (0,_business_finland_wif_ui_lib__WEBPACK_IMPORTED_MODULE_5__/* .useEventListener */ .OR)("resize", function() {
        return startTransition(updateViewport);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ViewportContext.Provider, {
        value: viewport,
        children: children
    });
}
function useViewport() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ViewportContext);
}


/***/ }),

/***/ 9937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gM": function() { return /* binding */ MagnoliaTemplate; },
/* harmony export */   "iL": function() { return /* binding */ magnoliaEditablePageConfig; },
/* harmony export */   "rX": function() { return /* binding */ getComponentForMagnoliaTemplate; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7599);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5218);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_0__);
/* istanbul ignore file */ 

// Templates
var Page = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 1631).then(__webpack_require__.bind(__webpack_require__, 5572));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5572)
            ];
        }
    }
});
var EventsPage = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 8822).then(__webpack_require__.bind(__webpack_require__, 8822));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8822)
            ];
        }
    }
});
var OpenJobsPage = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(808), __webpack_require__.e(2207), __webpack_require__.e(7826)]).then(__webpack_require__.bind(__webpack_require__, 7826));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7826)
            ];
        }
    }
});
var JobsPage = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(808), __webpack_require__.e(2207), __webpack_require__.e(7215)]).then(__webpack_require__.bind(__webpack_require__, 7215));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7215)
            ];
        }
    }
});
var EventsCalendarPage = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 6667).then(__webpack_require__.bind(__webpack_require__, 6667));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6667)
            ];
        }
    }
});
var ArticlesFiltersPage = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7386), __webpack_require__.e(808), __webpack_require__.e(5406)]).then(__webpack_require__.bind(__webpack_require__, 5406));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5406)
            ];
        }
    }
});
// Components
var ArticleChart = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 6875).then(__webpack_require__.bind(__webpack_require__, 6875));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6875)
            ];
        }
    }
});
var ArticleFooterSection = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 318).then(__webpack_require__.bind(__webpack_require__, 318));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(318)
            ];
        }
    }
});
var ArticleImageGallery = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 8622).then(__webpack_require__.bind(__webpack_require__, 8622));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8622)
            ];
        }
    }
});
var ArticlePageHero = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 3883).then(__webpack_require__.bind(__webpack_require__, 3883));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3883)
            ];
        }
    }
});
var ArticleQuote = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 7666).then(__webpack_require__.bind(__webpack_require__, 7666));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7666)
            ];
        }
    }
});
var ArticleSection = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 6191).then(__webpack_require__.bind(__webpack_require__, 6191));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6191)
            ];
        }
    }
});
var CompanyList = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(808), __webpack_require__.e(7512)]).then(__webpack_require__.bind(__webpack_require__, 9615));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9615)
            ];
        }
    }
});
var CompanyForm = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(808), __webpack_require__.e(8386)]).then(__webpack_require__.bind(__webpack_require__, 5130));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5130)
            ];
        }
    }
});
var ContactCard = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 3260).then(__webpack_require__.bind(__webpack_require__, 3260));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3260)
            ];
        }
    }
});
var CTABanner = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 93).then(__webpack_require__.bind(__webpack_require__, 1460));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1460)
            ];
        }
    }
});
var Hero = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 4349).then(__webpack_require__.bind(__webpack_require__, 4349));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4349)
            ];
        }
    }
});
var LinkPreview = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 1176).then(__webpack_require__.bind(__webpack_require__, 6333));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6333)
            ];
        }
    }
});
var MapBox = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 3707).then(__webpack_require__.bind(__webpack_require__, 3707));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3707)
            ];
        }
    }
});
var Masonry = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 5572).then(__webpack_require__.bind(__webpack_require__, 8446));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8446)
            ];
        }
    }
});
var MigriWidget = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 9642).then(__webpack_require__.bind(__webpack_require__, 9642));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9642)
            ];
        }
    }
});
var OpenJobsHighlight = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(808), __webpack_require__.e(9506)]).then(__webpack_require__.bind(__webpack_require__, 7404));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7404)
            ];
        }
    }
});
var PageHeader = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 6758).then(__webpack_require__.bind(__webpack_require__, 6758));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6758)
            ];
        }
    }
});
var PromotionBanner = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 9781).then(__webpack_require__.bind(__webpack_require__, 9781));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9781)
            ];
        }
    }
});
var Quotes = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 859).then(__webpack_require__.bind(__webpack_require__, 859));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(859)
            ];
        }
    }
});
var Recommendations = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 3987).then(__webpack_require__.bind(__webpack_require__, 3987));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3987)
            ];
        }
    }
});
var SectionHeader = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 2885).then(__webpack_require__.bind(__webpack_require__, 2885));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2885)
            ];
        }
    }
});
var Tabs = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 9569).then(__webpack_require__.bind(__webpack_require__, 9569));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9569)
            ];
        }
    }
});
var Video = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7650), __webpack_require__.e(698)]).then(__webpack_require__.bind(__webpack_require__, 698));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(698)
            ];
        }
    }
});
var Quiz = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 8866).then(__webpack_require__.bind(__webpack_require__, 8866));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8866)
            ];
        }
    }
});
var Form = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8039), __webpack_require__.e(4378)]).then(__webpack_require__.bind(__webpack_require__, 4378));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4378)
            ];
        }
    }
});
var FormGroupFields = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 9176).then(__webpack_require__.bind(__webpack_require__, 9176));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9176)
            ];
        }
    }
});
var FormEdit = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8039), __webpack_require__.e(8668)]).then(__webpack_require__.bind(__webpack_require__, 8668));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8668)
            ];
        }
    }
});
var FormSelection = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8039), __webpack_require__.e(9930)]).then(__webpack_require__.bind(__webpack_require__, 9930));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9930)
            ];
        }
    }
});
var FormHoneypot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 2627).then(__webpack_require__.bind(__webpack_require__, 2190));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2190)
            ];
        }
    }
});
var FormFile = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8039), __webpack_require__.e(5514)]).then(__webpack_require__.bind(__webpack_require__, 5514));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5514)
            ];
        }
    }
});
var FormSubmit = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8039), __webpack_require__.e(439)]).then(__webpack_require__.bind(__webpack_require__, 439));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(439)
            ];
        }
    }
});
var HtmlCode = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 731).then(__webpack_require__.bind(__webpack_require__, 731));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(731)
            ];
        }
    }
});
var MagnoliaTemplate;
(function(MagnoliaTemplate) {
    MagnoliaTemplate[// Pages
    "Page"] = "wif-lm:pages/page";
    MagnoliaTemplate["PageArticle"] = "wif-lm:pages/article";
    MagnoliaTemplate["PageArticleFilter"] = "wif-lm:pages/articleFilter";
    MagnoliaTemplate["PageDeleted"] = "pages-app:deleted";
    MagnoliaTemplate["PageEmployer"] = "wif-lm:pages/employer";
    MagnoliaTemplate["PageEvent"] = "wif-lm:pages/event";
    MagnoliaTemplate["PageEventCalendar"] = "wif-lm:pages/eventCalendar";
    MagnoliaTemplate["PageOpenJobs"] = "wif-lm:pages/openJobsPage";
    MagnoliaTemplate["PageJobs"] = "wif-lm:pages/jobsPage";
    MagnoliaTemplate["PageRedirect"] = "wif-lm:pages/redirect";
    MagnoliaTemplate[// Components
    "ArticleChart"] = "wif-lm:components/articleChart";
    MagnoliaTemplate["ArticleFooterSection"] = "wif-lm:components/footerSection";
    MagnoliaTemplate["ArticleImageGallery"] = "wif-lm:components/articleImageGallery";
    MagnoliaTemplate["ArticlePageHero"] = "wif-lm:components/articlePageHero";
    MagnoliaTemplate["ArticleQuote"] = "wif-lm:components/articleQuote";
    MagnoliaTemplate["ArticleSection"] = "wif-lm:components/articleSection";
    MagnoliaTemplate["CompanyList"] = "wif-lm:components/companyList";
    MagnoliaTemplate["CompanyForm"] = "wif-lm:components/companyForm";
    MagnoliaTemplate["ContactCard"] = "wif-lm:components/contactCard";
    MagnoliaTemplate["CTABanner"] = "wif-lm:components/ctaBanner";
    MagnoliaTemplate["Hero"] = "wif-lm:components/hero";
    MagnoliaTemplate["LinkPreview"] = "wif-lm:components/linkPreview";
    MagnoliaTemplate["Map"] = "wif-lm:components/mapBox";
    MagnoliaTemplate["Masonry"] = "wif-lm:components/masonry";
    MagnoliaTemplate["MigriWidget"] = "wif-lm:components/migriWidget";
    MagnoliaTemplate["OpenJobsHighlight"] = "wif-lm:components/openJobsHighlight";
    MagnoliaTemplate["PageHeader"] = "wif-lm:components/pageHeader";
    MagnoliaTemplate["PromotionBanner"] = "wif-lm:components/promotionBanner";
    MagnoliaTemplate["Quotes"] = "wif-lm:components/quotes";
    MagnoliaTemplate["Recommendations"] = "wif-lm:components/recommendations";
    MagnoliaTemplate["SectionHeader"] = "wif-lm:components/sectionHeader";
    MagnoliaTemplate["Tabs"] = "wif-lm:components/tabs";
    MagnoliaTemplate["Video"] = "wif-lm:components/articleVideo";
    MagnoliaTemplate["Quiz"] = "wif-lm:components/quiz";
    MagnoliaTemplate["Form"] = "form:components/form";
    MagnoliaTemplate["FormGroupFields"] = "form:components/formGroupFields";
    MagnoliaTemplate["FormEdit"] = "form:components/formEdit";
    MagnoliaTemplate["FormNumber"] = "form:components/formNumber";
    MagnoliaTemplate["FormSubmit"] = "form:components/formSubmit";
    MagnoliaTemplate["FormSelection"] = "form:components/formSelection";
    MagnoliaTemplate["FormHoneypot"] = "form:components/formHoneypot";
    MagnoliaTemplate["FormFile"] = "form:components/formFile";
    MagnoliaTemplate["HtmlCode"] = "wif-lm:components/htmlCode";
})(MagnoliaTemplate || (MagnoliaTemplate = {}));
var _obj;
var magnoliaEditablePageConfig = {
    componentMappings: (_obj = {}, // Pages
    (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.Page, Page), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.PageArticle, Page), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.PageArticleFilter, ArticlesFiltersPage), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.PageEmployer, Page), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.PageEvent, EventsPage), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.PageEventCalendar, EventsCalendarPage), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.PageOpenJobs, OpenJobsPage), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.PageJobs, JobsPage), // Components
    (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.ArticleChart, ArticleChart), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.ArticleFooterSection, ArticleFooterSection), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.ArticleImageGallery, ArticleImageGallery), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.ArticlePageHero, ArticlePageHero), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.ArticleQuote, ArticleQuote), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.ArticleSection, ArticleSection), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.CompanyList, CompanyList), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.CompanyForm, CompanyForm), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.ContactCard, ContactCard), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.CTABanner, CTABanner), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.LinkPreview, LinkPreview), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.Hero, Hero), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.Map, MapBox), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.Masonry, Masonry), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.MigriWidget, MigriWidget), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.OpenJobsHighlight, OpenJobsHighlight), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.PageHeader, PageHeader), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.PromotionBanner, PromotionBanner), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.Quotes, Quotes), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.Recommendations, Recommendations), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.SectionHeader, SectionHeader), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.Tabs, Tabs), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.Video, Video), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.Quiz, Quiz), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.Form, Form), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.FormGroupFields, FormGroupFields), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.FormEdit, FormEdit), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.FormNumber, FormEdit), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.FormSelection, FormSelection), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.FormHoneypot, FormHoneypot), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.FormFile, FormFile), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.FormSubmit, FormSubmit), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, MagnoliaTemplate.HtmlCode, HtmlCode), _obj)
};
/**
 * The helper function finds and returns the Component associated
 * with the provided MGNL template from the componentMappings.
 * If component is not found, `undefined` is returned.
 */ function getComponentForMagnoliaTemplate(template) {
    if (!template) {
        return undefined;
    }
    var validTemplate = Object.keys(magnoliaEditablePageConfig.componentMappings).find(function(t) {
        return t === template;
    });
    if (!validTemplate) {
        return undefined;
    }
    return magnoliaEditablePageConfig.componentMappings[validTemplate];
}


/***/ }),

/***/ 1999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 36 modules
var esm = __webpack_require__(9800);
// EXTERNAL MODULE: ../wif-ui-lib/dist/style.css
var style = __webpack_require__(1584);
// EXTERNAL MODULE: ./src/styles/theme.css
var theme = __webpack_require__(477);
// EXTERNAL MODULE: ./src/constants/magnolia.ts + 1 modules
var magnolia = __webpack_require__(5056);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(8038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(6677);
// EXTERNAL MODULE: ../node_modules/next/link.js
var next_link = __webpack_require__(9894);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../node_modules/next/future/image.js
var future_image = __webpack_require__(1723);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(5218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
;// CONCATENATED MODULE: ../node_modules/next-themes/dist/index.mjs
"use client";var L=(e,r,s,u,d,m,l,h)=>{let c=document.documentElement,v=["light","dark"];function p(i){(Array.isArray(e)?e:[e]).forEach(y=>{let k=y==="class",S=k&&m?d.map(f=>m[f]||f):d;k?(c.classList.remove(...S),c.classList.add(i)):c.setAttribute(y,i)}),R(i)}function R(i){h&&v.includes(i)&&(c.style.colorScheme=i)}function a(){return window.matchMedia("(prefers-color-scheme: dark)").matches?"dark":"light"}if(u)p(u);else try{let i=localStorage.getItem(r)||s,y=l&&i==="system"?a():i;p(y)}catch(i){}};var M=["light","dark"],Q="(prefers-color-scheme: dark)",U=typeof window=="undefined",E=react.createContext(void 0),N={setTheme:e=>{},themes:[]},z=()=>{var e;return(e=t.useContext(E))!=null?e:N},J=e=>react.useContext(E)?react.createElement(react.Fragment,null,e.children):react.createElement(_,{...e}),V=["light","dark"],_=({forcedTheme:e,disableTransitionOnChange:r=!1,enableSystem:s=!0,enableColorScheme:u=!0,storageKey:d="theme",themes:m=V,defaultTheme:l=s?"system":"light",attribute:h="data-theme",value:c,children:v,nonce:p,scriptProps:R})=>{let[a,i]=react.useState(()=>b(d,l)),[w,y]=react.useState(()=>b(d)),k=c?Object.values(c):m,S=react.useCallback(n=>{let o=n;if(!o)return;n==="system"&&s&&(o=I());let T=c?c[o]:o,C=r?W(p):null,P=document.documentElement,x=g=>{g==="class"?(P.classList.remove(...k),T&&P.classList.add(T)):g.startsWith("data-")&&(T?P.setAttribute(g,T):P.removeAttribute(g))};if(Array.isArray(h)?h.forEach(x):x(h),u){let g=M.includes(l)?l:null,O=M.includes(o)?o:g;P.style.colorScheme=O}C==null||C()},[p]),f=react.useCallback(n=>{let o=typeof n=="function"?n(a):n;i(o);try{localStorage.setItem(d,o)}catch(T){}},[a]),A=react.useCallback(n=>{let o=I(n);y(o),a==="system"&&s&&!e&&S("system")},[a,e]);react.useEffect(()=>{let n=window.matchMedia(Q);return n.addListener(A),A(n),()=>n.removeListener(A)},[A]),react.useEffect(()=>{let n=o=>{o.key===d&&(o.newValue?i(o.newValue):f(l))};return window.addEventListener("storage",n),()=>window.removeEventListener("storage",n)},[f]),react.useEffect(()=>{S(e!=null?e:a)},[e,a]);let D=react.useMemo(()=>({theme:a,setTheme:f,forcedTheme:e,resolvedTheme:a==="system"?w:a,themes:s?[...m,"system"]:m,systemTheme:s?w:void 0}),[a,f,e,w,s,m]);return react.createElement(E.Provider,{value:D},react.createElement(H,{forcedTheme:e,storageKey:d,attribute:h,enableSystem:s,enableColorScheme:u,defaultTheme:l,value:c,themes:m,nonce:p,scriptProps:R}),v)},H=react.memo(({forcedTheme:e,storageKey:r,attribute:s,enableSystem:u,enableColorScheme:d,defaultTheme:m,value:l,themes:h,nonce:c,scriptProps:v})=>{let p=JSON.stringify([s,r,m,e,h,l,u,d]).slice(1,-1);return react.createElement("script",{...v,suppressHydrationWarning:!0,nonce:typeof window=="undefined"?c:"",dangerouslySetInnerHTML:{__html:`(${L.toString()})(${p})`}})}),b=(e,r)=>{if(U)return;let s;try{s=localStorage.getItem(e)||void 0}catch(u){}return s||r},W=e=>{let r=document.createElement("style");return e&&r.setAttribute("nonce",e),r.appendChild(document.createTextNode("*,*::before,*::after{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}")),document.head.appendChild(r),()=>{window.getComputedStyle(document.body),setTimeout(()=>{document.head.removeChild(r)},1)}},I=e=>(e||(e=window.matchMedia(Q)),e.matches?"dark":"light");

// EXTERNAL MODULE: ../wif-ui-lib/dist/app-51178863.mjs
var app_51178863 = __webpack_require__(7610);
// EXTERNAL MODULE: ../wif-ui-lib/dist/ImageContext-57256dc1.mjs
var ImageContext_57256dc1 = __webpack_require__(2355);
// EXTERNAL MODULE: ../wif-ui-lib/dist/LinkContext-0c83848a.mjs
var LinkContext_0c83848a = __webpack_require__(2659);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/context.js







function s({
  children: r,
  LinkComponent: t,
  ImageComponent: o,
  isEmployerSite: m = !1
}) {
  return /* @__PURE__ */ react.createElement(app_51178863.E.Provider, { value: m }, /* @__PURE__ */ react.createElement(LinkContext_0c83848a.L.Provider, { value: t }, /* @__PURE__ */ react.createElement(ImageContext_57256dc1.I.Provider, { value: o }, r)));
}

//# sourceMappingURL=context.js.map

// EXTERNAL MODULE: ./src/constants/app.ts
var app = __webpack_require__(5884);
// EXTERNAL MODULE: ./src/constants/locale.ts
var constants_locale = __webpack_require__(3726);
// EXTERNAL MODULE: ./src/contexts/EmployerSiteContext.tsx
var EmployerSiteContext = __webpack_require__(981);
// EXTERNAL MODULE: ./src/contexts/PageContentContext.tsx
var PageContentContext = __webpack_require__(6548);
// EXTERNAL MODULE: ./src/contexts/SaveItemsToStorageContext.tsx
var SaveItemsToStorageContext = __webpack_require__(2433);
// EXTERNAL MODULE: ./src/contexts/ViewportContext.tsx
var ViewportContext = __webpack_require__(9366);
// EXTERNAL MODULE: ./src/magnolia.config.ts
var magnolia_config = __webpack_require__(9937);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var util_magnolia = __webpack_require__(7581);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3444);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Icon-e01b6482.mjs
var Icon_e01b6482 = __webpack_require__(2007);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Logo-8772aba7.mjs
var Logo_8772aba7 = __webpack_require__(1658);
// EXTERNAL MODULE: ../wif-ui-lib/dist/CallToAction-b7ee6480.mjs
var CallToAction_b7ee6480 = __webpack_require__(316);
// EXTERNAL MODULE: ../wif-ui-lib/dist/useKeyDown-88662051.mjs
var useKeyDown_88662051 = __webpack_require__(403);
// EXTERNAL MODULE: ../wif-ui-lib/dist/useClickOutside-55c64a80.mjs
var useClickOutside_55c64a80 = __webpack_require__(7720);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Link-460da2fc.mjs
var Link_460da2fc = __webpack_require__(1607);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/Footer.js






const Footer_ = "footer", u = "footer__logo", T = "desktop", h = "footer__button-to-top", C = "footer__button-to-top__btn-text", Footer_L = "footer__content_list", x = "footer__content_list--item", g = "footer__content_list__link", Footer_E = "footer__icon-content", y = "footer__icon-content__header", B = "footer__icon-content__list", Footer_I = "footer__copyright", Footer_b = "footer__copyright--text", Footer_N = "mobile--text", o = {
  footer: Footer_,
  footerLogo: u,
  desktop: T,
  footerButtonToTop: h,
  footerButtonToTopBtnText: C,
  footerContentList: Footer_L,
  footerContentListItem: x,
  footerContentListLink: g,
  footerIconContent: Footer_E,
  footerIconContentHeader: y,
  footerIconContentList: B,
  footerCopyright: Footer_I,
  footerCopyrightText: Footer_b,
  mobileText: Footer_N
};
function m({
  logo: n,
  ctaExternalLink: r,
  children: e,
  backToTopLabel: a
}) {
  return /* @__PURE__ */ react.createElement(useClickOutside_55c64a80.B, { as: "footer", className: o.footer, "data-testid": "footer-block" }, /* @__PURE__ */ react.createElement(useClickOutside_55c64a80.B.Content, { "data-testid": "footer-block-content" }, /* @__PURE__ */ react.createElement(
    "div",
    {
      role: "presentation",
      className: o.footerLogo,
      "data-testid": "footer-logo"
    },
    n
  ), /* @__PURE__ */ react.createElement(
    F,
    {
      "data-testid": "footer-to-top-button",
      backToTopLabel: a
    }
  ), e, /* @__PURE__ */ react.createElement("div", { className: o.footerCopyright, "data-testid": "footer-copy-right" }, r, /* @__PURE__ */ react.createElement(
    "div",
    {
      className: (0,useKeyDown_88662051.c)(
        useKeyDown_88662051.t.textsBodyText,
        o.footerCopyrightText
      )
    },
    /* @__PURE__ */ react.createElement("span", { "data-testid": "copyright-text" }, "© WorkInFinland.com ", (/* @__PURE__ */ new Date()).getFullYear())
  ))));
}
m.LinkList = k;
m.IconList = v;
function k({
  links: n,
  boldText: r = !1
}) {
  return !n || n.length === 0 ? null : /* @__PURE__ */ react.createElement(
    "ul",
    {
      className: o.footerContentList,
      "data-testid": "footer-list-container",
      itemScope: !0,
      itemType: "https://schema.org/ItemList"
    },
    n.map((e, a) => {
      if (!e.href)
        return null;
      const p = e.href.includes("://");
      return e.href ? /* @__PURE__ */ react.createElement(
        "li",
        {
          className: o.footerContentListItem,
          key: e.id,
          "data-testid": `footer-link-${e.id}`,
          itemProp: "itemListElement",
          itemScope: !0,
          itemType: "https://schema.org/ListItem"
        },
        /* @__PURE__ */ react.createElement("meta", { itemProp: "position", content: String(a + 1) }),
        /* @__PURE__ */ react.createElement(
          Link_460da2fc.L,
          {
            href: e.href,
            target: p ? "_blank" : void 0,
            locale: e.locale,
            className: (0,useKeyDown_88662051.c)(
              r ? useKeyDown_88662051.t.textsBodyTextBold : useKeyDown_88662051.t.textsBodyText,
              o.footerContentListLink
            ),
            itemProp: "item"
          },
          e.title
        )
      ) : null;
    })
  );
}
function v({
  iconLinks: n,
  followUsLabel: r = "Follow us"
}) {
  return !n || n.length === 0 ? null : /* @__PURE__ */ react.createElement("div", { className: o.footerIconContent }, /* @__PURE__ */ react.createElement("div", { className: o.footerIconContentHeader }, /* @__PURE__ */ react.createElement("span", { className: useKeyDown_88662051.t.textsBodyTextBold }, r)), /* @__PURE__ */ react.createElement(
    "div",
    {
      className: o.footerIconContentList,
      "data-testid": "footer-list-container"
    },
    n.map((e, a) => /* @__PURE__ */ react.createElement(
      Link_460da2fc.L,
      {
        "data-testid": `footer-icon-${a}`,
        key: e.url,
        href: e.url,
        target: "_blank",
        rel: "noreferrer noopener",
        "aria-label": e.label
      },
      /* @__PURE__ */ react.createElement(Icon_e01b6482.I, { ...e })
    ))
  ));
}
function F({
  backToTopLabel: n = "Back to Top"
}) {
  const r = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return /* @__PURE__ */ react.createElement(
    "button",
    {
      className: (0,useKeyDown_88662051.c)(useKeyDown_88662051.t.textsBodyText, o.footerButtonToTop),
      onClick: r
    },
    /* @__PURE__ */ react.createElement("div", { className: o.footerButtonToTopBtnText }, /* @__PURE__ */ react.createElement("span", null, n)),
    /* @__PURE__ */ react.createElement(Icon_e01b6482.I, { icon: Icon_e01b6482.W.CHEVRON_UP, size: 16, color: "white" })
  );
}

//# sourceMappingURL=Footer.js.map

;// CONCATENATED MODULE: ./src/components/Footer/Footer.tsx










function Footer(param) {
    var primary = param.primary, secondary = param.secondary, switchLink = param.switch;
    var t = (0,esm/* useTranslation */.$G)().t;
    var isEmployerSite = (0,EmployerSiteContext/* default */.Z)().isEmployerSite;
    var ctaLink = useCtaLink();
    var ctaProps = (0,react.useMemo)(function() {
        return {
            text: t("footer.ctaExternalLink"),
            to: ctaLink,
            isBlueBackground: true
        };
    }, [
        t,
        ctaLink
    ]);
    var socialIconLinks = (0,react.useMemo)(function() {
        return [
            {
                icon: Icon_e01b6482.W.SO_ME_YOUTUBE,
                color: "white",
                url: "https://www.youtube.com/channel/UCmZLixtub8rzI1Gxkr5w5jg",
                label: "Youtube",
                width: 35.75,
                height: 25.19,
                viewBox: "8 7.2 16 17"
            },
            {
                icon: Icon_e01b6482.W.SO_ME_LINKEDIN,
                color: "white",
                url: isEmployerSite ? "https://www.linkedin.com/company/work-in-finland-kansainvalisen-rekrytoinnin-tyonantajaneuvonta/" : "https://linkedin.com/showcase/finland-works/",
                label: "Linkedin",
                size: 35
            }, 
        ];
    }, [
        isEmployerSite
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(m, {
        logo: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo_8772aba7.L, {
            color: "secondary"
        }),
        ctaExternalLink: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction_b7ee6480.C, (0,_object_spread/* default */.Z)({}, ctaProps)),
        backToTopLabel: t("footer.backToTop"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(m.LinkList, {
                links: (0,_to_consumable_array/* default */.Z)(primary).concat([
                    switchLink
                ]),
                boldText: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(m.LinkList, {
                links: secondary
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(m.IconList, {
                iconLinks: socialIconLinks,
                followUsLabel: t("footer.followUs")
            })
        ]
    });
}
function useCtaLink() {
    var locale = (0,next_router.useRouter)().locale;
    if (locale === constants_locale/* Locale.Finnish */.go.Finnish) return "https://tem.fi/talent-boost";
    if (locale === constants_locale/* Locale.Swedish */.go.Swedish) return "https://tem.fi/sv/tillvaxt-genom-internationella-talanger";
    return "https://tem.fi/en/talent-boost-en";
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(2050);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Image-be3826ec.mjs
var Image_be3826ec = __webpack_require__(567);
// EXTERNAL MODULE: ../wif-ui-lib/dist/useModal-5a548e10.mjs
var useModal_5a548e10 = __webpack_require__(8175);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/Navigation.js











function _n(e) {
  const i = (0,react.useRef)(0), t = (0,react.useRef)("init"), a = (0,react.useCallback)(() => {
    const c = e?.current?.clientHeight ?? 104, s = window.scrollY - i.current;
    if (i.current = window.scrollY, window.scrollY <= c)
      return t.current = "init";
    if (s === 0)
      return t.current;
    const r = s < 0 ? "up" : "down";
    return t.current = r;
  }, [e]);
  return (0,react.useSyncExternalStore)(
    un,
    a,
    () => "init"
  );
}
function un(e) {
  return window.addEventListener("scroll", e), () => window.removeEventListener("scroll", e);
}
const mn = "rich-text", vn = "hero__text", pn = "mobile", kn = "tablet", Ln = "desktop", hn = "button__text-primary", En = "button__title", Sn = "button__title__map", wn = "button__heroTitle", yn = "heading__page", fn = "heading__section", Mn = "heading__menu", bn = "texts__component_title", xn = "navigation__language-picker--dropdown__link", Hn = "texts__component_title--bold", Cn = "texts__lead_text", Nn = "page__lead_text", In = "texts__lead_text--bold", Dn = "texts__paragraph_subtitle", Pn = "texts__paragraph_subtitle--bold", On = "texts__body_text", Tn = "texts__body_text--bold", An = "texts__link", Bn = "texts__caption", $n = "texts__caption--bold", Fn = "page__heading", Un = "navigation__language-picker", Rn = "navigation__language-picker__button", Vn = "navigation__language-picker--dropdown", zn = "navigation__language-picker--dropdown__heading", Wn = "navigation__language-picker--dropdown__list", Navigation_N = {
  richText: mn,
  heroText: vn,
  mobile: pn,
  tablet: kn,
  desktop: Ln,
  buttonTextPrimary: hn,
  buttonTitle: En,
  buttonTitleMap: Sn,
  buttonHeroTitle: wn,
  headingPage: yn,
  headingSection: fn,
  headingMenu: Mn,
  textsComponentTitle: bn,
  navigationLanguagePickerDropdownLink: xn,
  textsComponentTitleBold: Hn,
  textsLeadText: Cn,
  pageLeadText: Nn,
  textsLeadTextBold: In,
  textsParagraphSubtitle: Dn,
  textsParagraphSubtitleBold: Pn,
  textsBodyText: On,
  textsBodyTextBold: Tn,
  textsLink: An,
  textsCaption: Bn,
  textsCaptionBold: $n,
  pageHeading: Fn,
  navigationLanguagePicker: Un,
  navigationLanguagePickerButton: Rn,
  navigationLanguagePickerDropdown: Vn,
  navigationLanguagePickerDropdownHeading: zn,
  navigationLanguagePickerDropdownList: Wn
};
function Yn({
  currentLanguage: e,
  availableLanguages: i,
  currentUrlPath: t,
  isNavigationHidden: a,
  i18n: o
}) {
  const c = (0,react.useId)(), s = `language-picker-${c}`, r = `language-picker-button-${c}`, _ = `language-picker-dropdown-${c}`, { selectLanguageLabel: m = "Select language" } = o || {}, {
    isDropdownOpen: v,
    closeDropdown: p,
    toggleDropdownOpen: d,
    buttonRef: l,
    dropdownRef: y
  } = Kn(a);
  return i.length < 2 ? null : /* @__PURE__ */ react.createElement("div", { id: s, className: Navigation_N.navigationLanguagePicker }, /* @__PURE__ */ react.createElement(
    "button",
    {
      id: r,
      className: (0,useKeyDown_88662051.c)(
        Navigation_N.navigationLanguagePickerButton,
        v ? useKeyDown_88662051.t.textsLeadTextBold : useKeyDown_88662051.t.textsLeadText
      ),
      "aria-expanded": v,
      "aria-controls": _,
      onClick: d,
      type: "button",
      ref: l
    },
    /* @__PURE__ */ react.createElement("span", null, e.toUpperCase()),
    /* @__PURE__ */ react.createElement(Icon_e01b6482.I, { icon: Icon_e01b6482.W.GLOBE, size: 24 })
  ), /* @__PURE__ */ react.createElement(
    "div",
    {
      id: _,
      className: Navigation_N.navigationLanguagePickerDropdown,
      "data-open": v,
      role: "listbox",
      "aria-activedescendant": `${_}-${e}`,
      ref: y
    },
    /* @__PURE__ */ react.createElement(
      "div",
      {
        className: (0,useKeyDown_88662051.c)(
          useKeyDown_88662051.t.headingSection,
          Navigation_N.navigationLanguagePickerDropdownHeading
        )
      },
      m
    ),
    /* @__PURE__ */ react.createElement("ul", { className: Navigation_N.navigationLanguagePickerDropdownList }, i.map((M) => /* @__PURE__ */ react.createElement(
      Gn,
      {
        key: M.code,
        ...M,
        closeDropdown: p,
        currentLanguage: e,
        currentUrlPath: t,
        dropdownId: _
      }
    )))
  ));
}
function Gn({
  code: e,
  label: i,
  currentLanguage: t,
  currentUrlPath: a,
  closeDropdown: o,
  dropdownId: c
}) {
  const s = `${c}-${e}`, r = e === t;
  return /* @__PURE__ */ react.createElement(
    Link_460da2fc.L,
    {
      key: e,
      id: s,
      className: Navigation_N.navigationLanguagePickerDropdownLink,
      "aria-selected": r,
      locale: e,
      href: a,
      disableLinkTextStyle: !0,
      role: "listitem",
      onClick: o
    },
    e.toUpperCase(),
    " - ",
    i
  );
}
function Kn(e) {
  const [i, t] = (0,react.useState)(!1), a = (0,react.useCallback)(
    () => t((r) => !r),
    []
  ), o = (0,react.useCallback)(() => t(!1), []), c = (0,react.useRef)(null), s = (0,react.useRef)(null);
  return (0,react.useEffect)(() => {
    e && o();
  }, [e, o]), (0,useClickOutside_55c64a80.u)([c, s], o), {
    isDropdownOpen: i,
    toggleDropdownOpen: a,
    closeDropdown: o,
    buttonRef: c,
    dropdownRef: s
  };
}
const jn = "navigation__switch_link", qn = "navigation__links_section", Jn = "navigation__links_section--mobile-only", Qn = "desktop", Xn = "navigation__links_section__link", Zn = "navigation__links_section__link--primary", ne = "navigation__links_section__link--secondary", ee = "navigation__links_section__link--mobile-only", te = "navigation__modal", Navigation_I = {
  navigationSwitchLink: jn,
  navigationLinksSection: qn,
  navigationLinksSectionMobileOnly: Jn,
  desktop: Qn,
  navigationLinksSectionLink: Xn,
  navigationLinksSectionLinkPrimary: Zn,
  navigationLinksSectionLinkSecondary: ne,
  navigationLinksSectionLinkMobileOnly: ee,
  navigationModal: te
};
function Navigation_W(e) {
  return /* @__PURE__ */ react.createElement(
    "nav",
    {
      key: e.id,
      className: (0,useKeyDown_88662051.c)(
        Navigation_I.navigationLinksSection,
        e.isMobileOnly && Navigation_I.navigationLinksSectionMobileOnly
      )
    },
    /* @__PURE__ */ react.createElement(K, { key: `${e.id}-primary`, ...e, isPrimary: !0 }),
    X(e).map((i) => /* @__PURE__ */ react.createElement(
      K,
      {
        key: i.id,
        ...i,
        closeMenu: e.closeMenu
      }
    ))
  );
}
function K({
  id: e,
  href: i,
  locale: t,
  title: a,
  isPrimary: o,
  isMobileOnly: c,
  closeMenu: s
}) {
  const r = (0,useKeyDown_88662051.c)(
    Navigation_I.navigationLinksSectionLink,
    o ? Navigation_I.navigationLinksSectionLinkPrimary : Navigation_I.navigationLinksSectionLinkSecondary,
    o ? useKeyDown_88662051.t.textsLeadTextBold : useKeyDown_88662051.t.textsLeadText,
    c && Navigation_I.navigationLinksSectionLinkMobileOnly
  );
  return /* @__PURE__ */ react.createElement(
    Link_460da2fc.L,
    {
      key: e,
      href: i,
      locale: t,
      itemProp: "url",
      className: r,
      disableLinkTextStyle: !0,
      onClick: s
    },
    /* @__PURE__ */ react.createElement("span", { itemProp: "name" }, a),
    /* @__PURE__ */ react.createElement(Icon_e01b6482.I, { icon: Icon_e01b6482.W.ARROW_RIGHT, size: 20 })
  );
}
function X(e) {
  return e.subPages?.flatMap((i) => [
    i,
    ...X(i)
  ]) || [];
}
const ie = "navigation__links", oe = "desktop", ae = "navigation__links__link", ce = "navigation__links__dropdown", se = "navigation__links__dropdown--employer", re = "navigation__links__dropdown__main", le = "navigation__links__dropdown__featured", de = "navigation__links__dropdown__featured__image", ge = "navigation__links__dropdown__featured__link", Navigation_b = {
  navigationLinks: ie,
  desktop: oe,
  navigationLinksLink: ae,
  navigationLinksDropdown: ce,
  navigationLinksDropdownEmployer: se,
  navigationLinksDropdownMain: re,
  navigationLinksDropdownFeatured: le,
  navigationLinksDropdownFeaturedImage: de,
  navigationLinksDropdownFeaturedLink: ge
};
function _e({
  links: e,
  isNavigationHidden: i,
  i18n: t,
  currentPageId: a
}) {
  return /* @__PURE__ */ react.createElement(
    "nav",
    {
      className: Navigation_b.navigationLinks,
      "data-testid": "navigation-links",
      role: "navigation",
      itemScope: !0,
      itemType: "https://schema.org/SiteNavigationElement"
    },
    e.map((o) => /* @__PURE__ */ react.createElement(
      ue,
      {
        key: o.id,
        ...o,
        isNavigationHidden: i,
        i18n: t,
        currentPageId: a
      }
    ))
  );
}
function ue({
  id: e,
  href: i,
  locale: t,
  title: a,
  subPages: o,
  featured: c,
  isNavigationHidden: s,
  i18n: r,
  currentPageId: _
}) {
  const { isHovering: m, ref: v } = (0,Logo_8772aba7.u)(), {
    isHovering: p,
    ref: d,
    setIsHovering: l
  } = (0,Logo_8772aba7.u)(), y = !s && (m || p), M = (0,react.useCallback)(
    () => l(!1),
    [l]
  );
  return /* @__PURE__ */ react.createElement("li", { role: "none" }, /* @__PURE__ */ react.createElement(
    Link_460da2fc.L,
    {
      ref: v,
      disableLinkTextStyle: !0,
      itemProp: "url",
      href: i,
      locale: t,
      "data-title": a,
      className: (0,useKeyDown_88662051.c)(
        Navigation_b.navigationLinksLink,
        y || _ === e ? useKeyDown_88662051.t.textsLeadTextBold : useKeyDown_88662051.t.textsLeadText
      )
    },
    /* @__PURE__ */ react.createElement("span", { itemProp: "name" }, a)
  ), /* @__PURE__ */ react.createElement("div", { ref: d, role: "none" }, o && o.length > 0 && y ? /* @__PURE__ */ react.createElement(
    me,
    {
      links: o,
      featured: c,
      i18n: r,
      closeMenu: M
    }
  ) : null));
}
function me({
  links: e,
  featured: i,
  i18n: t,
  closeMenu: a
}) {
  const o = (0,app_51178863.u)();
  return /* @__PURE__ */ react.createElement(
    "section",
    {
      className: (0,useKeyDown_88662051.c)(
        Navigation_b.navigationLinksDropdown,
        o && Navigation_b.navigationLinksDropdownEmployer
      )
    },
    /* @__PURE__ */ react.createElement(
      useClickOutside_55c64a80.B,
      {
        as: "aside",
        className: Navigation_b.navigationLinksDropdownMain,
        topPadding: useClickOutside_55c64a80.B.Padding.NONE,
        bottomPadding: useClickOutside_55c64a80.B.Padding.NONE
      },
      /* @__PURE__ */ react.createElement(useClickOutside_55c64a80.B.Content, null, e.map((c) => /* @__PURE__ */ react.createElement(Navigation_W, { key: c.id, ...c, closeMenu: a })), i ? /* @__PURE__ */ react.createElement(ve, { ...i, i18n: t }) : null)
    )
  );
}
function ve({
  image: e,
  linkUrl: i,
  title: t,
  i18n: a
}) {
  const { featureArticleText: o = "Feature article", readMoreText: c = "Read more" } = a || {};
  return /* @__PURE__ */ react.createElement("div", { className: Navigation_b.navigationLinksDropdownFeatured }, /* @__PURE__ */ react.createElement(
    Image_be3826ec.I,
    {
      ...e,
      className: Navigation_b.navigationLinksDropdownFeaturedImage
    }
  ), /* @__PURE__ */ react.createElement("span", null, o, ": ", t), /* @__PURE__ */ react.createElement(
    Link_460da2fc.L,
    {
      href: i,
      className: Navigation_b.navigationLinksDropdownFeaturedLink
    },
    c
  ));
}
const pe = "navigation__header", ke = "navigation__header--modal-open", Le = "desktop", he = "navigation__header--visible", Ee = "navigation__header--show", Se = "animateShow", we = "navigation__header--hide", ye = "animateHide", fe = "navigation__header--employers", Me = "navigation__header__content", be = "navigation__header__logo", xe = "navigation__header__actions", He = "navigation__header__search", Ce = "navigation__header__menu", Ne = "navigation__header__search--employers", Ie = "navigation__header__menu--employers", De = "navigation__header__saved_items_link", Pe = "navigation__header__saved_items_link__with-dot", Navigation_k = {
  navigationHeader: pe,
  navigationHeaderModalOpen: ke,
  desktop: Le,
  navigationHeaderVisible: he,
  navigationHeaderShow: Ee,
  animateShow: Se,
  navigationHeaderHide: we,
  animateHide: ye,
  navigationHeaderEmployers: fe,
  navigationHeaderContent: Me,
  navigationHeaderLogo: be,
  navigationHeaderActions: xe,
  navigationHeaderSearch: He,
  navigationHeaderMenu: Ce,
  navigationHeaderSearchEmployers: Ne,
  navigationHeaderMenuEmployers: Ie,
  navigationHeaderSavedItemsLink: De,
  navigationHeaderSavedItemsLinkWithDot: Pe
}, Oe = "contact__us", Te = "contact__us__link", Ae = "contact__us__dropdown", Be = "contact__us__dropdown--employer", $e = "contact__us__dropdown__main", Fe = "contact__us__dropdown__featured", Ue = "contact__us__dropdown__featured__image", Re = "contact__us__dropdown__featured__link", Ve = "contact__us__dropdown__footer", Navigation_x = {
  contactUs: Oe,
  contactUsLink: Te,
  contactUsDropdown: Ae,
  contactUsDropdownEmployer: Be,
  contactUsDropdownMain: $e,
  contactUsDropdownFeatured: Fe,
  contactUsDropdownFeaturedImage: Ue,
  contactUsDropdownFeaturedLink: Re,
  contactUsDropdownFooter: Ve
};
function ze({
  links: e,
  isContactUsHidden: i,
  i18n: t,
  currentPageId: a,
  isMobile: o
}) {
  const { isHovering: c, ref: s } = (0,Logo_8772aba7.u)({ disableFocusEvent: o }), {
    isHovering: r,
    ref: _,
    setIsHovering: m
  } = (0,Logo_8772aba7.u)(), [v, p] = (0,react.useState)(!1), d = (0,react.useMemo)(() => o ? !i && v : !i && (c || r), [
    v,
    i,
    r,
    c,
    o
  ]), l = (0,react.useCallback)(() => {
    m(!1), p(!1);
  }, [m]), y = (0,react.useMemo)(() => [
    { ...e[0], subPages: [], isMobileOnly: !0 },
    ...e[0]?.subPages || []
  ], [e]), M = (0,react.useCallback)(
    ($) => {
      o && (p((D) => !D), $.preventDefault());
    },
    [o]
  );
  return /* @__PURE__ */ react.createElement("div", { className: Navigation_x.contactUs, ref: s }, /* @__PURE__ */ react.createElement(
    Link_460da2fc.L,
    {
      href: e[0]?.href,
      disableLinkTextStyle: !0,
      onClick: M,
      title: e[0]?.title,
      className: (0,useKeyDown_88662051.c)(
        Navigation_x.contactUsLink,
        d || a === e[0]?.id ? useKeyDown_88662051.t.textsLeadTextBold : useKeyDown_88662051.t.textsLeadText
      )
    },
    /* @__PURE__ */ react.createElement(Icon_e01b6482.I, { icon: Icon_e01b6482.W.CONTACT, size: 24 })
  ), /* @__PURE__ */ react.createElement("div", { ref: _, role: "none" }, e[0]?.subPages && e[0]?.subPages?.length > 0 && d ? /* @__PURE__ */ react.createElement(
    We,
    {
      links: y,
      featured: e[0]?.featured,
      i18n: t,
      closeMenu: l
    }
  ) : null));
}
function We({
  links: e,
  featured: i,
  i18n: t,
  closeMenu: a
}) {
  const o = (0,app_51178863.u)();
  return /* @__PURE__ */ react.createElement(
    "section",
    {
      className: (0,useKeyDown_88662051.c)(
        Navigation_x.contactUsDropdown,
        o && Navigation_x.contactUsDropdownEmployer
      )
    },
    /* @__PURE__ */ react.createElement(
      useClickOutside_55c64a80.B,
      {
        as: "aside",
        className: Navigation_x.contactUsDropdownMain,
        topPadding: useClickOutside_55c64a80.B.Padding.NONE,
        bottomPadding: useClickOutside_55c64a80.B.Padding.NONE
      },
      /* @__PURE__ */ react.createElement(useClickOutside_55c64a80.B.Content, null, e.map((c) => /* @__PURE__ */ react.createElement(Navigation_W, { key: c?.id, ...c, closeMenu: a })), i ? /* @__PURE__ */ react.createElement(Ye, { ...i, i18n: t }) : null)
    )
  );
}
function Ye({
  image: e,
  linkUrl: i,
  title: t,
  i18n: a
}) {
  const { featureArticleText: o = "Feature article", readMoreText: c = "Read more" } = a || {};
  return /* @__PURE__ */ react.createElement("div", { className: Navigation_x.contactUsDropdownFeatured }, /* @__PURE__ */ react.createElement(
    Image_be3826ec.I,
    {
      ...e,
      className: Navigation_x.contactUsDropdownFeaturedImage
    }
  ), /* @__PURE__ */ react.createElement("span", null, o, ": ", t), /* @__PURE__ */ react.createElement(
    Link_460da2fc.L,
    {
      href: i,
      className: Navigation_x.contactUsDropdownFeaturedLink
    },
    c
  ));
}
const Ge = "top-bar", Ke = "top-bar__switchLinks", je = "top-bar__link", qe = "top-bar__link--active", A = {
  topBar: Ge,
  topBarSwitchLinks: Ke,
  topBarLink: je,
  topBarLinkActive: qe
}, Je = (e) => {
  const { switchLinks: i } = e;
  return /* @__PURE__ */ react.createElement("section", { className: A.topBar }, /* @__PURE__ */ react.createElement("nav", { className: A.topBarSwitchLinks }, i.map((t, a) => /* @__PURE__ */ react.createElement(
    Link_460da2fc.L,
    {
      key: t.id,
      href: t.href,
      locale: t.locale,
      className: (0,useKeyDown_88662051.c)(
        A.topBarLink,
        t.isActive && A.topBarLinkActive
      ),
      disabled: t.isActive,
      disableLinkTextStyle: !0
    },
    a === 0 ? /* @__PURE__ */ react.createElement(Icon_e01b6482.I, { icon: Icon_e01b6482.W.EMPLOYEE }) : /* @__PURE__ */ react.createElement(Icon_e01b6482.I, { icon: Icon_e01b6482.W.EMPLOYER }),
    /* @__PURE__ */ react.createElement("span", null, t.title)
  ))));
};
function Qe(e) {
  const {
    isSearchDisabled: i,
    links: t,
    logoHref: a,
    onLogoClick: o,
    languagePickerOptions: c,
    isSearchOpen: s,
    onSearchClick: r,
    isMenuOpen: _,
    onMenuClick: m,
    i18n: v,
    switchLinks: p,
    savedItems: d,
    currentPageId: l,
    isMobile: y
  } = e, { headerRef: M, headerClassName: $, isHeaderHidden: D } = tt(), en = (0,app_51178863.u)();
  return /* @__PURE__ */ react.createElement(
    useClickOutside_55c64a80.B,
    {
      as: "header",
      blockRef: M,
      className: (0,useKeyDown_88662051.c)(
        $,
        (_ || s) && Navigation_k.navigationHeaderModalOpen
      ),
      "data-testid": "navigation",
      topPadding: useClickOutside_55c64a80.B.Padding.NONE,
      bottomPadding: useClickOutside_55c64a80.B.Padding.NONE
    },
    /* @__PURE__ */ react.createElement(Je, { switchLinks: p }),
    /* @__PURE__ */ react.createElement(useClickOutside_55c64a80.B.Content, { className: Navigation_k.navigationHeaderContent }, /* @__PURE__ */ react.createElement(Xe, { onClick: o, href: a }), /* @__PURE__ */ react.createElement(
      _e,
      {
        links: t?.filter((F) => F?.id !== "ota-yhteytta"),
        isNavigationHidden: D,
        i18n: v,
        currentPageId: l
      }
    ), /* @__PURE__ */ react.createElement("div", { className: Navigation_k.navigationHeaderActions }, en && /* @__PURE__ */ react.createElement(
      ze,
      {
        links: t?.filter((F) => F?.id === "ota-yhteytta"),
        isContactUsHidden: D,
        i18n: v,
        currentPageId: l,
        isMobile: y
      }
    ), c ? /* @__PURE__ */ react.createElement(
      Yn,
      {
        ...c,
        isNavigationHidden: D,
        i18n: v
      }
    ) : null, d ? /* @__PURE__ */ react.createElement(et, { ...d }) : null, i ? null : /* @__PURE__ */ react.createElement(
      Ze,
      {
        isSearchOpen: s,
        onSearchClick: r
      }
    ), /* @__PURE__ */ react.createElement(nt, { isMenuOpen: _, onMenuClick: m })))
  );
}
function Xe({
  href: e,
  onClick: i
}) {
  const t = (0,app_51178863.u)();
  return /* @__PURE__ */ react.createElement(
    Link_460da2fc.L,
    {
      href: e,
      className: Navigation_k.navigationHeaderLogo,
      disableLinkTextStyle: !0,
      "data-testid": "navigation-logo",
      title: "Work in Finland logo",
      onClick: i
    },
    /* @__PURE__ */ react.createElement(Logo_8772aba7.L, { color: t ? "secondary" : "primary" })
  );
}
function Ze({
  isSearchOpen: e,
  onSearchClick: i
}) {
  const t = (0,app_51178863.u)();
  return /* @__PURE__ */ react.createElement(
    "button",
    {
      type: "button",
      title: "Search",
      className: (0,useKeyDown_88662051.c)(
        Navigation_k.navigationHeaderSearch,
        t && Navigation_k.navigationHeaderSearchEmployers
      ),
      onClick: i
    },
    /* @__PURE__ */ react.createElement(Icon_e01b6482.I, { icon: e ? Icon_e01b6482.W.CLOSE : Icon_e01b6482.W.SEARCH, size: 24 })
  );
}
function nt({
  isMenuOpen: e,
  onMenuClick: i
}) {
  const t = (0,app_51178863.u)();
  return /* @__PURE__ */ react.createElement(
    "button",
    {
      type: "button",
      title: "Menu",
      className: (0,useKeyDown_88662051.c)(
        Navigation_k.navigationHeaderMenu,
        t && Navigation_k.navigationHeaderMenuEmployers
      ),
      onClick: i
    },
    /* @__PURE__ */ react.createElement(Icon_e01b6482.I, { icon: e ? Icon_e01b6482.W.CLOSE : Icon_e01b6482.W.HAMBURGER, size: 20 })
  );
}
function et({
  href: e,
  isEmpty: i,
  title: t = "Saved Items"
}) {
  return /* @__PURE__ */ react.createElement(
    Link_460da2fc.L,
    {
      href: e,
      title: t,
      "data-testid": "navigation-save-button",
      className: (0,useKeyDown_88662051.c)(
        Navigation_k.navigationHeaderSavedItemsLink,
        !i && Navigation_k.navigationHeaderSavedItemsLinkWithDot
      )
    },
    /* @__PURE__ */ react.createElement(Icon_e01b6482.I, { icon: Icon_e01b6482.W.HEART, size: 24 })
  );
}
function tt() {
  const e = (0,react.useRef)(null), i = _n(e), t = (0,app_51178863.u)(), a = i === "init", o = i === "down", c = i === "up", s = (0,useKeyDown_88662051.c)(
    Navigation_k.navigationHeader,
    useKeyDown_88662051.t.textsLeadText,
    t && Navigation_k.navigationHeaderEmployers,
    a && Navigation_k.navigationHeaderVisible,
    c && Navigation_k.navigationHeaderShow,
    o && Navigation_k.navigationHeaderHide
  );
  return { headerRef: e, headerClassName: s, isHeaderHidden: o };
}
const it = "accordion", ot = "accordion__item", at = "accordion__item__heading", ct = "active", st = "accordion__item__content", rt = "accordion__item__content--expanded", P = {
  accordion: it,
  accordionItem: ot,
  accordionItemHeading: at,
  active: ct,
  accordionItemContent: st,
  accordionItemContentExpanded: rt
}, Z = (0,react.createContext)(void 0);
function lt(e = {}, i) {
  const { collapsible: t = !1, multiple: a = !1, defaultActiveId: o } = e, [c, s] = (0,react.useState)(
    () => Navigation_U(e)
  ), r = (0,react.useMemo)(() => (react.Children.map(i, (l) => {
    if (l && typeof l == "object" && "type" in l)
      return l.props?.id;
  }) || []).filter(Boolean), [i]), _ = (0,react.useCallback)(
    (d) => {
      s((l) => a ? l.includes(d) ? !t && l.length === 1 ? l : l.filter((y) => y !== d) : [...l, d] : t ? l.includes(d) ? [] : [d] : [d]);
    },
    [t, a]
  ), m = (0,react.useCallback)(() => {
    s(Navigation_U({ defaultActiveId: o, collapsible: t }));
  }, [o, t]), v = (0,react.useCallback)(
    () => s(
      t ? [] : Navigation_U({ defaultActiveId: o, collapsible: t })
    ),
    [o, t]
  ), p = (0,react.useCallback)(() => {
    a && s(r);
  }, [a, r]);
  return { activeIds: c, toggleId: _, resetIds: m, collapseAll: v, expandAll: p };
}
function Navigation_U({
  defaultActiveId: e,
  collapsible: i,
  allIds: t = []
} = {}) {
  if (e)
    return [e];
  if (i)
    return [];
  const a = t[0];
  return a ? [a] : [];
}
function nn({
  id: e,
  heading: i,
  children: t,
  className: a,
  disabled: o
}) {
  const c = (0,react.useContext)(Z);
  if (!c)
    throw new Error("Accordion.Item must be used within Accordion");
  const { activeIds: s, toggleId: r, id: _ } = c, m = s.includes(e), v = {
    expanded: m,
    toggleItem: () => r(e)
  }, p = _ + "-item-" + e, d = _ + "-item-" + e + "-label", l = _ + "-item-" + e + "-content";
  return /* @__PURE__ */ react.createElement(
    "div",
    {
      id: p,
      "aria-expanded": m,
      className: (0,useKeyDown_88662051.c)(P.accordionItem),
      "data-testid": "accordion-item"
    },
    /* @__PURE__ */ react.createElement(
      "button",
      {
        id: d,
        className: (0,useKeyDown_88662051.c)(
          P.accordionItemHeading,
          m && "active",
          o && "disabled"
        ),
        onClick: () => r(e),
        disabled: o,
        "aria-controls": l,
        "aria-expanded": m,
        "data-testid": "accordion-toggler"
      },
      typeof i != "string" ? (0,react.createElement)(i, v) : i
    ),
    /* @__PURE__ */ react.createElement(
      "div",
      {
        id: l,
        className: (0,useKeyDown_88662051.c)(
          P.accordionItemContent,
          m && P.accordionItemContentExpanded,
          a
        ),
        role: "region",
        "aria-labelledby": d,
        "data-testid": "accordion-item-content-expanded"
      },
      t
    )
  );
}
function Navigation_z({
  className: e,
  children: i,
  collapsible: t,
  multiple: a,
  defaultActiveId: o,
  ...c
}) {
  (0,Logo_8772aba7.b)(i, nn, "Accordion");
  const s = (0,react.useId)(), r = lt(
    {
      collapsible: t,
      multiple: a,
      defaultActiveId: o
    },
    i
  );
  return /* @__PURE__ */ react.createElement(
    "div",
    {
      className: (0,useKeyDown_88662051.c)(P.accordion, e),
      ...c,
      "data-testid": "accordion"
    },
    /* @__PURE__ */ react.createElement(
      Z.Provider,
      {
        value: { ...r, id: c.id || s }
      },
      i
    )
  );
}
Navigation_z.Item = nn;
const dt = "navigation__switch_link", gt = "navigation__links_section", _t = "navigation__links_section--mobile-only", ut = "desktop", mt = "navigation__links_section__link", vt = "navigation__links_section__link--primary", pt = "navigation__links_section__link--secondary", kt = "navigation__links_section__link--mobile-only", Lt = "navigation__modal", ht = "navigation__menu", Et = "navigation__menu__switchLinks", St = "navigation__menu__switchLinks__content", wt = "navigation__menu__switchLinks__link", yt = "navigation__menu__switchLinks__link--active", ft = "navigation__menu__accordion", Mt = "navigation__menu__accordion__heading", bt = "navigation__menu__accordion__heading__container", xt = "navigation__menu__accordion__heading__link", Ht = "navigation__menu__accordion__heading__icon", Ct = "navigation__menu__accordion__content", Nt = "navigation__menu__accordion__content--employers", It = "navigation__menu__accordion__content__container", Dt = "navigation__menu__footer", Navigation_h = {
  navigationSwitchLink: dt,
  navigationLinksSection: gt,
  navigationLinksSectionMobileOnly: _t,
  desktop: ut,
  navigationLinksSectionLink: mt,
  navigationLinksSectionLinkPrimary: vt,
  navigationLinksSectionLinkSecondary: pt,
  navigationLinksSectionLinkMobileOnly: kt,
  navigationModal: Lt,
  navigationMenu: ht,
  navigationMenuSwitchLinks: Et,
  navigationMenuSwitchLinksContent: St,
  navigationMenuSwitchLinksLink: wt,
  navigationMenuSwitchLinksLinkActive: yt,
  navigationMenuAccordion: ft,
  navigationMenuAccordionHeading: Mt,
  navigationMenuAccordionHeadingContainer: bt,
  navigationMenuAccordionHeadingLink: xt,
  navigationMenuAccordionHeadingIcon: Ht,
  navigationMenuAccordionContent: Ct,
  navigationMenuAccordionContentEmployers: Nt,
  navigationMenuAccordionContentContainer: It,
  navigationMenuFooter: Dt
};
function Pt(e) {
  const { links: i = [], closeMenu: t, switchLinks: a, currentPageId: o } = e, c = (0,Logo_8772aba7.a)(), s = (0,app_51178863.u)();
  return /* @__PURE__ */ react.createElement(
    useModal_5a548e10.M,
    {
      className: Navigation_h.navigationMenu,
      "data-testid": "menu-mobile",
      modalRef: c,
      closeModal: t
    },
    /* @__PURE__ */ react.createElement(Ot, { switchLinks: a, closeMenu: t }),
    /* @__PURE__ */ react.createElement(
      Navigation_z,
      {
        className: Navigation_h.navigationMenuAccordion,
        defaultActiveId: o || i?.[0]?.id,
        collapsible: !0,
        "data-testid": "menu-mobile-accordion"
      },
      i?.filter((r) => r?.id !== "ota-yhteytta")?.map(({ id: r, title: _, href: m, locale: v, subPages: p = [] }) => {
        const d = p.length === 0;
        return /* @__PURE__ */ react.createElement(
          Navigation_z.Item,
          {
            key: r,
            id: r,
            disabled: d,
            heading: ({ expanded: l }) => /* @__PURE__ */ react.createElement(
              Tt,
              {
                expanded: l,
                href: m,
                locale: v,
                closeMenu: t,
                hideIcon: d
              },
              _
            )
          },
          d ? null : /* @__PURE__ */ react.createElement(
            useClickOutside_55c64a80.B,
            {
              className: (0,useKeyDown_88662051.c)(
                Navigation_h.navigationMenuAccordionContent,
                s && Navigation_h.navigationMenuAccordionContentEmployers
              ),
              topPadding: useClickOutside_55c64a80.B.Padding.NONE,
              bottomPadding: useClickOutside_55c64a80.B.Padding.NONE
            },
            /* @__PURE__ */ react.createElement(
              useClickOutside_55c64a80.B.Content,
              {
                className: Navigation_h.navigationMenuAccordionContentContainer
              },
              p.map((l) => /* @__PURE__ */ react.createElement(
                Navigation_W,
                {
                  key: l.id,
                  ...l,
                  closeMenu: t
                }
              ))
            )
          )
        );
      })
    )
  );
}
const Ot = ({
  switchLinks: e,
  closeMenu: i
}) => /* @__PURE__ */ react.createElement(
  useClickOutside_55c64a80.B,
  {
    topPadding: useClickOutside_55c64a80.B.Padding.NONE,
    bottomPadding: useClickOutside_55c64a80.B.Padding.NONE,
    className: Navigation_h.navigationMenuSwitchLinks
  },
  /* @__PURE__ */ react.createElement(useClickOutside_55c64a80.B.Content, { flex: !0, className: Navigation_h.navigationMenuSwitchLinksContent }, e.map((t) => /* @__PURE__ */ react.createElement(
    Link_460da2fc.L,
    {
      key: t.id,
      href: t.href,
      onClick: t.isActive ? void 0 : i,
      className: (0,useKeyDown_88662051.c)(
        Navigation_h.navigationMenuSwitchLinksLink,
        t.isActive && Navigation_h.navigationMenuSwitchLinksLinkActive
      ),
      disabled: t.isActive,
      disableLinkTextStyle: !0,
      itemProp: "url"
    },
    /* @__PURE__ */ react.createElement("span", { itemProp: "name" }, t.title)
  )))
);
function Tt({
  expanded: e,
  children: i,
  href: t,
  locale: a,
  closeMenu: o,
  hideIcon: c
}) {
  return /* @__PURE__ */ react.createElement(useClickOutside_55c64a80.B, { className: Navigation_h.navigationMenuAccordionHeading }, /* @__PURE__ */ react.createElement(
    useClickOutside_55c64a80.B.Content,
    {
      flex: !0,
      className: Navigation_h.navigationMenuAccordionHeadingContainer
    },
    /* @__PURE__ */ react.createElement(
      Link_460da2fc.L,
      {
        href: t,
        onClick: o,
        locale: a,
        title: i,
        disableLinkTextStyle: !0,
        className: (0,useKeyDown_88662051.c)(
          Navigation_h.navigationMenuAccordionHeadingLink,
          e ? useKeyDown_88662051.t.headingSection : useKeyDown_88662051.t.headingMenu
        ),
        itemProp: "url"
      },
      /* @__PURE__ */ react.createElement("span", { itemProp: "name" }, i)
    ),
    c ? null : /* @__PURE__ */ react.createElement(
      Icon_e01b6482.I,
      {
        className: Navigation_h.navigationMenuAccordionHeadingIcon,
        icon: e ? Icon_e01b6482.W.CHEVRON_UP : Icon_e01b6482.W.CHEVRON_DOWN,
        size: 16
      }
    )
  ));
}
const At = "navigation__switch_link", Bt = "navigation__links_section", $t = "navigation__links_section--mobile-only", Ft = "desktop", Ut = "navigation__links_section__link", Rt = "navigation__links_section__link--primary", Vt = "navigation__links_section__link--secondary", zt = "navigation__links_section__link--mobile-only", Wt = "navigation__modal", Yt = "navigation__search", Gt = "navigation__search__content", Kt = "navigation__search__input", jt = "navigation__search__input__button", qt = "navigation__search__input__field", O = {
  navigationSwitchLink: At,
  navigationLinksSection: Bt,
  navigationLinksSectionMobileOnly: $t,
  desktop: Ft,
  navigationLinksSectionLink: Ut,
  navigationLinksSectionLinkPrimary: Rt,
  navigationLinksSectionLinkSecondary: Vt,
  navigationLinksSectionLinkMobileOnly: zt,
  navigationModal: Wt,
  navigationSearch: Yt,
  navigationSearchContent: Gt,
  navigationSearchInput: Kt,
  navigationSearchInputButton: jt,
  navigationSearchInputField: qt
};
function Jt({
  defaultKeyword: e = "",
  closeSearch: i,
  renderContent: t
}) {
  const a = (0,Logo_8772aba7.a)(), [o, c] = (0,react.useState)(e);
  return /* @__PURE__ */ react.createElement(
    useModal_5a548e10.M,
    {
      className: O.navigationSearch,
      "data-testid": "search",
      modalRef: a,
      closeModal: i
    },
    /* @__PURE__ */ react.createElement(useClickOutside_55c64a80.B, { topPadding: useClickOutside_55c64a80.a.NONE, bottomPadding: useClickOutside_55c64a80.a.NONE }, /* @__PURE__ */ react.createElement(useClickOutside_55c64a80.B.Content, { className: O.navigationSearchContent }, /* @__PURE__ */ react.createElement(Qt, { onChange: c, defaultValue: e }))),
    t({ keyword: o, closeModal: i })
  );
}
function Qt({
  onChange: e,
  defaultValue: i,
  placeholder: t = "Search for keywords..."
}) {
  const [a, o] = (0,react.useState)(i), [, c] = (0,react.useTransition)(), s = (0,react.useRef)(null), r = (0,react.useCallback)(() => {
    o(""), s.current?.focus();
  }, []);
  return (0,react.useEffect)(() => {
    c(() => e(a));
  }, [e, a]), (0,react.useEffect)(() => {
    s.current?.focus();
  }, []), /* @__PURE__ */ react.createElement(
    "div",
    {
      className: (0,useKeyDown_88662051.c)(O.navigationSearchInput),
      "data-testid": "search-input"
    },
    /* @__PURE__ */ react.createElement(
      "button",
      {
        title: "Search",
        onClick: r,
        "data-testid": "search-input-button",
        className: O.navigationSearchInputButton
      },
      /* @__PURE__ */ react.createElement(
        Icon_e01b6482.I,
        {
          icon: a.length > 0 ? Icon_e01b6482.W.CLOSE : Icon_e01b6482.W.SEARCH,
          size: 24
        }
      )
    ),
    /* @__PURE__ */ react.createElement(
      "input",
      {
        type: "text",
        ref: s,
        value: a,
        onChange: (_) => o(_.target.value),
        placeholder: t,
        "data-testid": "search-input-field",
        className: (0,useKeyDown_88662051.c)(
          O.navigationSearchInputField,
          useKeyDown_88662051.t.textsComponentTitle
        )
      }
    )
  );
}
function di(e) {
  const {
    isMenuOpen: i,
    isSearchOpen: t,
    toggleMenuOpen: a,
    toggleSearchOpen: o,
    closeMenu: c,
    closeSearch: s,
    closeAllModals: r
  } = Xt();
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(
    Qe,
    {
      ...e,
      isMenuOpen: i,
      onMenuClick: a,
      isSearchOpen: t,
      onSearchClick: o,
      onLogoClick: r
    }
  ), i ? /* @__PURE__ */ react.createElement(
    Pt,
    {
      links: e.links,
      switchLinks: e.switchLinks,
      closeMenu: c,
      currentPageId: e.currentPageId
    }
  ) : null, t ? /* @__PURE__ */ react.createElement(
    Jt,
    {
      closeSearch: s,
      renderContent: e.searchContent,
      defaultKeyword: e.defaultSearchKeyword
    }
  ) : null);
}
function Xt() {
  const e = (0,react.useRef)(void 0), i = (0,react.useRef)(void 0), {
    isModalOpen: t,
    toggleModalOpen: a,
    closeModal: o
  } = (0,useModal_5a548e10.u)({ onOpen: e.current }), {
    isModalOpen: c,
    toggleModalOpen: s,
    closeModal: r
  } = (0,useModal_5a548e10.u)({ onOpen: i.current });
  i.current = o, e.current = r;
  const _ = (0,react.useCallback)(() => {
    o(), r();
  }, [o, r]);
  return {
    isMenuOpen: t,
    isSearchOpen: c,
    toggleMenuOpen: a,
    toggleSearchOpen: s,
    closeMenu: o,
    closeSearch: r,
    closeAllModals: _
  };
}

//# sourceMappingURL=Navigation.js.map

;// CONCATENATED MODULE: ./src/components/Navigation/Navigation.tsx














var SearchContent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(475), __webpack_require__.e(808), __webpack_require__.e(4587)]).then(__webpack_require__.bind(__webpack_require__, 4587));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4587)
            ];
        }
    },
    ssr: false
});
function Navigation(param) {
    var links = param.links, switchLinks = param.switchLinks;
    var t = (0,esm/* useTranslation */.$G)().t;
    var isMobile = (0,ViewportContext/* default */.Z)().isMobile;
    var i18n = (0,react.useMemo)(function() {
        return {
            featureArticleText: t("navigation.featureArticle"),
            readMoreText: t("navigation.readMore"),
            selectLanguageLabel: t("navigation.selectLanguage")
        };
    }, [
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(di, {
        logoHref: useLogoHref(),
        links: links,
        switchLinks: switchLinks,
        languagePickerOptions: useLanguagePicker(),
        savedItems: useSavedItemsLink(),
        currentPageId: useCurrentPageId(links),
        searchContent: renderSearchContent,
        i18n: i18n,
        isSearchDisabled: false,
        isMobile: isMobile
    });
}
function renderSearchContent(args) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
        fallback: null,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchContent, (0,_object_spread/* default */.Z)({}, args))
    });
}
function useLogoHref() {
    var isEmployerSite = (0,EmployerSiteContext/* default */.Z)().isEmployerSite;
    return (0,util_magnolia/* formatPageLink */.Jd)(isEmployerSite ? magnolia/* MGNL.EMPLOYERS_NODE */.m.EMPLOYERS_NODE : magnolia/* MGNL.ROOT_NODE */.m.ROOT_NODE);
}
function useCurrentPageId(links) {
    var asPath = (0,next_router.useRouter)().asPath;
    var page = (0,react.useMemo)(function() {
        return links === null || links === void 0 ? void 0 : links.find(function(param) {
            var href = param.href;
            return asPath.startsWith(href);
        });
    }, [
        asPath,
        links
    ]);
    return page === null || page === void 0 ? void 0 : page.id;
}
function useLanguagePicker() {
    var isEmployerSite = (0,EmployerSiteContext/* default */.Z)().isEmployerSite;
    var ref = (0,next_router.useRouter)(), _locale = ref.locale, locale = _locale === void 0 ? constants_locale/* defaultLocale */.al : _locale, _locales = ref.locales, locales = _locales === void 0 ? [] : _locales, asPath = ref.asPath;
    var ref1;
    var getLocaleName = (0,react.useCallback)(function(code) {
        var ref;
        return (ref1 = (ref = Object.entries(constants_locale/* Locale */.go).find(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
            return value === code;
        })) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref1 !== void 0 ? ref1 : code;
    }, []);
    var languagePicker = (0,react.useMemo)(function() {
        var availableLanguages = locales.filter(function(l) {
            return l !== "default";
        }).map(function(code) {
            return {
                code: code,
                label: getLocaleName(code)
            };
        });
        return {
            currentLanguage: locale,
            availableLanguages: availableLanguages,
            currentUrlPath: asPath
        };
    }, [
        asPath,
        locale,
        locales,
        getLocaleName
    ]);
    return isEmployerSite ? languagePicker : null;
}
function useSavedItemsLink() {
    var isEmployerSite = (0,EmployerSiteContext/* default */.Z)().isEmployerSite;
    var storedItems = (0,SaveItemsToStorageContext/* default */.Z)().storedItems;
    var isEmpty = storedItems.length === 0;
    return (0,react.useMemo)(function() {
        return isEmployerSite ? null : {
            isEmpty: isEmpty,
            href: "/saved-items"
        };
    }, [
        isEmployerSite,
        isEmpty
    ]);
}

;// CONCATENATED MODULE: ./src/components/Layout/RouteProgressBar.tsx
/* istanbul ignore file */ 



function RouteProgressBar() {
    var elementRef = useProgressElement();
    var isEmployerSite = (0,EmployerSiteContext/* default */.Z)().isEmployerSite;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "progress-bar-container",
        role: "none",
        style: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 1000,
            display: "flex",
            height: "2px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: elementRef,
            id: "progress-bar",
            role: "none",
            style: {
                background: isEmployerSite ? "var(--color-white)" : "var(--color-primary-700)",
                transition: "width 300ms ease-out"
            }
        })
    });
}
function useProgressElement() {
    var ref = (0,react.useTransition)(), startTransition = ref[1];
    var elementRef = (0,react.useRef)(null);
    var timeout = (0,react.useRef)();
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    (0,react.useEffect)(function() {
        var startLoading = function() {
            return startTransition(function() {
                return setIsLoading(true);
            });
        };
        var stopLoading = function() {
            return startTransition(function() {
                return setIsLoading(false);
            });
        };
        router.events.on("routeChangeStart", startLoading);
        router.events.on("routeChangeComplete", stopLoading);
        router.events.on("routeChangeError", stopLoading);
        return function() {
            router.events.off("routeChangeStart", startLoading);
            router.events.off("routeChangeComplete", stopLoading);
            router.events.off("routeChangeError", stopLoading);
        };
    }, [
        router
    ]);
    var setElementWidth = (0,react.useCallback)(function(width) {
        var element = elementRef.current;
        if (!element) return;
        element.style.width = width.toString();
        element.dataset.value = width.toString();
    }, []);
    var updateWidth = (0,react.useCallback)(function(ms) {
        var element = elementRef.current;
        if (!element) return;
        timeout.current = setTimeout(function() {
            var width = parseFloat(element.style.width);
            var percent = !isNaN(width) ? 10 + 0.9 * width : 0;
            setElementWidth("".concat(percent, "%"));
            updateWidth(100);
        }, ms);
    }, [
        setElementWidth
    ]);
    (0,react.useEffect)(function() {
        if (!isLoading || !elementRef.current) return;
        if (timeout.current) clearTimeout(timeout.current);
        var element = elementRef.current;
        setElementWidth("0%");
        updateWidth(300);
        return function() {
            if (timeout.current) clearTimeout(timeout.current);
            if (element.style.width === "0%") return;
            setElementWidth("100%");
            timeout.current = setTimeout(function() {
                if ((element === null || element === void 0 ? void 0 : element.style.width) !== "100%") return;
                setElementWidth("");
            }, 200);
        };
    }, [
        isLoading,
        updateWidth,
        setElementWidth
    ]);
    return elementRef;
}

// EXTERNAL MODULE: ./src/components/Layout/Layout.module.scss
var Layout_module = __webpack_require__(4375);
var Layout_module_default = /*#__PURE__*/__webpack_require__.n(Layout_module);
;// CONCATENATED MODULE: ./src/components/Layout/Layout.tsx
























var AinoChatButton = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2408).then(__webpack_require__.bind(__webpack_require__, 2408));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2408)
            ];
        }
    },
    ssr: false
});
function Layout(props) {
    var links = props.links, children = props.children, _isEmployerSite = props.isEmployerSite, isEmployerSite = _isEmployerSite === void 0 ? false : _isEmployerSite, page = props.page;
    var themeProviderConfig = (0,react.useMemo)(function() {
        return {
            themes: [
                "default",
                "employer"
            ],
            defaultTheme: isEmployerSite ? "employer" : "default",
            forcedTheme: isEmployerSite ? "employer" : "default",
            enableSystem: false,
            disableTransitionOnChange: true
        };
    }, [
        isEmployerSite
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadTags, (0,_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployerSiteContext/* EmployerSiteContextProvider */.N, {
                value: {
                    isEmployerSite: isEmployerSite
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SaveItemsToStorageContext/* WifSavedItemsToStorageProvider */.e, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewportContext/* ViewportContextProvider */.L, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageContentContext/* PageContentContextProvider */.V, {
                            value: page,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(s, {
                                    LinkComponent: (link_default()),
                                    ImageComponent: (image_default()),
                                    isEmployerSite: isEmployerSite,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(J, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, themeProviderConfig), {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RouteProgressBar, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation, {
                                                links: links.primary,
                                                switchLinks: links.switchLinks
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                                                className: (Layout_module_default()).layout,
                                                children: children
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, (0,_object_spread/* default */.Z)({}, links))
                                        ]
                                    }))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AinoChatButton, {})
                            ]
                        })
                    })
                })
            })
        ]
    });
}
function HeadTags(param) {
    var title = param.title, isEmployerSite = param.isEmployerSite, page = param.page, isHomepage = param.isHomepage;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,next_router.useRouter)(), locale = ref5.locale, asPath = ref5.asPath, isPreview = ref5.isPreview;
    var metaTitle = isHomepage ? title : "".concat(title).concat(app/* META_TITLE_SUFFIX */.A_);
    var description = (page === null || page === void 0 ? void 0 : page.metaDescription) || (page === null || page === void 0 ? void 0 : page.description);
    var canonicalUrl = "".concat(app/* __APP_HOST_PUBLIC__ */.jT, "/").concat(locale).concat(asPath);
    var ogLocale = locale ? constants_locale/* ogLocaleMap */.EW[locale] : undefined;
    var alternateLocales = (isEmployerSite ? constants_locale/* localesEmployers */.HG : constants_locale/* localesTalent */.Vb).filter(function(l) {
        return l !== locale;
    });
    var ogImage = (page === null || page === void 0 ? void 0 : (ref = page.introductionImage) === null || ref === void 0 ? void 0 : (ref1 = ref.renditions) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.xs) === null || ref2 === void 0 ? void 0 : ref2.link) || (page === null || page === void 0 ? void 0 : (ref3 = page.introductionImage) === null || ref3 === void 0 ? void 0 : ref3["@link"]);
    var ogType = (page === null || page === void 0 ? void 0 : page["mgnl:template"]) === magnolia_config/* MagnoliaTemplate.PageArticle */.gM.PageArticle || (page === null || page === void 0 ? void 0 : page["mgnl:template"]) === magnolia_config/* MagnoliaTemplate.PageEvent */.gM.PageEvent ? "article" : "website";
    var mgnlPageEditorStylesheet = isPreview // only needed in Mgnl Editor
     ? "".concat(magnolia/* MGNL.BASE_URL */.m.BASE_URL(isPreview), "/VAADIN/themes/pages-app/page-editor.css") : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: metaTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect",
                href: magnolia/* MGNL.HOST */.m.HOST(isPreview)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "keywords",
                content: page === null || page === void 0 ? void 0 : (ref4 = page.keywords) === null || ref4 === void 0 ? void 0 : ref4.join(", ")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "msvalidate.01",
                content: "74D640CD1F31D68F74FEE432FDD5A501"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:site_name",
                content: app/* META_TITLE_SUFFIX.replace */.A_.replace("-", "").trim()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:locale",
                content: ogLocale
            }),
            alternateLocales.map(function(l) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:locale:alternate",
                    content: constants_locale/* ogLocaleMap */.EW[l]
                }, l);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: ogType
            }),
            ogImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: (0,util_magnolia/* formatAssetLink */.Qz)(ogImage, isPreview)
            }),
            mgnlPageEditorStylesheet && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "stylesheet",
                href: mgnlPageEditorStylesheet
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/pages/_app.tsx







function MyApp(param) {
    var Component = param.Component, pageProps = param.pageProps;
    var page = pageProps.page, title = pageProps.title, _isEmployerSite = pageProps.isEmployerSite, isEmployerSite = _isEmployerSite === void 0 ? false : _isEmployerSite, navLinks = pageProps.navLinks;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
        title: title,
        links: navLinks,
        page: page,
        isHomepage: (page === null || page === void 0 ? void 0 : page["@path"]) === magnolia/* MGNL.ROOT_NODE */.m.ROOT_NODE,
        isEmployerSite: isEmployerSite,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps))
    });
}
/* harmony default export */ var _app = ((0,esm/* appWithTranslation */.Jc)(MyApp));


/***/ }),

/***/ 9166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$o": function() { return /* binding */ getLocalStorage; },
/* harmony export */   "dZ": function() { return /* binding */ removeLocalStorage; },
/* harmony export */   "qQ": function() { return /* binding */ setLocalStorage; }
/* harmony export */ });
var getLocalStorage = function(key) {
    try {
        if (true) {
            var storedDate = localStorage.getItem(key);
            return JSON.parse(storedDate);
        }
    } catch (error) {
        return error;
    }
};
var setLocalStorage = function(key, item) {
    if (true) {
        localStorage.setItem(key, JSON.stringify(item));
    }
};
var removeLocalStorage = function(key) {
    if (true) {
        localStorage.removeItem(key);
    }
};


/***/ }),

/***/ 7581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lJ": function() { return /* binding */ filterUniqueMgnlNodesPredicate; },
  "Qz": function() { return /* binding */ formatAssetLink; },
  "Jd": function() { return /* binding */ formatPageLink; },
  "dA": function() { return /* binding */ generateErrorResult; },
  "K3": function() { return /* binding */ getAssetPath; },
  "FE": function() { return /* binding */ jcrMultiFieldToArray; },
  "cJ": function() { return /* binding */ resolveLinkSwitchableField; },
  "gA": function() { return /* binding */ setURLSearchParams; }
});

// UNUSED EXPORTS: extractLocaleDataFromNode, extractUuidListFromMgnlNodeTree, findNodeFromMgnlNodeWithUUID, formatMgnlNodePath, generateCompanyServiceLabel, generateMgnlSystemNodeProperties, generateMgnlSystemNodeProperty, isValidMgnlUUID, removeMetadataPropertiesFromMgnlNode, removePropertiesFromMgnlNode, transformMgnlServiceNodesToWifServices, traverseMgnlNodeTree

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var src_sliced_to_array = __webpack_require__(2050);
// EXTERNAL MODULE: ./src/constants/magnolia.ts + 1 modules
var magnolia = __webpack_require__(5056);
;// CONCATENATED MODULE: ./src/types/wif-next.ts
var LinkSwitchableType;
(function(LinkSwitchableType) {
    LinkSwitchableType["Magnolia"] = "magnolia";
    LinkSwitchableType["External"] = "external";
})(LinkSwitchableType || (LinkSwitchableType = {}));

;// CONCATENATED MODULE: ./src/util/magnolia.ts








function jcrMultiFieldToArray(jcrMultiField) {
    return ((jcrMultiField === null || jcrMultiField === void 0 ? void 0 : jcrMultiField["@nodes"]) || []).map(function(n) {
        return jcrMultiField[n];
    }).filter(Boolean);
}
function formatAssetLink(url) {
    var isPreview = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return magnolia/* MGNL.HOST */.m.HOST(isPreview) + url;
}
/**
 * @param url string
 * @param isPreview boolean
 * @returns string
 */ function formatPageLink(url, isPreview, anchorTag) {
    var hash = anchorTag ? "#".concat(anchorTag) : "";
    if (!url) return hash;
    if (!isPreview) {
        if (url === magnolia/* MGNL.ROOT_NODE */.m.ROOT_NODE) {
            return "/" + hash;
        } else {
            return url.replace(magnolia/* MGNL.ROOT_NODE */.m.ROOT_NODE, "") + hash;
        }
    }
    return url + hash;
}
function setURLSearchParams(uri, params) {
    var url = new URL(uri);
    Object.entries(params).forEach(function(param) {
        var _param = (0,src_sliced_to_array/* default */.Z)(param, 2), name = _param[0], value = _param[1];
        if (value) url.searchParams.set(name, value);
    });
    return url.toString();
}
function getAssetPath(asset) {
    var isPreview = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (asset && asset["@link"]) {
        return magnolia/* MGNL.HOST */.m.HOST(isPreview) + asset["@link"];
    }
    return "";
}
/**
 * Traverse a Magnolia node till the last subnode.
 * @param node The Mgnl.Node to traverse.
 * @param predicate The callback function with receives current node, parentNode and depth.
 *
 * @example
 * ```ts
 * const pageNode: Wif.Mgnl.Page = {...};
 * traverseMgnlNodeTree(pageNode, (node, parentNode) => {...})
 * ```
 */ function traverseMgnlNodeTree(node, predicate, parentNode) {
    return _traverseMgnlNodeTree.apply(this, arguments);
}
function _traverseMgnlNodeTree() {
    _traverseMgnlNodeTree = _async_to_generator(function(node, predicate, parentNode) {
        var currentDepth, previousResult, result, nodeList;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    currentDepth = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : 0, previousResult = _arguments.length > 4 ? _arguments[4] : void 0;
                    return [
                        4,
                        predicate(node, parentNode, currentDepth, previousResult)
                    ];
                case 1:
                    result = _state.sent();
                    if (result === null) return [
                        2
                    ];
                    nodeList = (node === null || node === void 0 ? void 0 : node["@nodes"]) || [];
                    if (!(nodeList && Array.isArray(nodeList))) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all(nodeList.map(function(nodeName) {
                            return traverseMgnlNodeTree(node[nodeName], predicate, node, currentDepth + 1, result);
                        }))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _traverseMgnlNodeTree.apply(this, arguments);
}
/**
 * Extract a list of uuid in the provided Mgnl node
 * @param node Mgnl Node/Page/NavPage
 * @param matchPredicate Filter nodes that should be tested. Leave undefined for all nodes.
 * @param fields List of fields to test in a node. Default ["@id"];
 * @param existingUuidList List of existing uuid list. These uuid are ignored from returned list.
 * @returns A list of UUID.
 *
 * @example
 * ```ts
 * const uuidList = extractUuidListFromMgnlNodeTree(
 *  pageNode,
 *  (node) => node["@nodes"].length > 0,
 *  ["page", "field"],
 *  ["e3ea7c3b-2ef1-463a-9895-9ef53e28401", "e3ea7c3b-2ef1-463a-9895-9ef53e28439"]
 * )
 * ```
 */ function extractUuidListFromMgnlNodeTree(node, matchPredicate) {
    return _extractUuidListFromMgnlNodeTree.apply(this, arguments);
}
function _extractUuidListFromMgnlNodeTree() {
    _extractUuidListFromMgnlNodeTree = _async_to_generator(function(node, matchPredicate) {
        var fields, existingUuidList, uuidList;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    fields = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : [
                        "@id"
                    ], existingUuidList = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : [];
                    if (fields.length === 0) return [
                        2,
                        []
                    ];
                    uuidList = new Set();
                    return [
                        4,
                        traverseMgnlNodeTree(node, function(node, parentNode, depth) {
                            if (typeof node !== "object") return;
                            if (!matchPredicate || matchPredicate(node, parentNode, depth)) {
                                fields.forEach(function(field) {
                                    if (field in node) {
                                        var uuid = node[field];
                                        if (isValidMgnlUUID(uuid) && !existingUuidList.includes(uuid)) {
                                            uuidList.add(uuid);
                                        }
                                    }
                                });
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        _to_consumable_array(uuidList)
                    ];
            }
        });
    });
    return _extractUuidListFromMgnlNodeTree.apply(this, arguments);
}
function isValidMgnlUUID(uuid) {
    // e3ea7c3b-2ef1-463a-9895-9ef53e28439
    // e3ea7c3b-2ef1-463a-9895-9ef53e284395
    return Boolean(typeof uuid === "string" && uuid.split("-").length === 5);
}
function filterUniqueMgnlNodesPredicate(node, index, nodes) {
    return index === nodes.findIndex(function(n) {
        return n["@id"] === node["@id"];
    });
}
function removeMetadataPropertiesFromMgnlNode(node) {
    for(var _len = arguments.length, metaProperties = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        metaProperties[_key - 1] = arguments[_key];
    }
    Object.values(node).forEach(function(property) {
        if (property && typeof property === "object" && "metadata" in property) {
            metaProperties.forEach(function(metaProperty) {
                if (metaProperty in property.metadata) {
                    delete property.metadata[metaProperty];
                }
            });
        }
    });
}
function removePropertiesFromMgnlNode(node) {
    for(var _len = arguments.length, properties = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        properties[_key - 1] = arguments[_key];
    }
    return traverseObjectProperties(node, properties, function(_, obj, prop) {
        delete obj[prop];
    }, false);
}
/**
 * Format path based on target language and parent node's path.
 */ function formatMgnlNodePath(node, parentPath) {
    var targetLang = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultLocale, rootNodePath = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : MGNL.ROOT_NODE;
    var ref;
    if (targetLang === defaultLocale) return ((ref = node["@path"]) === null || ref === void 0 ? void 0 : ref.replace(rootNodePath, "")) || "/";
    if (!parentPath) return "/";
    var slug = node["slug_".concat(targetLang)] || node["@name"];
    return "".concat(parentPath, "/").concat(slug).replace("//", "/").replace(MGNL.ROOT_NODE, "");
}
function findNodeFromMgnlNodeWithUUID(mgnlNode, uuid) {
    return _findNodeFromMgnlNodeWithUUID.apply(this, arguments);
}
function _findNodeFromMgnlNodeWithUUID() {
    _findNodeFromMgnlNodeWithUUID = _async_to_generator(function(mgnlNode, uuid) {
        var matchingNode;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        traverseMgnlNodeTree(mgnlNode, function(node) {
                            if (node["@id"] === uuid) {
                                matchingNode = node;
                                return null;
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        matchingNode
                    ];
            }
        });
    });
    return _findNodeFromMgnlNodeWithUUID.apply(this, arguments);
}
/** Generate property that can be attached to MgnlSystemNode */ function generateMgnlSystemNodeProperty(name, value) {
    var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "String";
    var multiple = Array.isArray(value);
    var values = multiple ? value : [
        value
    ];
    return {
        name: name,
        values: values,
        type: type,
        multiple: multiple
    };
}
function generateMgnlSystemNodeProperties(entries) {
    var properties = [];
    Object.entries(entries).forEach(function(param) {
        var _param = _sliced_to_array(param, 2), name = _param[0], entry = _param[1];
        if (!entry) return;
        if (typeof entry === "object" && "value" in entry) {
            return properties.push(generateMgnlSystemNodeProperty(name, entry.value, entry.type));
        }
        return properties.push(generateMgnlSystemNodeProperty(name, entry));
    });
    return properties;
}
function transformMgnlServiceNodesToWifServices(services, lang) {
    return (services || []).filter(function(node) {
        return node && typeof node === "object" && node["@id"];
    }).map(function(serviceNode) {
        return {
            value: serviceNode["@id"],
            label: generateCompanyServiceLabel(serviceNode, lang)
        };
    });
}
function generateCompanyServiceLabel(service, lang) {
    var fallback = service.name || service["@name"] || "";
    if (lang === Locale.Finnish) return service.nameFi || fallback;
    if (lang === Locale.Swedish) return service.nameSv || fallback;
    return fallback;
}
function extractLocaleDataFromNode(node, lang, property) {
    var defaultValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    var fallback = node["".concat(property, "-fi")] || defaultValue;
    if (lang === Locale.English) return node["".concat(property, "-en")] || fallback;
    if (lang === Locale.Swedish) return node["".concat(property, "-sv")] || fallback;
    return fallback;
}
function generateErrorResult() {
    return {
        limit: 0,
        offset: 0,
        total: 0,
        results: []
    };
}
function resolveLinkSwitchableField(link, isPreview) {
    if (link) {
        if (link.field === LinkSwitchableType.Magnolia && link.wifLinkMagnoliaPage) {
            var page = link.wifLinkMagnoliaPage;
            var ref;
            var href = formatPageLink((ref = page["@path"]) !== null && ref !== void 0 ? ref : "", isPreview, link.wifLinkAnchorTag);
            var _introductionImage;
            var saveItemProps = {
                id: page["@id"] || "",
                title: page.title || "",
                description: page.metaDescription || page.description || "",
                pageLink: href,
                type: "masonryCard",
                image: (_introductionImage = page.introductionImage) !== null && _introductionImage !== void 0 ? _introductionImage : null
            };
            return {
                isExternalLink: false,
                linkHref: href,
                saveItemProps: saveItemProps
            };
        }
        if (link.field === LinkSwitchableType.External && link.wifLinkExternalUrl) {
            var _wifLinkExternalUrl;
            return {
                isExternalLink: true,
                linkHref: formatPageLink((_wifLinkExternalUrl = link.wifLinkExternalUrl) !== null && _wifLinkExternalUrl !== void 0 ? _wifLinkExternalUrl : "", isPreview)
            };
        }
    }
    return {
        isExternalLink: true,
        linkHref: ""
    };
}


/***/ }),

/***/ 5625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ getViewportByWindowWidth; },
/* harmony export */   "s": function() { return /* binding */ optimiseViewport; }
/* harmony export */ });
/* harmony import */ var _constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5884);

var getViewportByWindowWidth = function() {
    if (window.innerWidth >= _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .DeviceSizes.xl */ .aG.xl) return _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .Viewport.xl */ .l_.xl;
    if (window.innerWidth >= _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .DeviceSizes.lg */ .aG.lg) return _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .Viewport.lg */ .l_.lg;
    if (window.innerWidth >= _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .DeviceSizes.md */ .aG.md) return _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .Viewport.md */ .l_.md;
    if (window.innerWidth >= _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .DeviceSizes.sm */ .aG.sm) return _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .Viewport.sm */ .l_.sm;
    return _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .Viewport.xs */ .l_.xs;
};
/**
 * Get the optimised version of viewport.
 * Formula = min(maxViewport, max(minViewport ,Viewport))
 */ function optimiseViewport(viewport) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _maxViewport = options.maxViewport, maxViewport = _maxViewport === void 0 ? _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .Viewport.xl */ .l_.xl : _maxViewport, _minViewport = options.minViewport, minViewport = _minViewport === void 0 ? _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .Viewport.xs */ .l_.xs : _minViewport;
    // If viewport is limited to single option.
    if (maxViewport === minViewport) {
        return maxViewport;
    }
    // If viewport is limited to all options
    if (maxViewport === _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .Viewport.xl */ .l_.xl && minViewport === _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .Viewport.xs */ .l_.xs) {
        return viewport;
    }
    var minDeviceSize = _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .DeviceSizes */ .aG[minViewport];
    var maxDeviceSize = _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .DeviceSizes */ .aG[maxViewport];
    // Incorrect bounds
    if (minDeviceSize > maxDeviceSize) {
        return undefined;
    }
    // Else find the sweet spot
    var deviceSize = _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .DeviceSizes */ .aG[viewport];
    var optimalDeviceSize = Math.min(Math.max(deviceSize, minDeviceSize), maxDeviceSize);
    var optimalViewport = _constants_app__WEBPACK_IMPORTED_MODULE_0__/* .DeviceSizes */ .aG[optimalDeviceSize];
    return optimalViewport;
}


/***/ }),

/***/ 4375:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__vMu_3"};

/***/ }),

/***/ 477:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 1584:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 5218:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(9906)


/***/ }),

/***/ 1723:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(8603)


/***/ }),

/***/ 8038:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(555)


/***/ }),

/***/ 9894:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(1453)


/***/ }),

/***/ 6677:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5817)


/***/ }),

/***/ 7061:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 8702:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 9185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(8702);
} else {}


/***/ }),

/***/ 128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AJ": function() { return /* binding */ Xt; },
/* harmony export */   "OR": function() { return /* binding */ Vt; },
/* harmony export */   "R": function() { return /* binding */ Qt; },
/* harmony export */   "XZ": function() { return /* binding */ Zt; },
/* harmony export */   "Y8": function() { return /* binding */ tr; },
/* harmony export */   "Yz": function() { return /* binding */ jt; },
/* harmony export */   "gx": function() { return /* binding */ rr; },
/* harmony export */   "ko": function() { return /* binding */ er; },
/* harmony export */   "oi": function() { return /* binding */ or; },
/* harmony export */   "pz": function() { return /* binding */ Yt; },
/* harmony export */   "qL": function() { return /* binding */ Jt; }
/* harmony export */ });
/* unused harmony exports MIME_TYPE_MAP, createIntervalWithCleanup, eventListenerWithCleanup */
/* harmony import */ var _app_51178863_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7610);
/* harmony import */ var _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7720);
/* harmony import */ var _Button_eec2778c_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9358);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(403);
/* harmony import */ var _Logo_8772aba7_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1658);
/* harmony import */ var _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2007);
/* harmony import */ var _Dropdown_cd8250f9_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3978);
/* harmony import */ var _VideoIcon_c13b94d3_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3652);
/* harmony import */ var _index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8517);
























function Vt(t, r, o, n) {
  const a = (0,_index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_1__.a)(r);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => M(n || window, t, a, o), [t, a, n, o]);
}
function M(t, r, o, n) {
  return n ? () => {
  } : (t.addEventListener(r, o), () => t.removeEventListener(r, o));
}
function jt(t, r, o = {}) {
  const n = (0,_index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_1__.a)(t);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(
    () => ce(n, r, {
      disabled: o.disabled,
      maxDuration: o.maxDuration,
      executeImmediately: o.executeImmediately
    }),
    [
      n,
      r,
      o.disabled,
      o.maxDuration,
      o.executeImmediately
    ]
  );
}
function ce(t, r, o = {}) {
  const { disabled: n, maxDuration: a, executeImmediately: s } = o;
  if (n || r <= 0)
    return () => {
    };
  let l = 0;
  s && t(l);
  const i = window.setInterval(() => {
    l += r, a && l >= a && window.clearInterval(i), t(l) && window.clearInterval(i);
  }, r);
  return () => window.clearInterval(i);
}
const se = "checkbox", le = "no-padding", ie = "checkbox__icon", de = "checkbox__icon--dark-bg", pe = "checkbox__icon--error", ue = "checkbox__input", N = {
  checkbox: se,
  noPadding: le,
  checkboxIcon: ie,
  checkboxIconDarkBg: de,
  checkboxIconError: pe,
  checkboxInput: ue
};
function Zt({
  label: t,
  name: r,
  checked: o,
  onChange: n,
  disabled: a,
  error: s,
  onDarkBackground: l,
  required: i,
  noPadding: _
}) {
  const { isHovering: d, ref: b } = (0,_Logo_8772aba7_mjs__WEBPACK_IMPORTED_MODULE_2__.u)(), p = (0,_app_51178863_mjs__WEBPACK_IMPORTED_MODULE_3__.u)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "label",
    {
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(N.checkbox, _ && N.noPadding),
      ref: b,
      "data-hover": d,
      "aria-disabled": a
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
          N.checkboxIcon,
          s && N.checkboxIconError,
          (l === !0 || p) && N.checkboxIconDarkBg
        ),
        "aria-checked": o
      },
      o && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_5__.I, { icon: _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_5__.W.CHECK, size: 16 }),
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "input",
        {
          className: N.checkboxInput,
          type: "checkbox",
          checked: o,
          onChange: (E) => n?.(E.target.checked),
          name: r,
          required: i
        }
      )
    ),
    t
  );
}
const me = "curtain", be = "curtain--show", W = {
  curtain: me,
  curtainShow: be
};
function Yt({ show: t = !1 }) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(W.curtain, t && W.curtainShow) });
}
const ge = "error-handler", _e = "desktop", xe = "error-handler--heading", ye = "error-handler--description", Ee = "error-handler--icon", L = {
  errorHandler: ge,
  desktop: _e,
  errorHandlerHeading: xe,
  errorHandlerDescription: ye,
  errorHandlerIcon: Ee
};
function Jt({
  title: t,
  description: r,
  videoSrc: o,
  fallbackSrc: n
}) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_6__.B, { topPadding: _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_6__.a.NONE, bottomPadding: _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_6__.a.NONE }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_6__.B.Content, { flex: !0, className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(L.errorHandler) }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(L.errorHandlerIcon) }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_VideoIcon_c13b94d3_mjs__WEBPACK_IMPORTED_MODULE_7__.V, { src: o, fallbackImgSrc: n })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "p",
    {
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
        L.errorHandlerHeading,
        _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.t.headingSection
      )
    },
    t
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "p",
    {
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
        L.errorHandlerDescription,
        _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsBodyText
      )
    },
    r
  )));
}
const he = "media-upload", Ie = "media-upload__help-text", Be = "media-upload__area", Ce = "desktop", Ae = "media-upload__area__content", fe = "media-upload__area__icon", Ne = "media-upload__area__texts", Se = "media-upload__area__texts__subheading", ve = "media-upload__area__button", ke = "media-upload__area__input", Ue = "media-upload__banner", we = "media-upload__banner--error", Le = "media-upload__banner__file-icon", Te = "media-upload__banner__file-icon--error", Pe = "media-upload__banner__content", De = "media-upload__banner__content__fileSize", Fe = "media-upload__banner__content__fileSize--error", He = "media-upload__banner__clear-button", Ge = "media-upload__errorMessage", u = {
  mediaUpload: he,
  mediaUploadHelpText: Ie,
  mediaUploadArea: Be,
  desktop: Ce,
  mediaUploadAreaContent: Ae,
  mediaUploadAreaIcon: fe,
  mediaUploadAreaTexts: Ne,
  mediaUploadAreaTextsSubheading: Se,
  mediaUploadAreaButton: ve,
  mediaUploadAreaInput: ke,
  mediaUploadBanner: Ue,
  mediaUploadBannerError: we,
  mediaUploadBannerFileIcon: Le,
  mediaUploadBannerFileIconError: Te,
  mediaUploadBannerContent: Pe,
  mediaUploadBannerContentFileSize: De,
  mediaUploadBannerContentFileSizeError: Fe,
  mediaUploadBannerClearButton: He,
  mediaUploadErrorMessage: Ge
}, P = 1024, U = P * P, $ = U * U, Re = {
  IMAGES: ["image/jpeg", "image/webp", "image/png"],
  VIDEOS: ["video/mp4", "video/mpeg"],
  AUDIOS: ["audio/mpeg", "audio/wav", "audio/ogg", "audio/webm", "audio/mp3"]
};
function Qt({
  label: t,
  caption: r,
  onChange: o,
  disabled: n,
  required: a,
  supportedMimeTypes: s = Re.IMAGES,
  maxFileSize: l = U,
  fileIcon: i = _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_5__.W.SIGHTSEEING,
  name: _,
  value: d,
  errorMessage: b,
  i18n: p = {}
}) {
  const {
    maximumSizeLabel: E = "Maximum size",
    optionalLabel: f = "Optional",
    unsupportedFileTypeError: S = "File type not supported",
    browseFilesLabel: v = "Browse files"
  } = p, x = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), y = !!(d && s.includes(d.type)), w = (d?.size || 0) > l, J = s.map((X) => X.split("/")[1]).join(", "), Q = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    o(void 0), x.current?.value && (x.current.value = "");
  }, [o]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: u.mediaUpload }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(u.mediaUploadHelpText, _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsCaption)
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, t, " ", a ? null : f ? `(${f})` : null),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, E, " ", z(l))
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Me,
    {
      disabled: n,
      heading: r,
      subheading: J,
      onChange: o,
      supportedMimeTypes: s,
      buttonLabel: v,
      name: _,
      forwardedInputRef: x
    }
  ), d ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    We,
    {
      disabled: n,
      fileName: d.name,
      fileIcon: i,
      resetFile: Q,
      errorMessage: w ? z(d.size) : y ? void 0 : S
    }
  ) : null, !!b && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsCaption && u.mediaUploadErrorMessage
    },
    b
  ));
}
function Me({
  heading: t = "Upload",
  subheading: r,
  onChange: o,
  supportedMimeTypes: n,
  buttonLabel: a,
  name: s,
  disabled: l,
  forwardedInputRef: i
}) {
  const _ = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), [d, b] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), p = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (x) => {
      l || (x.preventDefault(), x.stopPropagation(), b(!0));
    },
    [l]
  ), E = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => b(!1), []), f = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => _.current?.click(), []), S = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (x) => {
      if (x.preventDefault(), l)
        return;
      b(!1);
      const y = x.dataTransfer.files?.[0];
      y && o(y);
    },
    [l, o]
  ), v = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (x) => {
      const y = x.target.files?.[0];
      y && o(y);
    },
    [o]
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "button",
    {
      type: "button",
      className: u.mediaUploadArea,
      onClick: f,
      onDragOver: p,
      onDragLeave: E,
      onDrop: S,
      "data-dragover": d
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: u.mediaUploadAreaContent }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: u.mediaUploadAreaIcon, role: "none" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_5__.I, { icon: _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_5__.W.SHARE, size: 24 })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: u.mediaUploadAreaTexts }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsLeadTextBold }, t), r && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "span",
      {
        className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
          u.mediaUploadAreaTextsSubheading,
          _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsLeadText
        )
      },
      r
    )), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Button_eec2778c_mjs__WEBPACK_IMPORTED_MODULE_8__.B.Primary,
      {
        asDiv: !0,
        text: a,
        className: u.mediaUploadAreaButton
      }
    )),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "input",
      {
        type: "file",
        name: s,
        disabled: l,
        ref: (0,_index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_1__.m)(_, i),
        onChange: v,
        className: u.mediaUploadAreaInput,
        accept: n.join(", ")
      }
    )
  );
}
function We({
  fileName: t,
  errorMessage: r,
  resetFile: o,
  disabled: n,
  fileIcon: a
}) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "output",
    {
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
        u.mediaUploadBanner,
        r && u.mediaUploadBannerError
      )
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
          u.mediaUploadBannerFileIcon,
          r && u.mediaUploadBannerFileIconError
        ),
        role: "none"
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_5__.I, { icon: a, size: 20 })
    ),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
          u.mediaUploadBannerContent,
          _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsLeadText
        )
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, t),
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "span",
        {
          className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
            u.mediaUploadBannerContentFileSize,
            r && u.mediaUploadBannerContentFileSizeError
          )
        },
        typeof r == "string" ? r : null
      )
    ),
    !n && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "button",
      {
        onClick: o,
        className: u.mediaUploadBannerClearButton
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_5__.I, { icon: _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_5__.W.CLOSE, size: 20 })
    )
  );
}
function z(t) {
  return t >= $ ? `${(t / $).toFixed(2)} GB` : t >= U ? `${(t / U).toFixed(2)} MB` : t >= P ? `${(t / P).toFixed(2)} KB` : `${t} Bytes`;
}
const $e = "phone-number-input", ze = "phone-number-input__label", Oe = "phone-number-input__label--error", qe = "phone-number-input__errorMessage", Ke = "phone-number-input__container", Ve = "phone-number-input__container--large", je = "phone-number-input__container--error", Ze = "phone-number-input__dropdown", Ye = "phone-number-input__dropdown__button", Je = "phone-number-input__dropdown__list", Qe = "phone-number-input__dropdown__flag", Xe = "phone-number-input__divider", et = "phone-number-input__country-code", tt = "phone-number-input__country-code--error", rt = "phone-number-input__input-field", g = {
  phoneNumberInput: $e,
  phoneNumberInputLabel: ze,
  phoneNumberInputLabelError: Oe,
  phoneNumberInputErrorMessage: qe,
  phoneNumberInputContainer: Ke,
  phoneNumberInputContainerLarge: Ve,
  phoneNumberInputContainerError: je,
  phoneNumberInputDropdown: Ze,
  phoneNumberInputDropdownButton: Ye,
  phoneNumberInputDropdownList: Je,
  phoneNumberInputDropdownFlag: Qe,
  phoneNumberInputDivider: Xe,
  phoneNumberInputCountryCode: et,
  phoneNumberInputCountryCodeError: tt,
  phoneNumberInputInputField: rt
};
function ot(t, r) {
  const o = 10 ** Math.round(r);
  return Math.round(t * o) / o;
}
function nt(t) {
  const r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    () => ct(t),
    [t]
  );
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useSyncExternalStore)(at, r, () => 0);
}
function at(t) {
  return t(), window.addEventListener("resize", t, { passive: !0 }), () => window.removeEventListener("resize", t);
}
function ct(t, r = 0) {
  return ot(
    t.current?.getBoundingClientRect().width || r,
    0
  );
}
const D = [
  {
    flagUrl: "/flags/fi.svg",
    name: "Soumi",
    code: "+358"
  },
  {
    flagUrl: "/flags/sv.svg",
    name: "Sverige",
    code: "+46"
  }
], st = D.map(Z), Xt = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function({
  errorMessage: r,
  dataTestid: o,
  label: n,
  onValueChange: a,
  onChange: s,
  height: l = "normal",
  ...i
}, _) {
  const d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), b = nt(d), [p, E] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(D[0]), f = (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
    _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsCaption,
    g.phoneNumberInputLabel,
    r && g.phoneNumberInputLabelError
  ), S = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (y) => {
      const w = y.target.value;
      s?.(y), a?.(w ? p.code + w : "");
    },
    [p.code, a, s]
  ), v = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((y) => {
    E(Y(y[0]));
  }, []), x = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => [Z(p)],
    [p]
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: g.phoneNumberInput }, n && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", { className: f }, n, i.required ? " *" : null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      ref: d,
      "aria-disabled": i.disabled,
      "data-testid": o,
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
        g.phoneNumberInputContainer,
        _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsLeadText,
        r && g.phoneNumberInputContainerError,
        l === "large" && g.phoneNumberInputContainerLarge
      ),
      style: {
        "--phone-input-container-width": b.toFixed(0) + "px"
      }
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Dropdown_cd8250f9_mjs__WEBPACK_IMPORTED_MODULE_9__.D,
      {
        name: `${i.name}-cc`,
        items: st,
        isMulti: !1,
        label: lt,
        selectedItems: x,
        onSelectedItemsChange: v,
        className: g.phoneNumberInputDropdown,
        buttonClassName: g.phoneNumberInputDropdownButton,
        listClassName: g.phoneNumberInputDropdownList,
        disabled: i.disabled
      }
    ),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: g.phoneNumberInputDivider, role: "none" }),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "span",
      {
        className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
          g.phoneNumberInputCountryCode,
          r && g.phoneNumberInputCountryCodeError
        )
      },
      p.code
    ),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "input",
      {
        ...i,
        type: "tel",
        className: g.phoneNumberInputInputField,
        onChange: S,
        ref: _,
        inputMode: "numeric"
      }
    )
  ), r && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "span",
    {
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
        _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsCaption,
        g.phoneNumberInputErrorMessage
      )
    },
    r
  ));
});
function lt({ selectedItems: t }) {
  const r = Y(t[0]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "img",
    {
      src: r.flagUrl,
      alt: r.name,
      className: g.phoneNumberInputDropdownFlag
    }
  );
}
function it({ flagUrl: t, name: r, code: o }) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: { display: "flex", alignItems: "center", gap: "1rem" } }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "img",
    {
      src: t,
      alt: r,
      className: g.phoneNumberInputDropdownFlag
    }
  ), " ", r, " ", /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: g.phoneNumberInputCountryCode }, o));
}
function Z(t) {
  return {
    label: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(it, { ...t }),
    value: t.code
  };
}
function Y(t) {
  return D.find((r) => r.code === t?.value) || D[0];
}
const dt = "progressBar", pt = "progressBar__container", ut = "progressBar__wrapper", mt = "progressBar__fill", T = {
  progressBar: dt,
  progressBarContainer: pt,
  progressBarWrapper: ut,
  progressBarFill: mt
};
function er({
  totalSteps: t,
  currentStep: r,
  stepLabel: o = "Step",
  ofLabel: n = "of"
}) {
  const a = Math.min(t, Math.max(0, r)), s = Math.min(
    100,
    Math.max(0, Math.round(a / t * 100))
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: T.progressBar }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: T.progressBarContainer }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", null, o, " ", a, " ", /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, n, " ", t))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: T.progressBarWrapper }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: T.progressBarFill,
      style: {
        width: `${s}%`
      }
    }
  )));
}
const bt = "radio", gt = "radio__icon", _t = "radio__icon--dark-bg", xt = "radio__icon--error", yt = "radio__input", k = {
  radio: bt,
  radioIcon: gt,
  radioIconDarkBg: _t,
  radioIconError: xt,
  radioInput: yt
};
function tr({
  label: t,
  name: r,
  checked: o,
  onChange: n,
  disabled: a,
  error: s,
  onDarkBackground: l,
  required: i
}) {
  const { isHovering: _, ref: d } = (0,_Logo_8772aba7_mjs__WEBPACK_IMPORTED_MODULE_2__.u)(), b = (0,_app_51178863_mjs__WEBPACK_IMPORTED_MODULE_3__.u)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "label",
    {
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(k.radio),
      ref: d,
      "data-hover": _,
      "aria-disabled": a
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
          k.radioIcon,
          s && k.radioIconError,
          (l === !0 || b) && k.radioIconDarkBg
        ),
        "aria-checked": o
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "input",
        {
          className: k.radioInput,
          type: "radio",
          checked: o,
          onChange: (p) => n?.(p.target.checked),
          name: r,
          required: i
        }
      )
    ),
    t
  );
}
const Et = "textarea", ht = "textarea__label", It = "textarea__label--required", Bt = "textarea__input", Ct = "textarea__input--error", At = "textarea__footer", ft = "textarea__errorMessage", B = {
  textarea: Et,
  textareaLabel: ht,
  textareaLabelRequired: It,
  textareaInput: Bt,
  textareaInputError: Ct,
  textareaFooter: At,
  textareaErrorMessage: ft
};
function Nt({
  label: t,
  errorMessage: r,
  onChange: o,
  onValueChange: n,
  maxLength: a = 500,
  ...s
}, l) {
  const i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), _ = (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
    _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsCaption,
    s.required && B.textareaLabelRequired,
    r && B.textareaLabelError
  ), d = (b) => {
    o?.(b);
    const p = b.target.value || "";
    n?.(p), i.current && (i.current.innerText = p.length.toString());
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: B.textarea }, t && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", { htmlFor: s.id, className: _ }, t), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "textarea",
    {
      ref: l,
      maxLength: a,
      rows: a / 100,
      ...s,
      onChange: d,
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
        B.textareaInput,
        _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsLeadText,
        r && B.textareaInputError
      )
    }
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: B.textareaFooter }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsCaption && B.textareaErrorMessage }, r), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsCaption }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { ref: i }, s.value?.length || 0), "/", a)));
}
const rr = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Nt), St = "text-input", vt = "text-input__label--required", kt = "text-input__container", Ut = "text-input__container__input_field", wt = "text-input__container__input_field--error", Lt = "text-input__container__icon_button", Tt = "text-input__container__icon_button--error", Pt = "text-input__container--error", Dt = "text-input__errorMessage", h = {
  textInput: St,
  textInputLabelRequired: vt,
  textInputContainer: kt,
  textInputContainerInputField: Ut,
  textInputContainerInputFieldError: wt,
  textInputContainerIconButton: Lt,
  textInputContainerIconButtonError: Tt,
  textInputContainerError: Pt,
  textInputErrorMessage: Dt
};
function Ft({
  label: t,
  dataTestid: r,
  buttonTargetId: o,
  iconState: n,
  errorMessage: a,
  onValueChange: s,
  onIconClick: l,
  buttonContent: i,
  helpText: _,
  ...d
}, b) {
  const p = (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
    _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsCaption,
    d.required && h.textInputLabelRequired
    // errorMessage && styles.textInputLabelError
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: h.textInput }, t && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", { className: p, htmlFor: `input-${d.name}` }, t), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
        _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsLeadText,
        h.textInputContainer,
        a && h.textInputContainerError
      ),
      "data-testid": r
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "input",
      {
        ...d,
        id: `input-${d.name}`,
        className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
          h.textInputContainerInputField,
          a && h.textInputContainerInputFieldError
        ),
        onChange: (E) => {
          s?.(E.target.value), d.onChange?.(E);
        },
        ref: b
      }
    ),
    n && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "button",
      {
        className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
          h.textInputContainerIconButton,
          a && h.textInputContainerIconButtonError
        ),
        onClick: l,
        "data-testid": o,
        title: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.c)(
          n === "SEARCH" && "Search",
          n === "CLEAR" && "Clear",
          n === "CHECK" && "Check"
        )
      },
      i,
      n === "SEARCH" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_5__.I, { icon: _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_5__.W.SEARCH, size: 20 }),
      n === "CLEAR" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_5__.I, { icon: _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_5__.W.CLOSE, size: 20 }),
      n === "CHECK" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_5__.I, { icon: _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_5__.W.CHECK, size: 20 })
    )
  ), _ && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsCaption }, _), a && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_4__.t.textsCaption && h.textInputErrorMessage
    },
    a
  ));
}
const or = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Ft);

//# sourceMappingURL=main.js.map


/***/ }),

/***/ 719:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 4364:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 7599:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 2126:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 5034:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7599);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 169:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 2050:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(2126);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(2164);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 3444:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(719);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(2126);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(2164);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 2164:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(719);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 9358:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ rt; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(403);
/* harmony import */ var _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2007);
/* harmony import */ var _app_51178863_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7610);




const S = "button", d = "button__default-focus-style-in-link", z = "button__primary-focus-style-in-link", f = "button__map", k = "button__primary", H = "button__menu-talent", I = "button__arrows", L = "button__secondary", T = "button__quiz", x = "button__menu-employer", Q = "employer", M = "desktop", D = "button__hero", P = "button__hero-talents", B = "button__hero-employer", R = "button__save-container", F = "button__save", w = "button__menu", A = "button__icon", h = "button__icon__container", q = "button__link", O = "button__quiz__label", g = "mobile", V = "button__quiz__divider", W = "button__quiz__text", G = "button__quiz__correct", U = "button__quiz__incorrect", e = {
  button: S,
  buttonDefaultFocusStyleInLink: d,
  buttonPrimaryFocusStyleInLink: z,
  buttonMap: f,
  buttonPrimary: k,
  buttonMenuTalent: H,
  buttonArrows: I,
  buttonSecondary: L,
  buttonQuiz: T,
  buttonMenuEmployer: x,
  employer: Q,
  desktop: M,
  buttonHero: D,
  buttonHeroTalents: P,
  buttonHeroEmployer: B,
  buttonSaveContainer: R,
  buttonSave: F,
  buttonMenu: w,
  buttonIcon: A,
  buttonIconContainer: h,
  buttonLink: q,
  buttonQuizLabel: O,
  mobile: g,
  buttonQuizDivider: V,
  buttonQuizText: W,
  buttonQuizCorrect: G,
  buttonQuizIncorrect: U
}, rt = {
  Default: (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)($),
  HeroTalents: (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Y),
  HeroEmployer: (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Z),
  Primary: (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(j),
  Secondary: (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(J),
  Save: (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(K),
  Arrow: (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(X),
  Menu: (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(tt),
  IconLabel: (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(et),
  DefaultFocusStyleInLink: e.buttonDefaultFocusStyleInLink,
  PrimaryFocusStyleInLink: e.buttonPrimaryFocusStyleInLink,
  Quiz: (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(nt),
  Link: (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(ot)
};
function $({ asDiv: u, ...o }, n) {
  const a = u ? "div" : "button";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    a,
    {
      ...o,
      ref: n,
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(e.button, o.className)
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.t.buttonTextPrimary) }, o.text),
    o.icon ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_2__.I, { icon: o.icon, size: 14 }) : null
  );
}
function j(u, o) {
  const { icon: n, text: a, onClick: s, asDiv: r, preventEmployerStyle: l, ...m } = u, y = (0,_app_51178863_mjs__WEBPACK_IMPORTED_MODULE_3__.u)(), E = r ? "div" : "button";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    E,
    {
      type: "button",
      ...m,
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        e.button,
        e.buttonPrimary,
        y && !l && e.employer,
        u.className
      ),
      onClick: s,
      ref: o
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: e.buttonMap }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.t.buttonTextPrimary) }, a), n ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_2__.I, { icon: n, size: 12 }) : null)
  );
}
function J(u, o) {
  const {
    icon: n,
    text: a,
    onClick: s,
    asDiv: r,
    preventEmployerStyle: l,
    iconPosition: m,
    ...y
  } = u, E = (0,_app_51178863_mjs__WEBPACK_IMPORTED_MODULE_3__.u)(), v = r ? "div" : "button";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    v,
    {
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        e.button,
        e.buttonSecondary,
        E && !l && e.employer,
        u.className
      ),
      onClick: s,
      type: "button",
      ...y,
      ref: o
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: e.buttonMap }, n && m === "left" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_2__.I, { icon: n, size: 12 }) : null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.t.buttonTextPrimary) }, a), n && m !== "left" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_2__.I, { icon: n, size: 12 }) : null)
  );
}
function K({ iconFilled: u, className: o, containerClassName: n, ...a }, s) {
  const r = (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
    e.buttonSaveContainer,
    n ?? ""
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: r }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "button",
    {
      type: "button",
      ...a,
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(e.button, e.buttonSave, o),
      ref: s,
      "aria-label": "save"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_2__.I,
      {
        icon: u ? _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_2__.W.HEART_FILLED : _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_2__.W.HEART,
        size: 20
      }
    )
  ));
}
function X({ arrowDirection: u, className: o, ...n }, a) {
  const s = (r) => {
    switch (r) {
      case "up":
        return _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_2__.W.CHEVRON_UP;
      case "down":
        return _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_2__.W.CHEVRON_DOWN;
      case "left":
        return _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_2__.W.CHEVRON_LEFT;
      case "right":
      default:
        return _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_2__.W.CHEVRON_RIGHT;
    }
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "button",
    {
      type: "button",
      ...n,
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(e.button, e.buttonArrows, o),
      ref: a,
      "aria-label": `arrow-${u}`
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_2__.I, { size: 20, icon: s(u) })
  );
}
function Y({ asDiv: u, ...o }, n) {
  const a = u ? "div" : "button";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    a,
    {
      type: "button",
      ...o,
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(e.button, e.buttonHeroTalents, o.className),
      ref: n
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.t.buttonHeroTitle) }, o.text)
  );
}
function Z({ asDiv: u, ...o }, n) {
  const a = u ? "div" : "button";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    a,
    {
      type: "button",
      ...o,
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        e.button,
        e.buttonHeroEmployer,
        o.className
      ),
      ref: n
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.t.buttonHeroTitle) }, o.text)
  );
}
function tt({ asDiv: u, isMenuOpen: o, ...n }, a) {
  const s = u ? "div" : "button", l = (0,_app_51178863_mjs__WEBPACK_IMPORTED_MODULE_3__.u)() ? e.buttonMenuEmployer : e.buttonMenuTalent;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    s,
    {
      type: "button",
      ...n,
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        e.button,
        e.buttonMenu,
        l,
        n.className
      ),
      ref: a,
      "aria-label": o ? "Close" : "Menu"
    },
    o ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_2__.I, { icon: _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_2__.W.CLOSE }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_2__.I, { icon: _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_2__.W.SEARCH }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_2__.I, { icon: _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_2__.W.HAMBURGER }))
  );
}
function et(u, o) {
  const { icon: n, text: a, textClassName: s, onClick: r, buttonClassName: l, ...m } = u, y = (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)("button " + e.buttonIcon, l), E = (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsLeadText, s);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", { className: y, onClick: r, type: "button", ...m, ref: o }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: e.buttonIconContainer }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: E }, a), n && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_2__.I,
    {
      icon: n.type,
      size: n.size,
      className: n.className,
      color: n.color
    }
  )));
}
function nt(u, o) {
  const {
    icon: n,
    text: a,
    onClick: s,
    asDiv: r,
    preventEmployerStyle: l,
    label: m,
    customClass: y,
    ...E
  } = u, v = (0,_app_51178863_mjs__WEBPACK_IMPORTED_MODULE_3__.u)(), C = r ? "div" : "button";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    C,
    {
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        e.button,
        e.buttonQuiz,
        v && !l && e.employer,
        y
      ),
      onClick: s,
      ...E,
      ref: o
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: e.buttonMap }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: e.buttonQuizLabel }, m), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: e.buttonQuizDivider }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: e.buttonQuizText }, a), n ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_2__.I, { icon: n, size: 29 }) : null)
  );
}
function ot(u, o) {
  const {
    onClick: n,
    asDiv: a,
    preventEmployerStyle: s,
    label: r,
    customClass: l,
    ...m
  } = u, y = (0,_app_51178863_mjs__WEBPACK_IMPORTED_MODULE_3__.u)(), E = a ? "div" : "button";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    E,
    {
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        e.button,
        e.buttonLink,
        y && !s && e.employer,
        l
      ),
      onClick: n,
      type: "button",
      ...m,
      ref: o
    },
    r
  );
}

//# sourceMappingURL=Button-eec2778c.mjs.map


/***/ }),

/***/ 316:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ y; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(403);
/* harmony import */ var _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2007);



const b = "cta-container", B = "cta-content", D = "text", k = "text--white-color", h = "text__disabled-default", p = "text__disabled-default__svg", N = "text__svg-blue-background__svg", W = "text__svg-white-background__svg", t = {
  ctaContainer: b,
  ctaContent: B,
  text: D,
  textWhiteColor: k,
  textDisabledDefault: h,
  textDisabledDefaultSvg: p,
  textSvgBlueBackgroundSvg: N,
  textSvgWhiteBackgroundSvg: W
};
function y(i) {
  const {
    text: r = "Call to Action",
    isDisabled: e,
    isBlueBackground: a,
    containerClassName: g,
    textClassName: x,
    to: n,
    as: d = "a",
    ...u
  } = i;
  let c;
  n && (c = {
    href: n,
    target: "_blank"
  });
  let l = d;
  e && (l = "div");
  const v = (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
    t.ctaContainer,
    g ?? ""
  ), m = (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.t.buttonTitle, t.text, {
    textClassName: x,
    [t.textWhiteColor]: a,
    [t.textDisabledDefault]: e,
    [t.textSvgBlueBackgroundSvg]: a
  }), _ = (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)({
    [t.textDisabledDefaultSvg]: e,
    [t.textSvgBlueBackgroundSvg]: a && !e,
    [t.textSvgWhiteBackgroundSvg]: !a && !e
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    l,
    {
      className: v,
      "aria-disabled": e,
      ...c,
      ...u
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: t.ctaContent }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: m }, r), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_2__.I,
      {
        className: _,
        icon: _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_2__.W.ARROW_UP_RIGHT,
        size: 12
      }
    ))
  );
}

//# sourceMappingURL=CallToAction-b7ee6480.mjs.map


/***/ }),

/***/ 3978:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ Ne; }
/* harmony export */ });
/* unused harmony export u */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(403);
/* harmony import */ var _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7720);
/* harmony import */ var _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2007);
/* harmony import */ var _index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8517);





const ee = "dropdown", te = "dropdown__button", oe = "dropdown__count-badge", ne = "dropdown__button--large", se = "dropdown__button--disabled", re = "dropdown__filter", ae = "mobile", de = "dropdown__list", le = "desktop", ce = "dropdown__list-item", ue = "dropdown__list-empty-message", ie = "dropdown__checkbox", pe = "dropdown__button--open", I = {
  dropdown: ee,
  dropdownButton: te,
  dropdownCountBadge: oe,
  dropdownButtonLarge: ne,
  dropdownButtonDisabled: se,
  dropdownFilter: re,
  mobile: ae,
  dropdownList: de,
  desktop: le,
  dropdownListItem: ce,
  dropdownListEmptyMessage: ue,
  dropdownCheckbox: ie,
  dropdownButtonOpen: pe
}, me = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function({
  isOpen: e,
  selectedItems: t,
  label: n,
  onClick: s,
  isLarge: d,
  isMulti: i,
  className: l,
  ...u
}, p) {
  const B = t.length, m = (0,_index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_1__.a)(
    (b) => {
      b.stopPropagation(), s?.(b);
    }
  ), { disabled: x } = { ...u }, h = typeof n == "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "label",
    {
      className: e ? _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsLeadTextBold : _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsLeadText
    },
    i ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, n, " ", /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(W, { count: B })) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, t[0]?.label || n)
  ) : (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(n, { isOpen: e, selectedItems: t, isMulti: i });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "button",
    {
      "data-testid": "dropdown-button",
      "aria-label": n.toString(),
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
        I.dropdownButton,
        d && I.dropdownButtonLarge,
        x && I.dropdownButtonDisabled,
        e && I.dropdownButtonOpen,
        l
      ),
      type: "button",
      ...u,
      onClick: m,
      ref: p
    },
    h,
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_3__.I,
      {
        icon: e ? _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_3__.W.CHEVRON_UP : _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_3__.W.CHEVRON_DOWN,
        size: 16
      }
    )
  );
}), we = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function({
  isOpen: e,
  getItemProps: t,
  checkSelected: n,
  items: s,
  highlightedIndex: d,
  emptyMessage: i,
  isMulti: l,
  className: u,
  name: p,
  showFilterInput: B = !1,
  ...m
}, x) {
  const [h, b] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), C = h ? s?.filter((r) => {
    if (r && r.label)
      return r.label.toLowerCase().startsWith(h.toLowerCase());
  }) : s, E = (r) => {
    const c = r.target.value, f = c.charAt(0).toUpperCase() + c.slice(1);
    b(f);
  };
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    e || b("");
  }, [e]), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, e && B && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "input",
    {
      type: "text",
      value: h,
      onChange: E,
      tabIndex: e ? 0 : -1,
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(I.dropdownFilter, _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsLeadTextBold),
      autoFocus: e
    }
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "ul",
    {
      ...m,
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(I.dropdownList, u),
      ref: x,
      "data-testid": "dropdown-list",
      hidden: !e
    },
    C.length > 0 ? C.map((r, c) => {
      const f = n(r.value);
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "li",
        {
          className: I.dropdownListItem,
          "data-highlighted": d === c,
          key: `${r.value}${c}`,
          "aria-selected": f,
          ...t({ item: r.value, index: c }),
          "data-testid": "dropdown-list-item-" + c,
          tabIndex: 0
        },
        l ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(fe, { checked: f }) : null,
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", { className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsLeadText) }, r.label, r.count ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(W, { count: r.count }) : null),
        p ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          "input",
          {
            hidden: !0,
            key: r.value,
            name: p,
            checked: f,
            value: r.value,
            type: l ? "checkbox" : "radio",
            onChange: ge
          }
        ) : null
      );
    }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", { className: I.dropdownListEmptyMessage }, i)
  ));
});
function fe({ checked: o = !1 }) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: I.dropdownCheckbox, "aria-checked": o }, o && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_3__.I, { icon: _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_3__.W.CHECK }));
}
function W({ count: o }) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: I.dropdownCountBadge, "aria-hidden": "true" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsCaption }, o));
}
function ge() {
}
function z(o, e) {
  const t = e?.replace(/\s/g, "-").replace(/[^\w]/gi, "");
  return `dropdown-${o}-list-item-${t}`;
}
function he(o, e, t, n) {
  const s = () => t(0), d = () => t(e - 1), i = () => t((u) => Math.min(u + 1, e - 1)), l = () => t((u) => Math.max(0, u - 1));
  if (o.key === "Tab") {
    o.preventDefault(), o.shiftKey ? l() : i();
    return;
  }
  if (o.key === "ArrowDown") {
    o.preventDefault(), o.metaKey ? d() : i();
    return;
  }
  if (o.key === "ArrowUp") {
    o.preventDefault(), o.metaKey ? s() : l();
    return;
  }
  if (o.key === "Enter" || o.key === " ")
    return o.preventDefault(), n();
}
function be(o, e) {
  const [t, n] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    () => e[t],
    [e, t]
  ), d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => z(o, s()?.value),
    [o, s]
  );
  return {
    highlightedIndex: t,
    highlightedItemId: d,
    setHighlightedIndex: n,
    getItemFromHighlightedIndex: s
  };
}
function Ie(o, e, t, n) {
  const [s, d] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (p = 0) => {
      d(!0), n?.(!0), e.current?.focus(), t(p);
    },
    [e, n, t]
  ), l = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (p = !1) => {
      d(!1), n?.(!1), p && o.current?.focus();
    },
    [o, n]
  ), u = (0,_index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_1__.a)(
    () => s ? l(!0) : i(0)
  );
  return { isOpen: s, openMenu: i, closeMenu: l, toggleMenu: u };
}
function Ee(o, e) {
  const t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(
    () => new Set(
      (e || o || []).map(
        (s) => s.value
      )
    )
  ), n = t[1];
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    e && n((s) => (s.clear(), e.forEach((d) => s.add(d.value)), s));
  }, [e, n]), t;
}
function ke(o, e, t) {
  const n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (t)
      return;
    const s = e.current?.querySelector("#" + o);
    n.current && s?.scrollIntoView({
      block: "nearest",
      inline: "nearest",
      behavior: "smooth"
    });
  }, [t, o, e]), n;
}
function ye(o) {
  const {
    id: e,
    items: t = [],
    initialSelectedItems: n,
    selectedItems: s,
    enableCloseOnSelect: d = !1,
    onOpenStateChange: i,
    onSelectedItemsChange: l,
    isMulti: u = !0,
    disabled: p
  } = o, B = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)(), m = (e || B).replace(/:/g, ""), x = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), h = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), {
    highlightedIndex: b,
    highlightedItemId: C,
    setHighlightedIndex: E,
    getItemFromHighlightedIndex: r
  } = be(m, t), { isOpen: c, closeMenu: f, openMenu: N, toggleMenu: F } = Ie(
    x,
    h,
    E,
    i
  ), D = ke(
    C,
    h,
    !c
  ), [g, L] = Ee(n, s), k = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (w) => g.has(w),
    [g]
  ), K = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (w) => {
      const y = w || r().value;
      if (u) {
        k(y) ? g.delete(y) : g.add(y), L(g);
        const M = t.filter(
          (V) => g.has(V.value)
        );
        l?.(M), d && f(!0);
      } else
        k(y) ? (L(/* @__PURE__ */ new Set()), l?.([])) : (L(/* @__PURE__ */ new Set([y])), l?.(
          t.filter((M) => M.value === y)
        )), f(!0);
    },
    [
      r,
      k,
      g,
      L,
      t,
      l,
      d,
      f,
      u
    ]
  ), q = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => ({
    id: `dropdown-${m}-button`,
    ref: x,
    "aria-expanded": c,
    "aria-haspopup": "listbox",
    onClick: F,
    onKeyUp: () => {
      D.current = !1;
    },
    onKeyDown: (w) => {
      if (D.current = !0, w.key === "ArrowDown")
        return w.preventDefault(), N();
    },
    disabled: p
  }), [m, c, F, p, D, N]), j = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => ({
    id: `dropdown-${m}-list`,
    ref: h,
    tabIndex: -1,
    role: "listbox",
    "aria-activedescendant": C,
    "data-open": c,
    onKeyUp: () => {
      D.current = !1;
    },
    onKeyDown: (w) => (D.current = !0, he(
      w,
      t.length,
      E,
      K
    ))
  }), [
    m,
    C,
    c,
    D,
    t.length,
    E,
    K
  ]), G = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    ({ item: w, index: y }) => {
      const M = b === y, V = k(w);
      return {
        id: z(m, w),
        role: "option",
        "aria-selected": V,
        "aria-current": M,
        onClick: () => K(w),
        onMouseEnter: () => E(y),
        onTouchStart: () => E(y)
      };
    },
    [
      b,
      k,
      m,
      K,
      E
    ]
  ), J = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => t.filter((w) => g.has(w.value)),
    [t, g]
  );
  return {
    uuid: m,
    isOpen: c,
    highlightedIndex: b,
    selectedItemsValues: g,
    selectedItems: J,
    checkSelected: k,
    openMenu: N,
    closeMenu: f,
    getMenuProps: j,
    getMenuItemProps: G,
    getUpdatedToggleButtonProps: q
  };
}
const Ne = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(e, t) {
  const n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), {
    label: s,
    name: d,
    items: i = [],
    emptyMessage: l = "No items available",
    size: u = "normal",
    isMulti: p = !0,
    className: B,
    buttonClassName: m,
    listClassName: x,
    autoFocus: h = !1,
    showFilterInput: b = !1,
    disabled: C
  } = e, {
    uuid: E,
    isOpen: r,
    highlightedIndex: c,
    selectedItems: f,
    getMenuProps: N,
    getMenuItemProps: F,
    checkSelected: D,
    getUpdatedToggleButtonProps: g,
    openMenu: L,
    closeMenu: k
  } = ye(e);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useImperativeHandle)(
    t,
    () => ({
      open: L,
      close: k,
      isOpen: r
    }),
    [L, k, r]
  ), (0,_useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_4__.u)([n], k, { disabled: !r }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      id: `dropdown-${E}`,
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(I.dropdown, B),
      "data-testid": "dropdown",
      ref: n
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      me,
      {
        isOpen: r,
        label: s,
        selectedItems: e.selectedItems || f,
        isLarge: u === "large",
        isMulti: p,
        className: m,
        ...g(),
        autoFocus: h
      }
    ),
    !C && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      we,
      {
        isOpen: r,
        items: i,
        getItemProps: F,
        checkSelected: D,
        highlightedIndex: c,
        emptyMessage: l,
        isMulti: p,
        className: x,
        name: d,
        ...N(),
        showFilterInput: b
      }
    )
  );
});
function Me() {
  return S(null);
}

//# sourceMappingURL=Dropdown-cd8250f9.mjs.map


/***/ }),

/***/ 2007:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ D0; },
/* harmony export */   "W": function() { return /* binding */ y0; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);

const E = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M4 4H2v16h2v-4h16v4h2v-6H4z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M7.5 13c1.4 0 2.5-1.1 2.5-2.5S8.9 8 7.5 8 5 9.1 5 10.5 6.1 13 7.5 13zm0-3.3c.4 0 .8.4.8.8s-.4.8-.8.8-.8-.4-.8-.8.4-.8.8-.8zM19.4 7.8H11V13h1.9V9.7h6.5c.4 0 .7.3.7.8V13H22v-2.6c0-1.4-1.2-2.6-2.6-2.6z" })
), g = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(E), p = g, d = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M5.3 17H2.1v1.9h3.3c1.3 0 2.5-.5 3.4-1.3l-1.3-1.3c-.7.4-1.4.7-2.2.7zM10.2 7.3 7.5 10l-.2.2c-.9 1.1-.9 2.7.1 3.7l3.6 3.6c.6.6.9 1.4.9 2.2V22h1.9v-2.3c0-1.3-.5-2.6-1.5-3.5l-3.6-3.6c-.3-.3-.3-.8 0-1.1l2.8-2.8c.5-.5 1.3-.5 1.7 0 .2.2.4.5.4.9s-.1.6-.4.9l-2 2 1.3 1.3 2-2c.6-.6.9-1.4.9-2.2s-.3-1.6-.9-2.2c-1-1.3-3.1-1.3-4.3-.1zM17.5 2C16.1 2 15 3.1 15 4.5S16.1 7 17.5 7 20 5.9 20 4.5 18.9 2 17.5 2zm0 3.3c-.4 0-.8-.4-.8-.8s.4-.8.8-.8.8.4.8.8-.4.8-.8.8z" })
), M = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(d), i = M, S = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M11 3v15l-4.5-4.5-1.4 1.4 5.5 5.5c.4.4.9.6 1.4.6s1-.2 1.4-.6l5.5-5.5-1.4-1.4L13 18V3h-2z" })
), z = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(S), x = z, H = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M21 11H6l4.5-4.5-1.4-1.4-5.5 5.5c-.4.4-.6.9-.6 1.4 0 .5.2 1 .6 1.4l5.5 5.5 1.4-1.4L6 13h15v-2z" })
), R = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(H), C = R, L = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M3 13h15l-4.5 4.5 1.4 1.4 5.5-5.5c.4-.4.6-.9.6-1.4s-.2-1-.6-1.4l-5.5-5.5-1.4 1.4L18 11H3v2z" })
), O = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(L), A = O, B = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M13 21V6l4.5 4.5 1.4-1.4-5.5-5.5C13 3.2 12.5 3 12 3s-1 .2-1.4.6L5.1 9.1l1.4 1.4L11 6v15h2z" })
), T = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(B), V = T, F = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "m12.379 1.045-.07-.07-.071.07L.929 12.354l-.07.07.07.071.571.571.071.071.07-.07 11.31-11.309.07-.07-.07-.071-.572-.572Z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M13 12.812h.1V.9H1.19v1.008h10.903V12.81H13Z" })
), _ = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(F), f = _, N = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M18.5 2 7.8 12.6l3.5 3.5L22 5.5 18.5 2zm-7.8 10.6 7.8-7.8.7.7-7.8 7.8-.7-.7zM6.4 14.5c-1.8 0-2.7 1.5-3.2 3.1L2 22l4.4-1.2c1.6-.5 3.1-1.4 3.1-3.1 0-1.8-1.4-3.2-3.1-3.2zm-.5 4.4-1.1.3.3-1.1c.3-1.2.8-1.7 1.3-1.8.7 0 1.2.5 1.2 1.3 0 .7-1.1 1.2-1.7 1.3z" })
), $ = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(N), u = $, y = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M20 10.5c0-.6-.1-1.2-.2-1.7.8-.8 1-2 .4-3-.5-.8-1.3-1.3-2.2-1.3-.2 0-.5 0-.7.1-.8-.8-1.8-1.3-2.9-1.7C14.2 1.8 13.2 1 12 1s-2.2.8-2.4 1.9c-1.1.4-2.1.9-3 1.7-.2-.1-.4-.1-.7-.1-.8 0-1.7.5-2.1 1.3-.6 1-.4 2.3.4 3-.1.5-.2 1.1-.2 1.7 0 .6.1 1.2.2 1.7-.8.8-1 2-.4 3 .5.8 1.3 1.3 2.2 1.3.2 0 .5 0 .7-.1.7.6 1.5 1.1 2.3 1.5l-.6 2.2H4V22h16v-1.9h-4.3l-.6-2.2c.9-.4 1.6-.9 2.3-1.5.2.1.4.1.7.1.9 0 1.7-.4 2.2-1.3.6-1 .4-2.3-.4-3 0-.5.1-1.1.1-1.7zM18.1 6c.4 0 .7.2.9.5.2.5 0 1.1-.4 1.4-.2.1-.4.1-.5.1-.4 0-.7-.2-.9-.5-.3-.5-.1-1.1.4-1.4.1 0 .3-.1.5-.1zM12 2.5c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zm-6.9 4c.1-.3.5-.5.8-.5.2 0 .3 0 .5.1.5.3.7.9.4 1.4-.2.3-.5.5-.9.5-.1 0-.3 0-.5-.1-.4-.3-.6-.9-.3-1.4zm0 8c-.3-.5-.1-1.1.3-1.4.2 0 .4-.1.5-.1.4 0 .7.2.9.5.3.5.1 1.1-.4 1.4-.1.1-.3.1-.5.1-.3 0-.7-.2-.8-.5zm8.6 5.6h-3.5l.5-1.7c.4.1.8.1 1.3.1s.8 0 1.3-.1l.4 1.7zm-2.4-3.5L12 14l.7 2.6h-1.4zm1.6-6.4c-.1-.4-.5-.7-.9-.7s-.8.3-.9.7L9.4 16c-.5-.2-.9-.5-1.3-.8.4-.7.4-1.7 0-2.4-.5-.8-1.3-1.3-2.1-1.3-.1-.3-.1-.7-.1-1 0-.3 0-.7.1-1 .8 0 1.7-.5 2.1-1.2.4-.8.4-1.7 0-2.4.5-.4 1.1-.8 1.7-1 .5.6 1.3 1.1 2.2 1.1.9 0 1.7-.5 2.1-1.2.6.2 1.2.6 1.7 1-.4.7-.4 1.7 0 2.4.5.8 1.4 1.3 2.2 1.3.1.3.1.7.1 1 0 .3 0 .7-.1 1-.8 0-1.7.5-2.1 1.2-.5.8-.4 1.7 0 2.4-.4.3-.8.6-1.3.8l-1.7-5.7zm6 4.3c-.2.3-.5.5-.9.5-.2 0-.3 0-.5-.1-.5-.3-.6-.9-.4-1.4.2-.3.5-.5.9-.5.2 0 .3 0 .5.1.5.3.7.9.4 1.4z" })
), U = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(y), P = U, Z = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M17.9 10.8c.1-.9 0-1.8-.2-2.8-.5-2.6-.8-6-.8-6H7s-.3 3.4-.8 6C6 9 5.9 9.9 6 10.8c.3 2.7 2.5 4.7 5 5.1V20H7v2h10v-2h-4v-4.1c2.4-.4 4.6-2.3 4.9-5.1zM12 4h3.2c.1.9.2 1.9.4 3H8.4c.2-1.1.3-2.1.4-3H12zm-4 6.6c-.1-.5 0-1 0-1.6h7.8c.1.6.1 1.1 0 1.6-.2 2-1.9 3.1-3.4 3.4h-1.1c-1.4-.3-3-1.4-3.3-3.4z" })
), D = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Z), G = D, I = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M5 4h5v1.9H5zM17.6 12c-.1 0-.1 0 0 0l-1.1-5.4c-.1-.2 0-.4.1-.5.1-.1.2-.2.4-.2h3V4h-3c-.8 0-1.5.4-2 1s-.6 1.4-.5 2l.2 1H7.2l-.7 4C4 12 2 14 2 16.5S4 21 6.5 21s4.5-2 4.5-4.5c0-1.8-1.1-3.4-2.7-4.1l.5-2.5h6.3l.5 2.6c-1.5.7-2.6 2.3-2.6 4 0 2.5 2 4.5 4.5 4.5s4.5-2 4.5-4.5-1.9-4.5-4.4-4.5zm-8.4 4.5c0 1.5-1.2 2.7-2.7 2.7S3.8 18 3.8 16.5c0-1.4 1-2.5 2.3-2.7l-.5 3h1.9l.5-2.5c.7.4 1.2 1.3 1.2 2.2zm8.4 2.7c-1.5 0-2.7-1.2-2.7-2.7 0-.9.4-1.7 1.1-2.2l.5 2.5h1.9l-.6-3c1.4.1 2.4 1.3 2.4 2.7.1 1.5-1.1 2.7-2.6 2.7z" })
), k = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(I), b = k, Y = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M5.6 6.2c.9 0 1.6-.7 1.6-1.6S6.5 3 5.6 3C4.7 3 4 3.7 4 4.6s.7 1.6 1.6 1.6zM9.9 6.2c.9 0 1.6-.7 1.6-1.6S10.8 3 9.9 3c-.9 0-1.6.7-1.6 1.6S9 6.2 9.9 6.2zM14.1 6.2c.9 0 1.6-.7 1.6-1.6S15 3 14.1 3s-1.6.7-1.6 1.6.7 1.6 1.6 1.6z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 18.4, cy: 4.6, r: 1.6 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M5.6 17.8c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6 0-.9-.7-1.6-1.6-1.6zM9.9 17.8c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6 0-.9-.7-1.6-1.6-1.6zM14.1 17.8c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6s1.6-.7 1.6-1.6c0-.9-.7-1.6-1.6-1.6zM18.4 17.8c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6s1.6-.7 1.6-1.6c0-.9-.7-1.6-1.6-1.6zM20 16V8H4v8h16zm-1.8-6.2v4.4H5.8V9.8h12.4z" })
), K = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Y), j = K, q = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 770 392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M404.975-198.944c-32.127 19.292-75.9 55.64-82.19 125.216-5.483 60.644 37.02 117.455 86.545 137.757C238.619 22.203 6.016 116.129.26 294.745c-3.277 47.683 27.406 87.822 54.99 123.907l.032.041c1.284 1.68 2.56 3.35 3.827 5.012 70.754 76.44 184.136 108.056 284.054 79.144 32.211-9.572 63.408-23.482 92.266-41.175-17.978 14.924-32.22 33.263-40.903 54.955-17.468 38.168-2.08 82.524 28.645 108.472 4.454 4.232 9.2 7.987 14.158 11.391-15.295-6.014-29.823-10.147-41.347-12.795-29.737-6.864-75.745-11.284-121.181 12.48-45.436 23.764-51.727 95.056-46.684 129.844 5.043 34.788 39.146 68.224 90.873 84.084 51.726 15.86 107.3 17.16 145.146 0 37.846-17.16 84.582-59.436 68.154-124.124-7.364-28.999-27.286-50.662-50.718-66.587 6.269 2.784 12.523 5.573 18.643 8.555 4.797 2.348 10.518 5.471 16.827 8.914l.002.001.001.001c16.045 8.757 35.893 19.591 54.027 25.04 46.207 12.328 96.077-11.716 138.134-31.992 2.469-1.19 4.912-2.368 7.325-3.524 27.916-14.56 43.304-45.292 50.323-75.296 31.241-169.17-182.454-214.889-303.092-148.579 13.247-9.854 25.831-20.565 37.596-32.069 61.76-58.812 90.457-173.42 70.338-214.552a203.27 203.27 0 0 0-12.581-26.495 89.667 89.667 0 0 1 1.508 2.419c2.406 3.99 4.469 8.179 6.531 12.369l.001.001c2.749 5.586 5.499 11.172 9.064 16.282a45.394 45.394 0 0 0 4.939 6.032 51.623 51.623 0 0 0 16.583 11.492c2.652 1.144 5.355 2.132 8.058 3.12.431.159.86.318 1.288.478 2.106.783 4.194 1.561 6.354 2.122 2.252.58 4.523 1.059 6.79 1.538 1.397.295 2.792.589 4.179.906a168.297 168.297 0 0 0 38.158 4.212c6.603 0 13.205-.416 19.755-1.248a105.529 105.529 0 0 0 9.826-1.872c.179-.039.36-.078.542-.115l.356-.073c1.129-.23 2.276-.463 3.261-.956 1.039-.572 2.131-.988 3.275-1.352a96.568 96.568 0 0 0 16.843-6.76c4.055-2.08 7.954-4.368 11.749-6.968a100.253 100.253 0 0 0 23.498-21.944c1.716-2.236 3.275-4.576 4.731-6.968 6.706-11.284 10.605-23.972 11.437-37.076.52-7.852.104-16.068-2.131-23.608a185.086 185.086 0 0 0-2.496-7.592 133.319 133.319 0 0 0-4.782-11.284 98.832 98.832 0 0 0-1.664-3.328c-4.939-9.464-11.073-18.252-18.195-26.208a123.18 123.18 0 0 0-24.174-20.8c-4.471-2.912-9.098-5.564-13.932-7.852-1.43-.682-2.844-1.395-4.259-2.108-3.113-1.57-6.229-3.14-9.518-4.392-5.926-2.236-12.009-3.9-18.299-4.94-3.015-.468-6.03-.832-9.046-1.04-1.403-.156-2.755-.208-4.159-.104-.332.024-.654.091-.969.157h-.001c-.375.079-.742.155-1.109.155-1.04-.052-2.132-.156-3.171-.364-4.419-.416-8.89 0-13.205 1.248a49.597 49.597 0 0 0-5.683 1.901 135.417 135.417 0 0 0 7.919-6.113c53.13-44.304 35.403-144.196 15.18-177.112s-96.903-84.76-155.96-75.92c-59.057 8.84-72.521 12.896-93.212 25.324Zm136.406 342.201c-27.576-34.362-65.609-58.24-108.845-72.566 49.006 8.31 124.229 4.145 178.334-23.595-1.293.973-2.579 1.956-3.865 2.939-5.762 4.404-11.521 8.807-17.894 12.27-4.745 2.582-9.749 4.58-14.743 6.573l-.004.002h-.001c-2.444.976-4.886 1.95-7.294 2.992-7.33 3.172-14.66 7.02-20.171 12.844-6.966 7.384-11.073 17.68-11.853 27.768a39.72 39.72 0 0 0 .208 8.944c.052.572.104 1.144.104 1.716.052 1.3.156 2.6.312 3.9.208 1.768.572 3.484 1.04 5.2.52 1.612 1.092 3.224 1.82 4.784a59.694 59.694 0 0 0 2.852 6.229Z"
    }
  )
), J = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(q), Q = J, X = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 7, cy: 15, r: 1 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 17, cy: 15, r: 1 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M6 18.1h12v1.8H6z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M18 2H6C3.8 2 2 3.8 2 6v16h2v-8c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v8h2V6c0-2.2-1.8-4-4-4zm0 8H6c-.7 0-1.4.2-2 .6V6c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v4.6c-.6-.4-1.3-.6-2-.6z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M9.5 5.2h5V7h-5z" })
), W = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(X), e1 = W, t1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 7, cy: 15, r: 1 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 17, cy: 15, r: 1 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M6 18.1h12v1.8H6z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "m19.9 10.5-.6-4.1c-.3-2-2-3.4-4-3.4H8.6c-2 0-3.7 1.5-4 3.4L4 10.5c-1.2.7-2 2-2 3.5v8h2v-8c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v8h2v-8c0-1.5-.8-2.8-2.1-3.5zM8.6 5h6.8c1 0 1.8.7 2 1.7l.5 3.3H6.2l.5-3.3c.1-1 .9-1.7 1.9-1.7z" })
), c1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(t1), r1 = c1, l1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      className: "Check_svg__st0",
      d: "M10 18c-.2 0-.5-.1-.7-.3l-6-5.4 1.3-1.5 5.3 4.8 10.4-9.4 1.3 1.5-11 10c-.2.2-.4.3-.6.3z"
    }
  )
), n1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(l1), h1 = n1, a1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M19.7 9.7 12 17.4 4.3 9.7l1.4-1.4 6.3 6.3 6.3-6.3z" })
), s1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(a1), m1 = s1, o1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M14.3 19.7 6.6 12l7.7-7.7 1.4 1.4L9.4 12l6.3 6.3z" })
), v1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(o1), w1 = v1, E1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "m9.7 4.3 7.7 7.7-7.7 7.7-1.4-1.4 6.3-6.3-6.3-6.3z" })
), g1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(E1), p1 = g1, d1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M4.3 14.3 12 6.6l7.7 7.7-1.4 1.4L12 9.4l-6.3 6.3z" })
), M1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(d1), i1 = M1, S1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M10.3 8.4c0-.9-.8-1.6-1.6-1.6-.9 0-1.6.8-1.6 1.6 0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6zM2 3h9v2H2zM5.9 8.4c0-.9-.7-1.6-1.6-1.6s-1.6.7-1.6 1.6.7 1.6 1.6 1.6 1.6-.8 1.6-1.6zM21.3 8.4c0-.9-.8-1.6-1.6-1.6-.9 0-1.6.8-1.6 1.6 0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6zM13 3h9v2h-9zM16.9 8.4c0-.9-.8-1.6-1.6-1.6s-1.6.8-1.6 1.6c0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6zM8.7 17.8c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6s1.6-.7 1.6-1.6c0-.9-.7-1.6-1.6-1.6zM2 14h9v2H2zM4.3 17.8c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6s1.6-.7 1.6-1.6c0-.9-.7-1.6-1.6-1.6zM19.7 17.8c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6s1.6-.7 1.6-1.6c0-.9-.7-1.6-1.6-1.6zM13 14h9v2h-9zM15.3 17.8c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6s1.6-.7 1.6-1.6c0-.9-.7-1.6-1.6-1.6z" })
), z1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(S1), x1 = z1, H1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M13 6h-2v7h6v-2h-4z" })
), R1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(H1), C1 = R1, L1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M21 4.4 19.6 3 12 10.6 4.4 3 3 4.4l7.6 7.6L3 19.6 4.4 21l7.6-7.6 7.6 7.6 1.4-1.4-7.6-7.6z" })
), O1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(L1), A1 = O1, B1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M10.3 7c1.8 0 3.5 1.1 3.9 3.2h2.5c1.8 0 3.4 1.5 3.4 3.4S18.6 17 16.7 17H6.5C5.2 17 4 15.8 4 14.2c0-1.2 1.1-2.5 2.5-2.6C6.1 8.5 8.1 7 10.3 7m0-2c-1.8 0-3.4.7-4.5 1.9-.6.7-1.2 1.7-1.4 3.3C3 11 2 12.6 2 14.2 2 16.8 4 19 6.5 19h10.2c3 0 5.4-2.4 5.4-5.4s-2.4-5.4-5.4-5.4h-1c-1.1-2-3.1-3.2-5.4-3.2z" })
), T1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(B1), V1 = T1, F1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M3 18h6.3v2H3z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M21 15.6V4H3v11.7h8V20h10v-2h-8v-2.4h8zm-3.4-9.7-3.9 3.5c-.9.8-2.4.8-3.3 0l-4-3.5h11.2zM4.9 7l4.3 3.7c.8.7 1.8 1 2.8 1s2.1-.3 2.8-1L19.1 7v6.8H4.9V7z" })
), _1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(F1), f1 = _1, N1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M24 0v24H0V0" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M19.5 2h-10C8.7 2 8 2.7 8 3.5V7H4.5C3.7 7 3 7.7 3 8.5v12c0 .8.7 1.5 1.5 1.5h10c.8 0 1.5-.7 1.5-1.5V17h3.5c.8 0 1.5-.7 1.5-1.5v-12c0-.8-.7-1.5-1.5-1.5zM14 20H5V9h9v11zm5-5h-3V8.5c0-.8-.7-1.5-1.5-1.5H10V4h9v11z" })
), $1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(N1), u1 = $1, y1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M20 9v8c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V9H2v8c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V9h-2z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "m16.7 11.7-1.4-1.4-2.3 2.4V2h-2v10.7l-2.3-2.4-1.4 1.4 4.7 4.6z" })
), U1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(y1), P1 = U1, Z1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 18",
    xmlSpace: "preserve",
    ref: c,
    ...t,
    fill: "none"
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M21.6471 11.7391L9.54924 11.7391M0.647064 11.7391H3.15793", stroke: "currentColor" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: "6.58184", cy: "3.52174", r: "2.23913", stroke: "currentColor" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: "16.1688", cy: "3.52174", r: "2.23913", stroke: "currentColor" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M19.3645 10.3696L19.8636 10.3402C19.8642 10.35 19.8645 10.3598 19.8645 10.3696L19.3645 10.3696ZM18.8653 10.3989C18.7694 8.76773 17.5494 7.96774 16.3128 7.97109C15.6918 7.97278 15.0946 8.18101 14.659 8.57219C14.232 8.95555 13.9297 9.54104 13.9297 10.3696L12.9297 10.3696C12.9297 9.27368 13.3407 8.41192 13.9908 7.82813C14.6323 7.25217 15.476 6.97336 16.3101 6.9711C17.9839 6.96655 19.7313 8.09097 19.8636 10.3402L18.8653 10.3989ZM19.8645 10.3696L19.8645 11.0544L18.8645 11.0544L18.8645 10.3696L19.8645 10.3696ZM13.9297 10.3696L13.9297 11.0543L12.9297 11.0543L12.9297 10.3696L13.9297 10.3696Z", fill: "currentColor" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M9.77749 10.3695L10.2766 10.3402C10.2772 10.35 10.2775 10.3597 10.2775 10.3695L9.77749 10.3695ZM9.27836 10.3989C9.1824 8.7677 7.96244 7.9677 6.72586 7.97106C6.10478 7.97275 5.50764 8.18097 5.07198 8.57216C4.64503 8.95552 4.34271 9.54101 4.34271 10.3695L3.34271 10.3695C3.34271 9.27365 3.7537 8.41189 4.40387 7.8281C5.04531 7.25214 5.88907 6.97333 6.72315 6.97107C8.3969 6.96652 10.1443 8.09094 10.2766 10.3402L9.27836 10.3989ZM10.2775 10.3695L10.2775 17.2174L9.27749 17.2174L9.27749 10.3695L10.2775 10.3695ZM4.34271 10.3695L4.34271 17.2174L3.34271 17.2174L3.34271 10.3695L4.34271 10.3695Z", fill: "currentColor" })
), D1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Z1), G1 = D1, I1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 16",
    xmlSpace: "preserve",
    ref: c,
    ...t,
    fill: "none"
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M2.82352 16L2.82352 11.2737L2.82352 10.8235", stroke: "currentColor" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M18.8235 16L18.8235 11.2737L18.8235 10.8235", stroke: "currentColor" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M13.6471 8L14.1462 7.97064C14.1468 7.98041 14.1471 7.99021 14.1471 8L13.6471 8ZM13.1479 8.02936C13.0485 6.33838 11.7828 5.50874 10.5014 5.51222C9.85786 5.51396 9.23852 5.72969 8.78627 6.13578C8.34273 6.53403 8.02942 7.14183 8.02942 8L7.02942 8C7.02942 6.87446 7.4514 5.9904 8.11816 5.39171C8.7762 4.80086 9.64215 4.51455 10.4986 4.51222C12.2172 4.50755 14.0104 5.66162 14.1462 7.97064L13.1479 8.02936ZM14.1471 8L14.1471 8.70588L13.1471 8.70588L13.1471 8L14.1471 8ZM8.02942 8L8.02942 8.70588L7.02942 8.70588L7.02942 8L8.02942 8Z", fill: "currentColor" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: "3.76469", cy: "2.82353", r: "2.32353", stroke: "currentColor" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M0.941162 8.70588L0.941162 8C0.941162 5.97741 2.46997 4.90551 3.99999 4.94118", stroke: "currentColor" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: "2.82353", cy: "2.82353", r: "2.32353", transform: "matrix(-1 0 0 1 20.2353 0)", stroke: "currentColor" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M20.2353 8.70588L20.2353 8C20.2353 5.97741 18.7065 4.90551 17.1765 4.94118", stroke: "currentColor" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M21.6471 10.3529L1.88236 10.3529H5.30481e-06", stroke: "currentColor" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: "10.3529", cy: "2.82353", r: "2.32353", stroke: "currentColor" })
), k1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(I1), b1 = k1, Y1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12.1 15.2c-1 0-1.9-.5-2.2-1.4h2.9v-1.4H7.7c0 2.9 1.7 4.6 4.4 4.6 2.3 0 3.9-1.5 4.2-3.8l-2.1-.2c-.1 1.3-.9 2.2-2.1 2.2zM12.1 7c-2.6 0-4.3 1.8-4.4 4.6h5.2v-1.4h-3c.3-.8 1.2-1.4 2.2-1.4 1.2 0 2 .8 2.1 2.1l2.1-.2C16 8.4 14.3 7 12.1 7z" })
), K1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Y1), j1 = K1, q1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M16.6 4V2h-1.9v2H9V2H7v2H2v18h20V4h-5.4zM20 20H4V6h3v2h2V6h5.7v2h1.9V6H20v14z" })
), J1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(q1), Q1 = J1, X1 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      style: {
        fill: "none"
      },
      d: "M0 0h24v24H0z"
    }
  ),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M21.3 10c-1-1.3-2.3-2.4-3.7-3.3C16 5.7 14 5 11.9 5c-2 0-3.9.7-5.5 1.8-1.4.9-2.7 2-3.7 3.2-.5.6-.7 1.3-.7 2s.2 1.4.7 2c1.1 1.4 2.4 2.5 3.9 3.5 1.6 1 3.5 1.6 5.4 1.6s3.8-.5 5.4-1.6c1.5-.9 2.8-2.1 3.9-3.5.5-.6.7-1.2.7-2 0-.7-.3-1.4-.7-2zm-1.6 2.7c-.9 1.2-2.1 2.2-3.4 3-1.3.9-2.8 1.3-4.3 1.3s-3-.4-4.3-1.3c-1.3-.8-2.5-1.8-3.4-3-.2-.2-.3-.4-.3-.7 0-.2.1-.5.3-.7.9-1.1 2-2.1 3.2-2.9C8.8 7.5 10.3 7 11.9 7c1.6 0 3.3.5 4.6 1.4 1.2.8 2.3 1.7 3.2 2.9.2.2.3.4.3.7s-.1.5-.3.7z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12 8.8c-1.8 0-3.2 1.5-3.2 3.2s1.5 3.2 3.2 3.2 3.2-1.5 3.2-3.2-1.4-3.2-3.2-3.2zm0 4.6c-.8 0-1.4-.6-1.4-1.4 0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4 0 .8-.6 1.4-1.4 1.4z" })
), W1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(X1), e2 = W1, t2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M6.5 10.6C7.9 10.6 9 9.5 9 8.1S7.9 5.6 6.5 5.6 4 6.7 4 8.1s1.1 2.5 2.5 2.5zm0-3.3c.4 0 .8.4.8.8s-.4.8-.8.8-.8-.4-.8-.8.4-.8.8-.8zM17.5 7C18.9 7 20 5.9 20 4.5S18.9 2 17.5 2 15 3.1 15 4.5 16.1 7 17.5 7zm0-3.3c.4 0 .8.4.8.8s-.4.8-.8.8-.8-.4-.8-.8.4-.8.8-.8zM22 11.7c0-2.1-1.8-3.8-3.9-3.8h-1.2c-2.2 0-3.9 1.8-3.9 3.9V14c0 .6-.4 1-1 1-.5 0-.7-.2-1.2-1.1-.2-.3-.3-.6-.5-.8-.7-1-1.9-1.6-3.1-1.6H5.9c-2.2 0-3.9 1.8-3.9 3.9V22h2v-6.6c0-1.1.9-1.9 1.9-1.9h1.2c.6 0 1.2.3 1.5.8.2.2.3.4.4.7.5.9 1.2 2 3 2 1.7 0 3-1.3 3-3v-2.2c0-1.1.9-1.9 1.9-1.9h1.2c1 0 1.9.8 1.9 1.8V22h2V11.7z" })
), c2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(t2), r2 = c2, l2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M22 11h-3V7.5C19 5.6 17.4 4 15.5 4H13V2h-2v2H8.5C6.6 4 5 5.6 5 7.5V11H2l3 9H2v2h20v-2h-3l3-9zM7 7.5C7 6.7 7.7 6 8.5 6h7c.8 0 1.5.7 1.5 1.5V11H7V7.5zM7.1 20l-2.3-7h14.4l-2.3 7H7.1z" })
), n2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(l2), h2 = n2, a2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M10.8 4C10.4 2.8 9.3 2 8 2s-2.4.8-2.8 2H2v2h3.2C5.6 7.2 6.7 8 8 8s2.4-.8 2.8-2H22V4H10.8zM8 6.2c-.7 0-1.2-.5-1.2-1.2S7.3 3.8 8 3.8s1.2.5 1.2 1.2S8.7 6.2 8 6.2zM8 16c-1.3 0-2.4.8-2.8 2H2v2h3.2c.4 1.2 1.5 2 2.8 2s2.4-.8 2.8-2H22v-2H10.8c-.4-1.2-1.5-2-2.8-2zm0 4.2c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2 1.2.5 1.2 1.2-.5 1.2-1.2 1.2zM16 9c-1.3 0-2.4.8-2.8 2H2v2h11.2c.4 1.2 1.5 2 2.8 2s2.4-.8 2.8-2H22v-2h-3.2c-.4-1.2-1.5-2-2.8-2zm0 4.2c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2 1.2.5 1.2 1.2-.5 1.2-1.2 1.2z" })
), s2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(a2), m2 = s2, o2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M10 6.8c0 1.7-.7 2.1-1.6 2.2V2h-2v7C5.6 8.9 5 8.5 5 6.8V2H3v4.8c0 3.5 2.1 4.1 3.5 4.2v11h2V11c1.4 0 3.5-.7 3.5-4.2V2h-2v4.8zM16.7 2H15v20h2V4c1.3.1 2 .9 2 2.3v9.2h2V6.3C21 3.7 19.3 2 16.7 2z" })
), v2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(o2), w2 = v2, E2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm6.9 6h-3.3c-.2-1.4-.6-2.6-1-3.6 1.8.7 3.4 2 4.3 3.6zM14 12c0 .7 0 1.4-.1 2h-3.8c-.1-.6-.1-1.3-.1-2s0-1.4.1-2h3.8c.1.6.1 1.3.1 2zm-3.6 4h3.2c-.4 2.2-1.2 3.6-1.6 3.9-.4-.3-1.2-1.7-1.6-3.9zm0-8c.4-2.2 1.2-3.6 1.6-4 .4.3 1.2 1.7 1.6 4h-3.2zm-1-3.6c-.4 1-.8 2.2-1 3.6H5.1C6 6.4 7.6 5.1 9.4 4.4zM4.3 10h3.8c-.1.6-.1 1.3-.1 2s0 1.4.1 2H4.3c-.2-.6-.3-1.3-.3-2s.1-1.4.3-2zm.8 6h3.3c.2 1.4.6 2.6 1 3.6-1.8-.7-3.4-2-4.3-3.6zm9.5 3.6c.4-1 .8-2.2 1-3.6h3.3c-.9 1.6-2.5 2.9-4.3 3.6zm5.1-5.6h-3.8c.1-.6.1-1.3.1-2s0-1.4-.1-2h3.8c.2.6.3 1.3.3 2s-.1 1.4-.3 2z" })
), g2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(E2), p2 = g2, d2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M18.1 12.8h-.5c.4.6.7 1.3.8 2 .9.1 1.6.9 1.6 1.9V20h2v-3.3c0-2.1-1.8-3.9-3.9-3.9zM2 16.7V20h2v-3.3c0-.9.7-1.7 1.6-1.9.1-.7.4-1.4.8-2h-.5c-2.1 0-3.9 1.8-3.9 3.9zM16.9 15.8c0-2.4-1.7-3.9-3.8-3.9H11c-2.2 0-3.9 1.8-3.9 3.9V20h2v-4.2c0-1.1.9-1.9 1.9-1.9h2c1 0 1.9.8 1.9 1.9V20h2v-4.2zM12 10c1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.3-3 3 1.3 3 3 3zm0-4.3c.7 0 1.3.6 1.3 1.3s-.6 1.3-1.3 1.3-1.3-.6-1.3-1.3.6-1.3 1.3-1.3zM18.5 11.7c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5S16 7.8 16 9.2s1.1 2.5 2.5 2.5zm0-3.3c.4 0 .8.4.8.8s-.4.8-.8.8-.8-.4-.8-.8.4-.8.8-.8zM5.5 11.7c1.4 0 2.5-1.1 2.5-2.5S6.9 6.7 5.5 6.7 3 7.8 3 9.2s1.1 2.5 2.5 2.5zm0-3.3c.4 0 .8.4.8.8s-.4.8-.8.8-.8-.3-.8-.8.4-.8.8-.8z" })
), M2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(d2), i2 = M2, S2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M13 2H0V0h13v2ZM13 16H0v-2h13v2ZM0 9h20V7H0v2Z" })
), z2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(S2), x2 = z2, H2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M16.2 4C18.5 4 20 5.6 20 8c0 3.5-3.1 6.7-7.5 10.8l-.5.4-.5-.5C7.1 14.7 4 11.5 4 8c0-2.4 1.5-4 3.8-4 .9 0 1.7.3 2.4 1 .7.6 1.3.7 1.8.7s1.1-.1 1.8-.7c.7-.7 1.5-1 2.4-1m0-2c-1.4 0-2.7.5-3.8 1.5-.2.2-.2.2-.4.2s-.2 0-.4-.2C10.5 2.5 9.2 2 7.8 2 4.4 2 2 4.5 2 8c0 4.5 3.7 8.1 8.2 12.2L12 22l1.8-1.8C18.3 16.1 22 12.5 22 8c0-3.5-2.4-6-5.8-6z" })
), R2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(H2), C2 = R2, L2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M16.2 2c-1.4 0-2.7.5-3.7 1.5-.2.2-.2.2-.4.2s-.2 0-.4-.2C10.5 2.5 9.2 2 7.8 2 4.4 2 2 4.5 2 8c0 4.5 3.7 8.1 8.2 12.2L12 22l1.8-1.8C18.3 16.1 22 12.5 22 8c0-3.5-2.4-6-5.8-6z" })
), O2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(L2), A2 = O2, B2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12.2 14.1C8.6 13.2 7 11.5 7 8.4V2H5v6.4c0 2.3.7 4 2.1 5.3V22h2v-6.9c.8.4 1.6.7 2.7.9 3.4.8 4.2 1.3 4.2 4v2h2v-2c0-4.3-2.3-5.1-5.8-5.9z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12.6 12c2.1 0 3.9-1.7 3.9-3.9s-1.7-3.9-3.9-3.9c-2.1 0-3.9 1.7-3.9 3.9s1.7 3.9 3.9 3.9zm0-5.8c1 0 1.9.8 1.9 1.9 0 1-.8 1.9-1.9 1.9-1 0-1.9-.8-1.9-1.9 0-1 .8-1.9 1.9-1.9z" })
), T2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(B2), V2 = T2, F2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M11 11h2v7h-2z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 12, cy: 7.5, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z" })
), _2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(F2), f2 = _2, N2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M14 16v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1h4z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M7.9 16v-1c0-2.3 1.8-4.1 4.1-4.1s4.1 1.8 4.1 4.1v1H18v-1c0-3.3-2.7-6-6-6s-6 2.7-6 6v1h1.9z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M3.9 16v-1c0-4.5 3.6-8.1 8.1-8.1s8.1 3.6 8.1 8.1v1H22v-1c0-5.5-4.5-10-10-10S2 9.5 2 15v1h1.9z" })
), $2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(N2), u2 = $2, y2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M9 4h13v2H9zM9 18h13v2H9zM9 11h13v2H9zM4.5 2.5C3.1 2.5 2 3.6 2 5s1.1 2.5 2.5 2.5S7 6.4 7 5 5.9 2.5 4.5 2.5zm0 3.2c-.4 0-.7-.3-.7-.7s.3-.7.7-.7.7.3.7.7-.3.7-.7.7zM4.5 16.5C3.1 16.5 2 17.6 2 19s1.1 2.5 2.5 2.5S7 20.4 7 19s-1.1-2.5-2.5-2.5zm0 3.2c-.4 0-.7-.3-.7-.7s.3-.7.7-.7.7.3.7.7-.3.7-.7.7zM4.5 9.5C3.1 9.5 2 10.6 2 12s1.1 2.5 2.5 2.5S7 13.4 7 12 5.9 9.5 4.5 9.5zm0 3.2c-.4 0-.7-.3-.7-.7s.3-.7.7-.7.7.3.7.7-.3.7-.7.7z" })
), U2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(y2), P2 = U2, Z2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 12, cy: 10.5, r: 3 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M18.5 3.7C16.7 1.9 14.4 1 12 1c-2.4 0-4.7.9-6.5 2.7-1.8 1.8-2.7 4.1-2.7 6.4 0 2.3.9 4.7 2.7 6.4L12 23l6.5-6.5c1.8-1.8 2.7-4.1 2.7-6.4 0-2.3-.9-4.7-2.7-6.4zm-1.4 11.4L12 20.2l-5.1-5.1c-1.3-1.3-2.1-3.1-2.1-5s.7-3.7 2.1-5C8.3 3.7 10.1 3 12 3c1.9 0 3.7.7 5.1 2.1 1.3 1.3 2.1 3.1 2.1 5s-.8 3.7-2.1 5z" })
), D2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Z2), G2 = D2, I2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M16.7 3.7c-1.1.3-1.8.3-2.6.1L10 2.4c-.9-.3-1.8-.3-2.8-.1L2 3.3v18.1l5.6-1.1c.6-.1 1.2-.1 1.8.1l4.1 1.4c.5.2 1 .2 1.5.2.6 0 1.4-.1 2.2-.3l4.8-1.5V2l-5.3 1.7zM7.2 18.4l-3.3.7V4.9l3.7-.7c.2 0 .3-.1.5-.1v14.3c-.3-.1-.6 0-.9 0zm2.9.2h-.2V4.4l3.6 1.2c.2.1.4.1.6.2V20l-4-1.4zm10 .2-3.4 1.1c-.3.1-.5.1-.8.2V5.8c.4-.1.9-.2 1.3-.3l2.9-.9v14.2z" })
), k2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(I2), b2 = k2, Y2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M2 4h13v2H2zM2 18h13v2H2zM2 11h20v2H2z" })
), K2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Y2), j2 = K2, q2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M2 11h20v2H2z" })
), J2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(q2), Q2 = J2, X2 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M6 3h12v2H6zM4 7h16v2H4zM6 19h12v2H6zM2 11h20v2H2zM4 15h16v2H4z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" })
), W2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(X2), ee = W2, te = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M6.6 6v.9c0 5.8 4.7 10.5 10.4 10.5.4 0 .7 0 1.1-.1-1.5 1.7-3.6 2.8-6 2.8-4.4 0-8.2-3.7-8.2-8.1 0-2.4 1.1-4.5 2.7-6M10 2.1c-4.5 1-8.1 5-8.1 9.9 0 5.6 4.7 10.1 10.2 10.1 4.9 0 8.9-3.5 9.8-8.4-1.4 1-3.1 1.6-4.9 1.6-4.6 0-8.4-3.8-8.4-8.5 0-1.7.5-3.4 1.4-4.7z" })
), ce = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(te), re = ce, le = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M2 20h20v2H2zM7.6 15.8c.7 0 1.5-.2 2.2-.5l9.8-4.1c1.5-.6 2.3-1.8 2.3-3.1 0-1-.4-1.8-1.2-2.3-.9-.6-2.2-.7-3.5-.2L14.3 7l-3.4-3c-1.1-1-2.3-1.2-3.5-.7l-2.1.9 2.3 5.6L4.7 11l-.9-2-1.8.8 1.2 2.9c.9 2 2.5 3.1 4.4 3.1zm2.6-5L7.9 5.2l.3-.1c.3-.1.8-.2 1.4.3l4.3 3.9 4.2-1.8c.6-.2 1.2-.2 1.6 0 .2.2.3.4.3.7 0 .7-.8 1.1-1.1 1.2l-9.8 4.1c-1.5.6-2.7.3-3.5-.8l4.6-1.9z" })
), ne = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(le), he = ne, ae = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M22 11h-9V2h-2v9H2v2h9v9h2v-9h9z" })
), se = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(ae), me = se, oe = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12 2C7 2 2 5.3 2 12h1.7c.4-1.1 1.3-1.7 2.2-1.7s1.7.6 2.1 1.7h1.7c.4-1.1 1.4-1.7 2.3-1.7s1.9.6 2.3 1.7H16c.4-1.1 1.3-1.7 2.2-1.7.9 0 1.8.6 2.1 1.7H22c0-6.7-5-10-10-10zm6.2 6.4c-1.2 0-2.3.5-3.1 1.4A4.1 4.1 0 0 0 12 8.4c-1.2 0-2.3.5-3.1 1.4a4.1 4.1 0 0 0-3.1-1.4c-.5 0-.9.1-1.3.2C5.8 5.4 9 3.9 12 3.9c3.1 0 6.2 1.5 7.5 4.7-.4-.1-.8-.2-1.3-.2zM11 19.4c0 .4-.3.7-.7.7s-.7-.3-.7-.7v-1H7.7v1c0 1.5 1.2 2.6 2.6 2.6s2.6-1.2 2.6-2.6V12H11v7.4z" })
), ve = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(oe), we = ve, Ee = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      style: {
        fill: "none"
      },
      d: "M0 0h24v24H0z"
    }
  ),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M2 15h2v7H2zM20.7 16.5l-2.9 2.4c-.9.7-2.2 1.2-3.4 1.2H8v-3h7c.6 0 1-.4 1-1s-.4-1-1-1H6V22h8.4c1.8 0 3.5-.6 4.7-1.6L22 18l-1.3-1.5zM11.1 7.6V13h4.7v-1.8h-2.9V7.6c.4-.1.8-.4 1.1-.7.5-.5.8-1.3.8-2 0-.4-.1-.8-.2-1.1-.1-.4-.4-.7-.6-.9-.3-.3-.6-.5-.9-.6-.3-.1-.7-.2-1-.2H12c-.4 0-.7.1-1.1.2-.4.1-.7.4-.9.6-.3.2-.5.5-.7.9-.1.3-.2.7-.2 1.1 0 .8.3 1.5.8 2 .4.3.8.5 1.2.7zm-.2-3.2c.1-.1.1-.3.3-.4.1-.1.2-.2.4-.2.1-.1.3-.1.4-.1.1 0 .3 0 .4.1.1.1.3.1.4.2.1.1.2.2.2.4.1.1.1.3.1.5 0 .3-.1.6-.3.8-.2.2-.5.3-.8.4-.3 0-.6-.1-.8-.4-.2-.2-.3-.5-.3-.9-.1-.1 0-.3 0-.4z" })
), ge = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Ee), pe = ge, de = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12 1.7 2 10.6V22h2V11.4l8-7.1 8 7.1V22h2V10.6z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M13.1 16c0-.1-.1-.2-.1-.3-.2-.5-.4-1-.4-1.8 0-.7.2-1.3.5-1.9h-1.9c-.3.6-.5 1.2-.5 1.9 0 .9.2 1.3.4 1.8 0 .1.1.2.1.3.2.6.3 1.2.3 1.9 0 1-.2 1.6-.4 2.1H13c.2-.5.4-1.2.4-2.1 0-.7-.1-1.3-.3-1.9zM9.1 16c0-.1-.1-.2-.1-.3-.2-.5-.4-1-.4-1.8 0-.7.2-1.3.5-1.9h-2c-.3.6-.5 1.2-.5 1.9 0 .9.2 1.3.4 1.8 0 .1.1.2.1.3.2.6.3 1.2.3 1.9 0 1-.2 1.6-.4 2.1h2c.2-.5.4-1.2.4-2.1 0-.7-.1-1.3-.3-1.9zM17.1 16c0-.1-.1-.2-.1-.3-.2-.5-.4-1-.4-1.8 0-.7.2-1.3.5-1.9h-1.9c-.3.6-.5 1.2-.5 1.9 0 .9.2 1.3.4 1.8 0 .1.1.2.1.3.2.6.3 1.2.3 1.9 0 1-.2 1.6-.4 2.1H17c.2-.5.4-1.2.4-2.1 0-.7-.1-1.3-.3-1.9z" })
), Me = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(de), ie = Me, Se = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M9.5 2C5.3 2 2 5.3 2 9.5S5.3 17 9.5 17 17 13.7 17 9.5 13.7 2 9.5 2zm0 13C6.4 15 4 12.6 4 9.5S6.4 4 9.5 4c1.5 0 2.9.6 3.9 1.6S15 8 15 9.5c0 3.1-2.4 5.5-5.5 5.5zM15.78 17.215l1.415-1.414 4.738 4.737-1.415 1.415z" })
), ze = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Se), xe = ze, He = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M20 10v7c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3v-7H2v7c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5v-7h-2z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M11 5.6v9.8h2V5.6L15.3 8l1.4-1.3L12 2 7.3 6.7 8.7 8z" })
), Re = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(He), Ce = Re, Le = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M16.6 7v-.2c0-2.6-2.1-4.8-4.8-4.8C9.2 2.1 7 4.2 7 6.8V7H2v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7h-5.4zM9 6.8C9 5.2 10.2 4 11.8 4s2.9 1.3 2.9 2.9V7H9v-.2zM20 17c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V9h3v2h2V9h5.7v2h1.9V9H20v8z" })
), Oe = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Le), Ae = Oe, Be = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "m16.7 6-1.2-3h-7L7.3 6H2v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V6h-5.3zM20 16c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V8H8.7l.5-1.3.7-1.7h4.3l.7 1.7.4 1.3H20v8z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12 9c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 6.1c-1.2 0-2.1-.9-2.1-2.1s.9-2.1 2.1-2.1 2.1.9 2.1 2.1-.9 2.1-2.1 2.1z" })
), Te = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Be), Ve = Te, Fe = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M22 11.1h-4.4l2.8-2.9-1.3-1.3-4.2 4.2H13v-2l4.1-4.2-1.3-1.3L13 6.4V2h-2v4.4L8.2 3.6 6.9 4.9 11 9.1v2H9.1L4.9 6.9 3.6 8.2l2.8 2.9H2V13h4.4l-2.8 2.8 1.3 1.3L9.1 13H11v1.9l-4.1 4.2 1.3 1.3 2.8-2.8V22h2v-4.4l2.8 2.8 1.3-1.3-4.1-4.2V13h1.9l4.2 4.1 1.3-1.3-2.8-2.8H22z" })
), _e = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Fe), fe = _e, Ne = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M20.44 10.238a9.656 9.656 0 0 0-1.632-.178c-1.173 0-1.25.51-1.25 1.326v1.453h2.933l-.256 3.009h-2.677V25h-3.671v-9.152H12v-3.01h1.887v-1.86c0-2.55 1.198-3.978 4.207-3.978 1.045 0 1.81.153 2.804.357l-.458 2.881Z"
    }
  )
), $e = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Ne), ue = $e, ye = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M16.005 10.864a5.14 5.14 0 0 0-5.14 5.138 5.14 5.14 0 0 0 10.28 0 5.14 5.14 0 0 0-5.14-5.138Zm0 8.47a3.334 3.334 0 1 1 0-6.667 3.334 3.334 0 0 1 0 6.668Z"
    }
  ),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M21.348 11.86a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M16.006 6c-2.717 0-3.057.012-4.124.059-1.063.046-1.794.218-2.427.465-.66.257-1.22.597-1.774 1.156a4.9 4.9 0 0 0-1.157 1.77c-.246.637-.418 1.363-.465 2.426-.047 1.07-.059 1.41-.059 4.126 0 2.715.012 3.055.059 4.122.047 1.063.219 1.793.465 2.426.258.66.598 1.22 1.157 1.774a4.892 4.892 0 0 0 1.77 1.152c.637.247 1.364.419 2.427.465 1.067.047 1.408.059 4.124.059 2.716 0 3.056-.012 4.123-.059 1.064-.046 1.794-.218 2.428-.464a4.892 4.892 0 0 0 1.77-1.153 4.889 4.889 0 0 0 1.153-1.77c.247-.637.419-1.363.465-2.426.047-1.067.059-1.407.059-4.122 0-2.716-.012-3.055-.059-4.122-.046-1.063-.218-1.793-.465-2.426a4.685 4.685 0 0 0-1.145-1.778 4.892 4.892 0 0 0-1.77-1.153c-.638-.246-1.365-.418-2.428-.464-1.07-.051-1.41-.063-4.127-.063Zm0 1.801c2.673 0 2.99.012 4.041.059.977.043 1.505.207 1.857.344.465.18.801.398 1.149.746.352.351.567.684.746 1.149.137.351.302.882.344 1.855.047 1.055.06 1.372.06 4.04 0 2.672-.013 2.989-.06 4.04-.043.977-.207 1.504-.344 1.856-.18.465-.398.8-.746 1.148a3.078 3.078 0 0 1-1.15.747c-.35.137-.883.3-1.856.343-1.055.047-1.372.06-4.041.06-2.674 0-2.99-.013-4.042-.06-.977-.042-1.504-.206-1.856-.343a3.094 3.094 0 0 1-1.15-.747 3.076 3.076 0 0 1-.746-1.148c-.137-.352-.3-.883-.344-1.856-.047-1.055-.058-1.371-.058-4.04 0-2.672.011-2.989.058-4.04.043-.977.207-1.504.344-1.856.18-.464.399-.8.747-1.148a3.078 3.078 0 0 1 1.149-.746c.352-.137.883-.301 1.856-.344 1.052-.047 1.368-.059 4.042-.059Z"
    }
  )
), Ue = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(ye), Pe = Ue, Ze = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M24.5 6h-17C6.7 6 6 6.6 6 7.4v17.1c0 .9.7 1.5 1.5 1.5h17c.8 0 1.5-.6 1.5-1.4V7.4c0-.8-.7-1.4-1.5-1.4zM11.9 23H9v-9.5h3V23zm-1.5-10.8c-1 0-1.7-.8-1.7-1.7 0-.9.8-1.7 1.7-1.7.9 0 1.7.8 1.7 1.7.1.9-.7 1.7-1.7 1.7zM23 23h-3v-4.6c0-1.1 0-2.5-1.5-2.5s-1.8 1.2-1.8 2.5V23h-3v-9.5h2.8v1.3c.4-.8 1.4-1.5 2.8-1.5 3 0 3.6 2 3.6 4.5V23z" })
), De = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Ze), Ge = De, Ie = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M16 5.01c-6.2 0-11 4.53-11 10.66a10.46 10.46 0 0 0 3.45 7.9.88.88 0 0 1 .3.62l.06 2a.89.89 0 0 0 1.24.78l2.18-1a.85.85 0 0 1 .59-.05 11.8 11.8 0 0 0 3.18.42c6.2 0 11-4.54 11-10.67S22.2 5.01 16 5.01Zm6.6 8.22-3.22 5.12a1.66 1.66 0 0 1-2.39.44l-2.57-1.93a.66.66 0 0 0-.79 0l-3.48 2.63a.52.52 0 0 1-.75-.7l3.23-5.12a1.64 1.64 0 0 1 2.37-.44l2.57 1.93a.68.68 0 0 0 .8 0l3.47-2.63a.52.52 0 0 1 .76.69v.01Z" })
), ke = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Ie), be = ke, Ye = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M20.558 19.35c-1.178.748-2.796 1.046-3.867 1.153l.9.885 3.275 3.276c1.198 1.227-.753 3.149-1.965 1.965-.822-.83-2.024-2.033-3.276-3.29l-3.276 3.286c-1.212 1.183-3.163-.758-1.95-1.966.83-.831 2.024-2.034 3.275-3.276l.885-.884c-1.056-.113-2.704-.392-3.892-1.154-1.398-.905-2.014-1.433-1.471-2.533.318-.626 1.188-1.154 2.347-.244 0 0 1.56 1.241 4.077 1.241 2.518 0 4.078-1.241 4.078-1.241 1.153-.905 2.024-.382 2.346.244.528 1.1-.088 1.628-1.486 2.538Zm-10.516-8.776A5.577 5.577 0 0 1 15.615 5a5.577 5.577 0 0 1 5.574 5.574c0 3.065-2.503 5.559-5.574 5.559-3.07 0-5.573-2.494-5.573-5.56Zm2.835 0a2.743 2.743 0 0 0 2.738 2.738 2.74 2.74 0 0 0 2.738-2.738 2.742 2.742 0 0 0-2.738-2.748 2.742 2.742 0 0 0-2.738 2.748Z" })
), Ke = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Ye), je = Ke, qe = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M16 5C9.924 5 5 9.924 5 16c0 4.662 2.9 8.641 6.991 10.244-.095-.872-.185-2.204.039-3.154l1.289-5.466s-.331-.657-.331-1.633c0-1.53.885-2.672 1.99-2.672.936 0 1.391.704 1.391 1.55 0 .946-.601 2.356-.91 3.662-.258 1.096.55 1.99 1.628 1.99 1.955 0 3.46-2.063 3.46-5.037 0-2.634-1.892-4.477-4.594-4.477-3.128 0-4.967 2.346-4.967 4.774 0 .945.365 1.96.82 2.51.09.107.103.206.078.313-.082.348-.271 1.096-.306 1.246-.047.202-.159.245-.369.146-1.375-.64-2.234-2.647-2.234-4.262 0-3.472 2.522-6.656 7.266-6.656 3.815 0 6.78 2.72 6.78 6.355 0 3.79-2.389 6.84-5.706 6.84-1.113 0-2.162-.58-2.522-1.263l-.684 2.617c-.249.954-.92 2.153-1.366 2.883 1.031.318 2.123.49 3.257.49 6.076 0 11-4.924 11-11S22.076 5 16 5Z" })
), Je = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(qe), Qe = Je, Xe = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M11.921 24.876c8.3 0 12.84-6.878 12.84-12.841 0-.194-.003-.391-.012-.585A9.168 9.168 0 0 0 27 9.114a8.9 8.9 0 0 1-2.59.709 4.538 4.538 0 0 0 1.984-2.496 9.072 9.072 0 0 1-2.865 1.095 4.52 4.52 0 0 0-7.694 4.116 12.819 12.819 0 0 1-9.301-4.713 4.519 4.519 0 0 0 1.396 6.023 4.52 4.52 0 0 1-2.045-.563v.056a4.512 4.512 0 0 0 3.622 4.426 4.488 4.488 0 0 1-2.037.077 4.523 4.523 0 0 0 4.215 3.137A9.052 9.052 0 0 1 5 22.848a12.805 12.805 0 0 0 6.921 2.028Z" })
), We = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Xe), e0 = We, t0 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M8.134 10H5.8c-.667 0-.8.314-.8.66 0 .618.79 3.685 3.684 7.739 1.928 2.77 4.646 4.27 7.118 4.27 1.484 0 1.667-.333 1.667-.906V19.67c0-.667.141-.8.61-.8.347 0 .94.172 2.325 1.507 1.583 1.583 1.843 2.293 2.733 2.293h2.334c.667 0 1.001-.334.808-.992-.21-.655-.966-1.607-1.968-2.735-.545-.642-1.36-1.335-1.607-1.681-.347-.445-.248-.643 0-1.039 0 0 2.843-4.005 3.14-5.365.15-.494 0-.858-.707-.858h-2.333c-.593 0-.867.314-1.016.66 0 0-1.186 2.893-2.868 4.772-.544.544-.791.718-1.088.718-.148 0-.363-.174-.363-.668v-4.624c0-.593-.172-.858-.667-.858h-3.668c-.37 0-.593.275-.593.537 0 .562.84.692.927 2.274v3.437c0 .754-.135.89-.433.89-.79 0-2.715-2.906-3.857-6.23C8.954 10.261 8.73 10 8.134 10Z"
    }
  )
), c0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(t0), r0 = c0, l0 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M21.306 12.166a6.636 6.636 0 0 0-.366-.008c-4.377 0-7.928 2.974-7.928 6.645 0 .601.098 1.183.276 1.737a10.28 10.28 0 0 1-3.339-.353l-.148-.043-3.146 1.602.841-2.634-.08-.05C5.34 17.732 4 15.636 4 13.279 4 9.259 7.896 6 12.703 6c4.354 0 7.962 2.673 8.603 6.166Zm-11.631-.21c-.675 0-1.222-.531-1.222-1.184 0-.654.547-1.183 1.222-1.183.675 0 1.223.53 1.223 1.183s-.548 1.184-1.223 1.184Zm6.057-2.367c.675 0 1.222.53 1.222 1.183s-.547 1.184-1.222 1.184c-.676 0-1.221-.531-1.221-1.184 0-.654.545-1.183 1.221-1.183Z"
    }
  ),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M21.006 24.996c-4.061 0-7.354-2.753-7.354-6.15 0-3.396 3.293-6.149 7.354-6.149 4.06 0 7.352 2.754 7.352 6.149 0 1.992-1.133 3.762-2.887 4.886l-.067.042.71 2.226-2.657-1.355s-.083.025-.125.036a8.644 8.644 0 0 1-2.326.315Zm-3.592-8.268c0-.551.463-1 1.032-1 .571 0 1.034.449 1.034 1 0 .553-.463 1.001-1.034 1.001-.57 0-1.032-.448-1.032-1.002Zm5.117 0c0-.551.462-1 1.032-1 .571 0 1.033.449 1.033 1 0 .553-.462 1.001-1.033 1.001-.57 0-1.032-.448-1.032-1.002Z"
    }
  )
), n0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(l0), h0 = n0, a0 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M26.361 14.851c.834-.073 1.048-1.565.95-2.812-.258-3.299-3.036-5.796-6.716-5.312l-.151.018c-.435.05-.836.097-.926.607-.182 1.06.756.97 1.441.903.15-.015.286-.028.397-.028 2.188 0 4.422 1.793 4.372 4.374-.004.22-.051.476-.099.735-.144.79-.293 1.605.732 1.515Z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M9.825 20.724c1.286 3.46 8.32 1.589 6.97-2.436-.405-1.202-1.775-2.126-3.612-1.94-2.154.224-4.22 2.063-3.358 4.376Z"
    }
  ),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M22.04 15.414c-.25-.12-.503-.243-.748-.375.347-.89.562-2.042.003-2.688-.914-1.048-2.655-.574-4.068-.189-.555.151-1.06.289-1.444.314.631-1.902-.06-3.831-2.408-3.25-2.163.537-3.754 1.7-5.259 3.188-1.58 1.558-3.19 3.387-3.422 5.75-.27 2.743 1.479 4.12 3.168 5.062 5.035 2.807 13.101 1.255 15.775-2.438.376-.518.748-1.329.824-1.936.265-2.142-1.051-2.777-2.42-3.438Zm-1.445 3.189c.003 1.004-.506 1.867-1.013 2.435-1.386 1.552-4.306 2.568-7.224 2.378-2.525-.168-5.963-1.634-5.322-4.752.285-1.386 1.43-2.308 2.408-2.874 1.2-.694 2.348-1.049 4.055-1.187 3.122-.253 7.09.893 7.096 4Z"
    }
  ),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M24.21 12.039c.133.95-.144 1.776-.697 1.812-.692.045-.671-.328-.641-.861.01-.177.02-.373.007-.576-.035-.501-.456-1.08-.824-1.25-.265-.122-.583-.122-.879-.122-.511 0-.958 0-.958-.628 0-.648.502-.667.872-.68l.142-.007c1.602-.12 2.787.97 2.978 2.312Z" })
), s0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(a0), m0 = s0, o0 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M23.802 8.21A10.957 10.957 0 0 0 6.558 21.427L5 27.102l5.809-1.523a10.95 10.95 0 0 0 11.32-.513A10.956 10.956 0 0 0 23.794 8.21h.01Zm-7.75 16.852c-1.63 0-3.23-.438-4.633-1.27l-.332-.197-3.457.904.92-3.359-.217-.344a9.107 9.107 0 1 1 7.714 4.266h.005Zm4.996-6.818c-.274-.137-1.62-.8-1.871-.89-.25-.092-.433-.137-.616.136s-.708.89-.867 1.073c-.159.183-.32.205-.593.069a7.464 7.464 0 0 1-2.207-1.359 8.302 8.302 0 0 1-1.523-1.895c-.16-.274-.016-.422.125-.558.142-.137.274-.321.411-.48.113-.139.205-.293.274-.457a.501.501 0 0 0-.024-.48c-.067-.136-.614-1.484-.842-2.031-.228-.547-.449-.462-.617-.47-.167-.007-.343-.01-.524-.01a1 1 0 0 0-.73.342c-.25.274-.959.937-.959 2.283 0 1.346.981 2.649 1.118 2.832.136.183 1.93 2.947 4.677 4.133.51.219 1.03.411 1.56.576.559.17 1.149.207 1.724.109.527-.08 1.62-.663 1.849-1.303.227-.64.227-1.187.16-1.301-.068-.114-.252-.182-.525-.32Z" })
), v0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(o0), w0 = v0, E0 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M27.76 10.976s-.233-1.655-.955-2.382c-.914-.956-1.936-.96-2.405-1.017-3.356-.244-8.395-.244-8.395-.244h-.01s-5.039 0-8.395.244c-.469.056-1.49.061-2.405 1.017-.722.727-.951 2.382-.951 2.382S4 12.92 4 14.86v1.82c0 1.94.24 3.885.24 3.885s.233 1.655.95 2.381c.915.957 2.115.924 2.65 1.027 1.92.183 8.16.24 8.16.24s5.044-.01 8.4-.25c.469-.056 1.49-.06 2.405-1.017.722-.726.956-2.38.956-2.38S28 18.625 28 16.68v-1.819c0-1.94-.24-3.885-.24-3.885Zm-14.24 7.912v-6.745l6.483 3.384-6.483 3.361Z" })
), g0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(E0), p0 = g0, d0 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "m12 5.5 1.7 3.6.4.9 1 .1 3.7.5-2.7 2.5-.7.7.2 1 .6 3.6-3.4-1.7-.8-.3-.9.4-3.4 1.7.6-3.6.2-1-.7-.7-2.7-2.5 3.7-.5 1-.1.4-.9L12 5.5M12 1 8.6 8.2 1 9.4l5.5 5.2L5.2 22l6.8-3.4 6.8 3.4-1.3-7.4L23 9.4l-7.6-1.1L12 1z" })
), M0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(d0), i0 = M0, S0 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12 7.5c-2.5 0-4.5 2-4.5 4.5s2 4.5 4.5 4.5 4.5-2 4.5-4.5-2-4.5-4.5-4.5zm0 7c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5zM11 2h2v4h-2zM4.16 5.636 5.576 4.22 8.403 7.05 6.99 8.464zM2 11h4v2H2zM4.222 18.425l2.828-2.829 1.414 1.415-2.828 2.828zM11 18h2v4h-2zM15.596 16.949l1.414-1.415 2.83 2.828-1.415 1.415zM18 11h4v2h-4zM15.535 6.99l2.829-2.829 1.414 1.414-2.828 2.829z" })
), z0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(S0), x0 = z0, H0 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 3.2, cy: 20.8, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 6.4, cy: 20.8, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 9.5, cy: 20.8, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 14.5, cy: 20.8, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 17.6, cy: 20.8, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 20.8, cy: 20.8, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 3.2, cy: 16.4, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 6.4, cy: 16.4, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 9.5, cy: 16.4, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 14.5, cy: 16.4, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 17.6, cy: 16.4, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 20.8, cy: 16.4, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 3.2, cy: 12, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 6.4, cy: 12, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 9.5, cy: 12, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 14.5, cy: 12, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 17.6, cy: 12, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 20.8, cy: 12, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 3.2, cy: 7.7, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 6.4, cy: 7.7, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 9.5, cy: 7.7, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 14.5, cy: 7.7, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 17.6, cy: 7.7, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 20.8, cy: 7.7, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 3.2, cy: 3.3, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 6.4, cy: 3.3, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 9.5, cy: 3.3, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 14.5, cy: 3.3, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 17.6, cy: 3.3, r: 1.2 }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 20.8, cy: 3.3, r: 1.2 })
), R0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(H0), C0 = R0, L0 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "116",
    height: "134",
    viewBox: "0 0 116 134",
    fill: "none",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      d: "M47.4704 134H63.1795V122.833H47.4704C25.2247 122.833 10.5699 110.103 10.5699 88.2167C10.5699 71.4667 19.2152 66.33 30.0745 58.8483C39.6686 52.26 50.0007 44.555 54.6397 25.125L57.2754 14.07C57.6971 12.1717 59.2786 11.1667 60.5438 11.1667C61.9143 11.1667 63.1795 12.1717 63.1795 14.2933V44.6667H73.7225V14.2933C73.7225 4.91333 67.2913 0 60.6492 0C55.694 0 49.6845 2.79166 47.6813 10.05L43.8858 24.0083C40.0903 38.19 32.0776 44.3317 23.0106 50.6967C10.4644 59.5183 0.65945 65.4367 0.0268696 87.1C-0.816571 117.808 18.2663 134 47.4704 134ZM73.8279 134H94.914V122.833H73.8279V134ZM73.8279 111.667H110.728V100.5H73.8279V111.667ZM73.8279 89.3333H116V78.1667H73.8279V89.3333ZM73.8279 67H105.457V55.8333H73.8279V67Z",
      fill: "#F8FCFF"
    }
  )
), O0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(L0), A0 = O0, B0 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M19 15V6c0-2.2-1.8-4-4-4H9C6.8 2 5 3.8 5 6v9c0 1.9 1.3 3.5 3.1 3.9L5.9 22h2.5l2.1-3h2.9l2.1 3H18l-2.2-3.1c1.8-.4 3.2-2 3.2-3.9zm-2-9v3h-4.1V4H15c1.1 0 2 .9 2 2zM9 4h2.1v5H7V6c0-1.1.9-2 2-2zm6 13H9c-1.1 0-2-.9-2-2v-4.2h10V15c0 1.1-.9 2-2 2z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: 12, cy: 13.9, r: 1.5 })
), T0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(B0), V0 = T0, F0 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M21 13.1h-4.4L15 10l-2 4-3-6-2.6 5.1h-.5c-1 0-2-.6-2.4-1.6C4.2 10.7 4 9.9 4 9c0-2.4 1.5-4 3.8-4 .9 0 1.7.3 2.4 1 .7.6 1.3.7 1.8.7s1.1-.1 1.8-.7 1.5-1 2.4-1C18.5 5 20 6.6 20 9c0 .8-.2 1.5-.4 2.3h2.1c.2-.8.3-1.5.3-2.3 0-3.5-2.4-6-5.8-6-1.4 0-2.7.5-3.8 1.5-.2.2-.2.2-.4.2s-.2 0-.4-.2C10.5 3.5 9.2 3 7.8 3 4.4 3 2 5.5 2 9c0 1.1.2 2.2.7 3.2.7 1.6 2.3 2.7 4 2.7h1.9L10 12l3 6 2-4 .4.9h1.9c-1.3 1.5-2.9 3.1-4.9 4.9l-.4.4-.5-.5c-1.2-1.1-2.2-2.1-3.2-3.1H5.6c1.3 1.5 2.9 3 4.6 4.5L12 23l1.8-1.8c2.4-2.2 4.5-4.2 6-6.3H22v-1.8h-1z" })
), _0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(F0), f0 = _0, N0 = (t, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M18.5 6C16.6 6 15 7.6 15 9.5h2c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5-.7 1.5-1.5 1.5H2v2h16.7c1.9-.1 3.4-1.6 3.4-3.5C22 7.6 20.4 6 18.5 6z" }),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M14 5.5C14 3.6 12.4 2 10.5 2S7 3.6 7 5.5h2c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5S11.3 7 10.5 7H2v2h8.5C12.4 9 14 7.4 14 5.5zM15.5 15H2v2h13.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5c-.5 0-.9-.2-1.2-.6-.2-.3-.3-.6-.3-.9h-2c0 .8.2 1.5.7 2.1.7.9 1.7 1.4 2.8 1.4 1.9 0 3.5-1.6 3.5-3.5S17.4 15 15.5 15z" })
), $0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(N0), u0 = $0;
var y0 = /* @__PURE__ */ ((t) => (t.ACCOMMODATION = "ACCOMMODATION", t.ACTIVITY = "ACTIVITY", t.ARROW_DOWN = "ARROW_DOWN", t.ARROW_LEFT = "ARROW_LEFT", t.ARROW_RIGHT = "ARROW_RIGHT", t.ARROW_UP = "ARROW_UP", t.ARROW_UP_RIGHT = "ARROW_UP_RIGHT", t.ART_CULTURE = "ART_CULTURE", t.ATTRACTION = "ATTRACTION", t.BAR = "BAR", t.BICYCLE = "BICYCLE", t.BOARDROOM = "BOARDROOM", t.BUBBLES = "BUBBLES", t.BUS = "BUS", t.CAR = "CAR", t.CHECK = "CHECK", t.CHEVRON_DOWN = "CHEVRON_DOWN", t.CHEVRON_LEFT = "CHEVRON_LEFT", t.CHEVRON_RIGHT = "CHEVRON_RIGHT", t.CHEVRON_UP = "CHEVRON_UP", t.CLASSROOM = "CLASSROOM", t.CLOCK = "CLOCK", t.CLOSE = "CLOSE", t.CLOUD = "CLOUD", t.CONTACT = "CONTACT", t.COPY = "COPY", t.DOWNLOAD = "DOWNLOAD", t.EMPLOYER = "EMPLOYER", t.EMPLOYEE = "EMPLOYEE", t.EURO = "EURO", t.EVENT = "EVENT", t.EYE = "EYE", t.FAMILY = "FAMILY", t.FERRY = "FERRY", t.FILTER = "FILTER", t.FOOD = "FOOD", t.GLOBE = "GLOBE", t.GROUP = "GROUP", t.HAMBURGER = "HAMBURGER", t.HEART = "HEART", t.HEART_FILLED = "HEART_FILLED", t.INDIVIDUAL = "INDIVIDUAL", t.INFO = "INFO", t.LGBT = "LGBT", t.LIST = "LIST", t.LOCATION = "LOCATION", t.MAP = "MAP", t.MENU = "MENU", t.MINUS = "MINUS", t.MIST = "MIST", t.NIGHT = "NIGHT", t.PLANE = "PLANE", t.PLUS = "PLUS", t.RAIN = "RAIN", t.RENTAL = "RENTAL", t.SAUNA = "SAUNA", t.SEARCH = "SEARCH", t.SHARE = "SHARE", t.SHOPPING = "SHOPPING", t.SIGHTSEEING = "SIGHTSEEING", t.SNOW = "SNOW", t.SO_ME_FACEBOOK = "SO_ME_FACEBOOK", t.SO_ME_INSTAGRAM = "SO_ME_INSTAGRAM", t.SO_ME_LINKEDIN = "SO_ME_LINKEDIN", t.SO_ME_MESSENGER = "SO_ME_MESSENGER", t.SO_ME_ODNOKLASSISKI = "SO_ME_ODNOKLASSISKI", t.SO_ME_PINTEREST = "SO_ME_PINTEREST", t.SO_ME_TWITTER = "SO_ME_TWITTER", t.SO_ME_V_KONTAKTE = "SO_ME_V_KONTAKTE", t.SO_ME_WECHAT = "SO_ME_WECHAT", t.SO_ME_WEIBO = "SO_ME_WEIBO", t.SO_ME_WHATSAPP = "SO_ME_WHATSAPP", t.SO_ME_YOUTUBE = "SO_ME_YOUTUBE", t.STAR = "STAR", t.SUN = "SUN", t.THEATER = "THEATER", t.THUMBSUP = "THUMBSUP", t.TRAIN = "TRAIN", t.WELLBEING = "WELLBEING", t.WIND = "WIND", t))(y0 || {});
const U0 = {
  ACCOMMODATION: p,
  ACTIVITY: i,
  ARROW_DOWN: x,
  ARROW_LEFT: C,
  ARROW_RIGHT: A,
  ARROW_UP: V,
  ARROW_UP_RIGHT: f,
  ART_CULTURE: u,
  ATTRACTION: P,
  BAR: G,
  BICYCLE: b,
  BOARDROOM: j,
  BUBBLES: Q,
  BUS: e1,
  CAR: r1,
  CHECK: h1,
  CHEVRON_DOWN: m1,
  CHEVRON_LEFT: w1,
  CHEVRON_RIGHT: p1,
  CHEVRON_UP: i1,
  CLASSROOM: x1,
  CLOCK: C1,
  CLOSE: A1,
  CLOUD: V1,
  CONTACT: f1,
  COPY: u1,
  DOWNLOAD: P1,
  EMPLOYER: G1,
  EMPLOYEE: b1,
  EURO: j1,
  EVENT: Q1,
  EYE: e2,
  FAMILY: r2,
  FERRY: h2,
  FILTER: m2,
  FOOD: w2,
  GLOBE: p2,
  GROUP: i2,
  HAMBURGER: x2,
  HEART: C2,
  HEART_FILLED: A2,
  INDIVIDUAL: V2,
  INFO: f2,
  LGBT: u2,
  LIST: P2,
  LOCATION: G2,
  MAP: b2,
  MENU: j2,
  MINUS: Q2,
  MIST: ee,
  NIGHT: re,
  PLANE: he,
  PLUS: me,
  RAIN: we,
  RENTAL: pe,
  SAUNA: ie,
  SEARCH: xe,
  SHARE: Ce,
  SHOPPING: Ae,
  SIGHTSEEING: Ve,
  SNOW: fe,
  SO_ME_FACEBOOK: ue,
  SO_ME_INSTAGRAM: Pe,
  SO_ME_LINKEDIN: Ge,
  SO_ME_MESSENGER: be,
  SO_ME_ODNOKLASSISKI: je,
  SO_ME_PINTEREST: Qe,
  SO_ME_TWITTER: e0,
  SO_ME_V_KONTAKTE: r0,
  SO_ME_WECHAT: h0,
  SO_ME_WEIBO: m0,
  SO_ME_WHATSAPP: w0,
  SO_ME_YOUTUBE: p0,
  STAR: i0,
  SUN: x0,
  THEATER: C0,
  THUMBSUP: A0,
  TRAIN: V0,
  WELLBEING: f0,
  WIND: u0
}, D0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function({ icon: c, size: l, width: s, height: m, color: o, className: v, viewBox: n }, w) {
  const h = {
    height: m || l || 30,
    width: s || l || 30,
    fill: o,
    className: v
  };
  n && (h.viewBox = n);
  const a = U0[c];
  return a ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(a, { ...h, ref: w }) : null;
});

//# sourceMappingURL=Icon-e01b6482.mjs.map


/***/ }),

/***/ 567:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ w; },
/* harmony export */   "a": function() { return /* binding */ k; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(403);
/* harmony import */ var _ImageContext_57256dc1_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2355);



const d = "picture", A = "picture--fall-back", C = "picture--animation", P = "skeleton-loading", E = "image__hero", R = "image__article-quote", M = "image__promotion", O = "image__card", x = "image__masonry-card", H = "image__article-page-hero", f = "image__preview_card", B = "image__map-box", b = "mobile", t = {
  picture: d,
  pictureFallBack: A,
  pictureAnimation: C,
  skeletonLoading: P,
  imageHero: E,
  imageArticleQuote: R,
  imagePromotion: M,
  imageCard: O,
  imageMasonryCard: x,
  imageArticlePageHero: H,
  imagePreviewCard: f,
  imageMapBox: B,
  mobile: b
};
var k = /* @__PURE__ */ ((e) => (e.ARTICLE_QUOTE = "imageArticleQuote", e.HERO = "imageHero", e.CARD = "imageCard", e.PROMOTION = "imagePromotion", e.MASONRY_CARD = "imageMasonryCard", e.ARTICLE_PAGE_HERO = "imageArticlePageHero", e.PREVIEW_CARD = "imagePreviewCard", e.MAPBOX = "imageMapBox", e))(k || {});
function w({
  src: e,
  width: m,
  height: c,
  altText: n,
  imageLoader: g,
  styling: a,
  className: l,
  errorHandler: s,
  credits: p
}) {
  const _ = (0,_ImageContext_57256dc1_mjs__WEBPACK_IMPORTED_MODULE_1__.u)(), i = [n, p].filter(Boolean).join(" - ").trim();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "picture",
    {
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(t.picture),
      itemProp: "image",
      itemScope: !0,
      itemType: "https://schema.org/ImageObject"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _,
      {
        src: e,
        title: i,
        width: m,
        height: c,
        alt: i,
        loading: "lazy",
        loader: g,
        className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(l, a ? t[a] : void 0),
        onError: s,
        itemProp: "contentUrl",
        quality: 100
      }
    )
  );
}

//# sourceMappingURL=Image-be3826ec.mjs.map


/***/ }),

/***/ 2355:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ a; },
/* harmony export */   "u": function() { return /* binding */ s; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);

const a = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(
  void 0
);
function s() {
  const t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(a);
  return t || c;
}
function c(t) {
  const e = { ...t };
  return delete e.loader, delete e.blurDataURL, delete e.onLoadingComplete, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", { ...e, src: e.src.toString() });
}

//# sourceMappingURL=ImageContext-57256dc1.mjs.map


/***/ }),

/***/ 1607:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ N; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(403);
/* harmony import */ var _LinkContext_0c83848a_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2659);



const L = "link", x = "error", g = "no-href", a = {
  link: L,
  error: x,
  noHref: g
}, N = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function({
  className: l,
  children: n,
  href: t,
  disabled: i,
  disableLinkTextStyle: c,
  ...r
}, f) {
  const m = (0,_LinkContext_0c83848a_mjs__WEBPACK_IMPORTED_MODULE_1__.u)();
  if (!t)
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, n);
  const o = (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
    !c && [a.link, _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsLink],
    l
  );
  return i ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(a.noHref, o) }, n) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    m,
    {
      href: t,
      prefetch: !1,
      className: o,
      ...r,
      ref: f,
      rel: r.target === "_blank" ? "noopener" : void 0
    },
    n
  );
});

//# sourceMappingURL=Link-460da2fc.mjs.map


/***/ }),

/***/ 2659:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ a; },
/* harmony export */   "u": function() { return /* binding */ s; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);

const a = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(
  void 0
);
function s() {
  const t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(a);
  return t || l;
}
const l = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(e, o) {
  const r = typeof e.href == "string" ? e.href : e.href.href ?? "";
  if (!r)
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, e.children);
  const f = { ...e };
  return delete f.prefetch, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", { ...f, href: r, ref: o });
});

//# sourceMappingURL=LinkContext-0c83848a.mjs.map


/***/ }),

/***/ 1658:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ b; },
/* harmony export */   "a": function() { return /* binding */ M; },
/* harmony export */   "b": function() { return /* binding */ Z; },
/* harmony export */   "u": function() { return /* binding */ g; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(403);


function g(s = {}) {
  const { disableFocusEvent: n = !1, disableHoverEvent: r = !1 } = s, e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), [t, C] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const o = e.current;
    if (!o)
      return;
    const H = () => C(!0), a = () => C(!1);
    return r || (o.addEventListener("mouseenter", H), o.addEventListener("mouseleave", a)), n || (o.addEventListener("focus", H), o.addEventListener("blur", a)), () => {
      a(), r || (o.removeEventListener("mouseenter", H), o.removeEventListener("mouseleave", a)), n || (o.removeEventListener("focus", H), o.removeEventListener("blur", a));
    };
  }, [n, r]), { ref: e, isHovering: t, setIsHovering: C };
}
const m = [
  "a[href]",
  "button",
  "textarea",
  'input[type="text"]',
  'input[type="radio"]',
  'input[type="checkbox"]',
  'input[type="file"]',
  'input[type="search"]',
  "select"
];
function M(s) {
  const n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  function r(e) {
    const t = n.current;
    if (!t)
      return;
    const C = t.querySelectorAll(
      m.join(", ")
    ), o = C[0], H = C[C.length - 1];
    if (e.key === "Tab") {
      if (e.shiftKey)
        return document.activeElement === o ? (e.preventDefault(), e.stopPropagation(), H.focus()) : void 0;
      if (document.activeElement === H)
        return e.preventDefault(), o.focus();
    }
  }
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const e = n.current;
    if (!(!e || s))
      return e?.addEventListener("keydown", r), () => e?.removeEventListener("keydown", r);
  }, [s]), n;
}
function Z(s, n, r = "Component") {
  const e = (t) => {
    throw new Error(
      `${r} can only have ${n} as children. ${t ? `Found '${t}'.` : ""}`
    );
  };
  react__WEBPACK_IMPORTED_MODULE_0__.Children.forEach(s, (t) => {
    t && typeof t == "object" ? "type" in t && t.type !== n && e(t.type) : e();
  });
}
const v = "logo", E = "logo--primary", p = "logo--secondary", l = {
  logo: v,
  logoPrimary: E,
  logoSecondary: p
};
function b({
  color: s = "primary",
  style: n
}) {
  const r = s === "primary" ? l.logoPrimary : l.logoSecondary;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(l.logo, r), style: n }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { viewBox: "0 0 83 38" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M0.979858 22.2666H10.3483V25.3168H4.46579V28.367H9.97791V31.4171H4.46579V37.5175H0.979858V22.2666ZM11.9883 34.6852H13.9927V25.0989H11.9883V22.2666H19.4612V25.0989H17.4568V34.6852H19.4612V37.5175H11.9883V34.6852ZM21.9745 22.2666H24.8068L29.5782 30.6328C29.6218 30.7054 29.6799 30.7417 29.7525 30.7417C29.8107 30.7417 29.8542 30.72 29.8832 30.6764C29.9268 30.6182 29.9414 30.5603 29.9268 30.5021L29.6 28.5848V22.2666H32.868V37.5175H30.0357L25.2862 29.1513C25.2572 29.0787 25.199 29.0424 25.1119 29.0424C25.0539 29.0424 25.0029 29.0713 24.9593 29.1295C24.9304 29.1731 24.9232 29.2238 24.9376 29.282L25.2426 31.1993V37.5175H21.9745V22.2666ZM35.8017 22.2666H39.2876V34.4673H43.5143V37.5175H35.8017V22.2666ZM52.498 33.988H48.707L47.9663 37.5175H44.5021L47.5087 25.0989H45.9183V22.2666H52.9991L56.7029 37.5175H53.2387L52.498 33.988ZM51.8879 31.1557L50.9511 26.6894L50.7986 25.3168C50.7986 25.2586 50.7768 25.215 50.7332 25.186C50.6896 25.1425 50.6461 25.1207 50.6025 25.1207C50.5007 25.1207 50.4354 25.186 50.4064 25.3168L50.2539 26.6894L49.3171 31.1557H51.8879ZM58.5624 22.2666H61.3947L66.1661 30.6328C66.2096 30.7054 66.2678 30.7417 66.3404 30.7417C66.3986 30.7417 66.4421 30.72 66.4711 30.6764C66.5147 30.6182 66.5293 30.5603 66.5147 30.5021L66.1879 28.5848V22.2666H69.4559V37.5175H66.6236L61.874 29.1513C61.8451 29.0787 61.7869 29.0424 61.6997 29.0424C61.6416 29.0424 61.5908 29.0713 61.5472 29.1295C61.5182 29.1731 61.5108 29.2238 61.5254 29.282L61.8305 31.1993V37.5175H58.5624V22.2666ZM72.3895 22.2666H76.8341C78.6932 22.2666 80.1311 22.7095 81.1479 23.5956C82.1791 24.4817 82.7602 25.7089 82.8909 27.2776C82.9635 28.1491 82.9998 29.0206 82.9998 29.8921C82.9998 30.7635 82.9635 31.635 82.8909 32.5065C82.7746 34.0752 82.2009 35.3024 81.1697 36.1885C80.1383 37.0746 78.6932 37.5175 76.8341 37.5175H72.3895V22.2666ZM76.8341 34.6852C77.72 34.6852 78.3954 34.4455 78.8603 33.9662C79.325 33.4869 79.6011 32.8479 79.6882 32.049C79.7462 31.4679 79.7754 30.7489 79.7754 29.8921C79.7754 29.0495 79.7462 28.3306 79.6882 27.7351C79.6154 26.9362 79.3396 26.2972 78.8603 25.8179C78.3954 25.3386 77.72 25.0989 76.8341 25.0989H75.8755V34.6852H76.8341Z" }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M0 0.261445H1.59045L3.35521 11.1768L3.39878 12.2879C3.39878 12.4332 3.44961 12.5058 3.55129 12.5058C3.63844 12.5058 3.68927 12.4477 3.7038 12.3315L5.53391 4.61886H6.77577L8.60589 12.3315C8.62042 12.4477 8.67125 12.5058 8.7584 12.5058C8.86007 12.5058 8.9109 12.4332 8.9109 12.2879L8.95448 11.1768L10.741 0.261445H12.3097L9.91311 15.5124H8.10478L6.38361 8.78018C6.34003 8.60589 6.26742 8.51874 6.16574 8.51874C6.06406 8.51874 5.99144 8.60589 5.94787 8.78018L4.2049 15.5124H2.39658L0 0.261445ZM19.352 15.7738C17.7833 15.7738 16.556 15.3163 15.67 14.4012C15.1471 13.8784 14.7477 13.1376 14.4717 12.179C14.1957 11.2203 14.0577 9.78964 14.0577 7.88691C14.0577 5.98419 14.1957 4.55349 14.4717 3.59486C14.7477 2.63623 15.1471 1.89547 15.67 1.37258C16.556 0.457528 17.7833 0 19.352 0C20.9207 0 22.1481 0.457528 23.0339 1.37258C23.5568 1.89547 23.9564 2.63623 24.2322 3.59486C24.5083 4.55349 24.6462 5.98419 24.6462 7.88691C24.6462 9.78964 24.5083 11.2203 24.2322 12.179C23.9564 13.1376 23.5568 13.8784 23.0339 14.4012C22.1481 15.3163 20.9207 15.7738 19.352 15.7738ZM19.352 14.0744C20.4123 14.0744 21.2257 13.7912 21.7921 13.2247C22.3585 12.6583 22.671 11.8667 22.7289 10.85C22.8161 9.5863 22.8596 8.59863 22.8596 7.88691C22.8596 7.1752 22.8161 6.18752 22.7289 4.92387C22.671 3.90714 22.3585 3.11555 21.7921 2.54909C21.2257 1.98262 20.4123 1.69939 19.352 1.69939C18.2917 1.69939 17.4783 1.98262 16.9118 2.54909C16.3454 3.11555 16.0331 3.90714 15.975 4.92387C15.8879 6.18752 15.8443 7.1752 15.8443 7.88691C15.8443 8.59863 15.8879 9.5863 15.975 10.85C16.0331 11.8667 16.3454 12.6583 16.9118 13.2247C17.4783 13.7912 18.2917 14.0744 19.352 14.0744ZM27.8151 0.261445H32.7825C34.1915 0.261445 35.2881 0.63908 36.0724 1.39437C36.8567 2.14966 37.2489 3.21723 37.2489 4.59707C37.2489 5.59927 36.9946 6.44897 36.4863 7.14615C35.978 7.82881 35.2809 8.29361 34.3948 8.54053C34.2787 8.56957 34.2205 8.62767 34.2205 8.71482C34.2205 8.7584 34.2495 8.83829 34.3076 8.95448L34.9395 10.0003L36.9439 15.5124H35.0048L32.5429 8.73661H29.5581V15.5124H27.8151V0.261445ZM32.7825 7.14615C33.625 7.14615 34.2787 6.92828 34.7434 6.49254C35.2227 6.04227 35.4623 5.41045 35.4623 4.59707C35.4623 3.69654 35.2227 3.00661 34.7434 2.5273C34.2787 2.03345 33.625 1.78654 32.7825 1.78654H29.5581V7.14615H32.7825ZM39.9827 0.261445H41.7693V7.05901H43.4033L47.0853 0.261445H49.0461L44.8848 7.75619L49.0897 15.5124H47.1289L43.4033 8.69304H41.7693V15.5124H39.9827V0.261445ZM56.2762 13.8566H58.8906V1.91726H56.2762V0.261445H63.3134V1.91726H60.6989V13.8566H63.3134V15.5124H56.2762V13.8566ZM66.2514 0.261445H67.7329L74.1165 12.179C74.1601 12.2516 74.2037 12.2879 74.2472 12.2879C74.2908 12.2879 74.3272 12.2661 74.3562 12.2225C74.3997 12.179 74.4143 12.1281 74.3997 12.07L74.1601 10.6103V0.261445H75.903V15.5124H74.1601L68.0815 4.24848C68.0233 4.1468 67.958 4.09597 67.8854 4.09597C67.8564 4.09597 67.8272 4.11775 67.7983 4.16133C67.7693 4.2049 67.7619 4.25573 67.7765 4.31384L67.9943 5.73V15.5124H66.2514V0.261445Z" })));
}

//# sourceMappingURL=Logo-8772aba7.mjs.map


/***/ }),

/***/ 3652:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ E; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8517);


const s = {
  width: "100%",
  height: "100%",
  aspectRatio: "1",
  objectFit: "contain"
}, E = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function({ src: n, fallbackImgSrc: e }, u) {
  const [c, l] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1), t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => e ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", { src: e, "aria-hidden": !0, style: s }) : null,
    [e]
  );
  return (0,_index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_1__.u)(t, (m) => {
    const a = t.current;
    !a || !m || r.current || (r.current = !0, a?.play()?.catch(() => l(!0)));
  }), !n || c ? d : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "video",
    {
      ref: (0,_index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_1__.m)(u, t),
      src: n,
      style: s,
      muted: !0,
      playsInline: !0,
      disablePictureInPicture: !0,
      disableRemotePlayback: !0,
      tabIndex: -1,
      preload: "true",
      "x-webkit-airplay": "deny",
      "aria-hidden": !0
    }
  );
});

//# sourceMappingURL=VideoIcon-c13b94d3.mjs.map


/***/ }),

/***/ 7610:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ n; },
/* harmony export */   "E": function() { return /* binding */ m; },
/* harmony export */   "u": function() { return /* binding */ l; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);

const m = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(!1);
function l() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(m);
}
var n = /* @__PURE__ */ ((t) => (t[t.xs = 0] = "xs", t[t.sm = 600] = "sm", t[t.md = 900] = "md", t[t.lg = 1024] = "lg", t[t.xl = 1440] = "xl", t))(n || {});

//# sourceMappingURL=app-51178863.mjs.map


/***/ }),

/***/ 8517:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ p; },
/* harmony export */   "c": function() { return /* binding */ a; },
/* harmony export */   "d": function() { return /* binding */ y; },
/* harmony export */   "m": function() { return /* binding */ h; },
/* harmony export */   "u": function() { return /* binding */ g; }
/* harmony export */ });
/* unused harmony exports N, b */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);

const S = () => {
}, E = typeof window > "u" ? react__WEBPACK_IMPORTED_MODULE_0__.useEffect : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;
function a(t) {
  const e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t);
  return E(() => {
    e.current = t;
  }, [t]), e;
}
function p(t) {
  const e = a(t);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((...n) => e.current(...n), [e]);
}
function y(t) {
  const e = a(t);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => e.current, [e]);
}
function g(t, e, n) {
  const r = p(e), s = y(n);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!s?.disabled)
      try {
        const c = t.current;
        if (!c)
          return;
        const o = new IntersectionObserver((f) => {
          f.forEach((i) => {
            r(i.isIntersecting);
          });
        }, s);
        return o.observe(c), () => o.unobserve(c);
      } catch {
        return r(!0), () => r(!1);
      }
  }, [r, s, t]);
}
function h(...t) {
  return (e) => {
    t.forEach((n) => {
      n && (typeof n == "function" ? n(e) : n.current = e);
    });
  };
}

//# sourceMappingURL=index-615eb227.mjs.map


/***/ }),

/***/ 7720:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ p; },
/* harmony export */   "a": function() { return /* binding */ g; },
/* harmony export */   "u": function() { return /* binding */ j; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(403);


const u = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
  isInsideBlock: !1
}), B = "block__content", _ = "block__content--flex", v = "block__content--grid", x = "block__content--limited-width", A = "desktop", T = "desktop--limited-width", G = "debug", r = {
  blockContent: B,
  blockContentFlex: _,
  blockContentGrid: v,
  blockContentLimitedWidth: x,
  desktop: A,
  desktopLimitedWidth: T,
  debug: G
}, R = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(o, d) {
  const {
    children: e,
    limitedWidth: n = !0,
    className: c,
    style: l,
    id: s,
    debug: a,
    itemScope: k = !1,
    itemType: L,
    flex: C
  } = o;
  if (!(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(u).isInsideBlock)
    throw new Error("Content should be only used inside the Block.");
  const f = a && "production" === "development" ? 0 : "";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      ref: d,
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        c,
        r.blockContent,
        f,
        n && r.blockContentLimitedWidth,
        C ? r.blockContentFlex : r.blockContentGrid
      ),
      style: l,
      id: s,
      itemScope: k,
      itemType: L
    },
    e
  );
}), y = "block", w = "block--padding-top-large", W = "desktop", I = "block--padding-top-small", D = "block--padding-top-small--disabled", M = "block--padding-bottom-large", O = "block--padding-bottom-small", i = {
  block: y,
  blockPaddingTopLarge: w,
  desktop: W,
  blockPaddingTopSmall: I,
  blockPaddingTopSmallDisabled: D,
  blockPaddingBottomLarge: M,
  blockPaddingBottomSmall: O
};
var g = /* @__PURE__ */ ((t) => (t.NONE = "NONE", t.SMALL = "SMALL", t.LARGE = "LARGE", t))(g || {});
function p(t) {
  const {
    children: o,
    className: d,
    topPadding: e = "LARGE",
    bottomPadding: n = "LARGE",
    as: c,
    blockRef: l,
    ...s
  } = t, a = c || "div";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    a,
    {
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        i.block,
        F(e),
        K(n),
        d
      ),
      ...s,
      ref: l
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(u.Provider, { value: { isInsideBlock: !0 } }, o)
  );
}
p.Content = R;
p.Padding = g;
function F(t) {
  return t === "LARGE" ? i.blockPaddingTopLarge : t === "SMALL" ? i.blockPaddingTopSmall : "";
}
function K(t) {
  return t === "LARGE" ? i.blockPaddingBottomLarge : t === "SMALL" ? i.blockPaddingBottomSmall : "";
}
function j(t, o, d = {}) {
  const { disabled: e = !1, enableEscKey: n = !0 } = d;
  (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.u)("Escape", o, { disabled: e || !n }), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (e)
      return;
    const c = (l) => {
      const s = l.target;
      t.some(
        (k) => k.current?.contains(s)
      ) || (l.stopPropagation(), o());
    };
    return document.addEventListener("click", c), () => {
      document.removeEventListener("click", c);
    };
  }, [o, t, e, n]);
}

//# sourceMappingURL=useClickOutside-55c64a80.mjs.map


/***/ }),

/***/ 403:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ A; },
/* harmony export */   "t": function() { return /* binding */ j; },
/* harmony export */   "u": function() { return /* binding */ K; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);

function i(t) {
  var o, n, e = "";
  if (typeof t == "string" || typeof t == "number")
    e += t;
  else if (typeof t == "object")
    if (Array.isArray(t))
      for (o = 0; o < t.length; o++)
        t[o] && (n = i(t[o])) && (e && (e += " "), e += n);
    else
      for (o in t)
        t[o] && (e && (e += " "), e += o);
  return e;
}
function A() {
  for (var t, o, n = 0, e = ""; n < arguments.length; )
    (t = arguments[n++]) && (o = i(t)) && (e && (e += " "), e += o);
  return e;
}
const r = "rich-text", d = "hero__text", _ = "mobile", l = "tablet", c = "desktop", p = "button__text-primary", u = "button__title", b = "button__title__map", g = "button__heroTitle", T = "heading__page", h = "heading__section", m = "heading__menu", y = "texts__component_title", f = "texts__component_title--bold", B = "texts__lead_text", L = "page__lead_text", k = "texts__lead_text--bold", C = "texts__paragraph_subtitle", P = "texts__paragraph_subtitle--bold", v = "texts__body_text", S = "texts__body_text--bold", w = "texts__link", H = "texts__caption", M = "texts__caption--bold", D = "page__heading", j = {
  richText: r,
  heroText: d,
  mobile: _,
  tablet: l,
  desktop: c,
  buttonTextPrimary: p,
  buttonTitle: u,
  buttonTitleMap: b,
  buttonHeroTitle: g,
  headingPage: T,
  headingSection: h,
  headingMenu: m,
  textsComponentTitle: y,
  textsComponentTitleBold: f,
  textsLeadText: B,
  pageLeadText: L,
  textsLeadTextBold: k,
  textsParagraphSubtitle: C,
  textsParagraphSubtitleBold: P,
  textsBodyText: v,
  textsBodyTextBold: S,
  textsLink: w,
  textsCaption: H,
  textsCaptionBold: M,
  pageHeading: D
};
function K(t, o, n = {}) {
  const { disabled: e = !1 } = n;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (e)
      return;
    const s = (a) => {
      a.key === t && (a.preventDefault(), o());
    };
    return document.addEventListener("keydown", s), () => {
      document.removeEventListener("keydown", s);
    };
  }, [t, o, e]);
}

//# sourceMappingURL=useKeyDown-88662051.mjs.map


/***/ }),

/***/ 8175:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ O; },
/* harmony export */   "u": function() { return /* binding */ X; }
/* harmony export */ });
/* unused harmony export a */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(403);


function M(l) {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (l)
      return;
    const s = [
      window.document.documentElement,
      window.document.body,
      window.document.getElementById("__next")
    ], a = s.map((o) => {
      const t = {
        overflow: o?.style.overflow || "",
        overflowX: o?.style.overflowX || "",
        overflowY: o?.style.overflowY || ""
      };
      return o && (o.style.overflow = "hidden", o.style.overflowX = "hidden", o.style.overflowY = "hidden"), t;
    });
    return () => {
      s.forEach((o, t) => {
        const e = a[t];
        o && (o.style.overflow = e.overflow, o.style.overflowX = e.overflowX, o.style.overflowY = e.overflowY);
      });
    };
  }, [l]);
}
const C = "modal", E = "modal__content", m = {
  modal: C,
  modalContent: E
};
function O({
  children: l,
  className: s,
  backdropClassName: a,
  backdropStyle: o,
  style: t,
  modalRef: e,
  id: d,
  closeModal: r
}) {
  return M(), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      ref: e,
      id: d,
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(m.modal, a),
      style: o,
      onClick: (n) => {
        n.stopPropagation(), r?.();
      },
      "data-testid": "modal"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        onClick: (n) => n.stopPropagation(),
        className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(m.modalContent, s),
        style: t,
        "data-testid": "modal-content"
      },
      l
    )
  );
}
function X(l = {}) {
  const { onClose: s, onOpen: a, defaultOpen: o = !1 } = l, [, t] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useTransition)(), [e, d] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(o), r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    t(() => {
      d(!0), a?.();
    });
  }, [a]), n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    t(() => {
      d(!1), s?.();
    });
  }, [s]), u = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    () => e ? n() : r(),
    [e, r, n]
  );
  return (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.u)("Escape", n, { disabled: !e }), {
    isModalOpen: e,
    openModal: r,
    closeModal: n,
    toggleModalOpen: u
  };
}

//# sourceMappingURL=useModal-5a548e10.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(6321), __webpack_exec__(5817); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);